import { EditOutlined } from '@ant-design/icons'
import {
  Button,
  Checkbox,
  Col,
  ColorPicker,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  List,
  Menu,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Upload,
} from 'antd'
import MenuItem from 'antd/es/menu/MenuItem'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import productApi from '../../api/product.api'
import programApi from '../../api/program.api'
import { salusS3 } from '../../api/s3.api'
import ProductDetailImageComponent from '../../components/product/ProductDetailImageComponent'
import ProductReviewRefComponent from '../../components/product/ProductReviewRefComponent'
import ProductSetOptionComponent from '../../components/product/ProductSetOptionComponent'
import { userState } from '../../store/user'
import styles from '../../styles/product.module.scss'
import CustomTag from './component/CustomTag'

const ProductRegisterPage = () => {
  const { productId } = useParams()
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const isReUse = productId && location?.search?.includes('template')

  const [product, setProduct] = useState({
    isPurchase: true,
    isShow: true,
    categoryId: '',
    categorySubId: '',
    categoryName: '',
    // brand_commission_rate: 0.0,
    // include_vat: true,
    commissionRate: 30.0,
    cancellationInformation: '',
    cancellationImpossibleInformation: '',
    qualityAssuranceStandardsInformation: '',
    refundIndemnityInformation: '',
    disputeInformation: '',
    topNutrientContent: 0,
    targetGender: 0,
    productTarget: 99,
    // delivery_type: '당일 배송',
    // delivery_due: 1,
    savingPoint: 0,
    savingPointType: 'PERCENT',
    reviewPoint: 0,
    reviewPointType: 'PERCENT',
    reviewImagePoint: 0,
    reviewImagePointType: 'PERCENT',
    nutrientEffect: '',
    nutrientAdditionalIngredient: '',
    // EVENT/PICK 태그 관련 필드
    eventTag: false,
    eventColor: '',
    eventTextColor: '',
    pickTag: false,
    pickColor: '',
    pickTextColor: '',
  })
  const [productDetail, setProductDetail] = useState({})
  const [productOptions, setProductOptions] = useState([
    {
      optionTitle: '1박스 1개월분',
      price1: 0,
      price2: 0,
      discount: 0,
      optionQuantity: 1,
      optionDescription: '',
      notExposed: false,
      maxPurchasableQuantity: 1,
    },
  ])
  const [deleteOption, setDeleteOption] = useState([])
  const [nutrients, setNutrients] = useState({
    is_certify: true,
    status: 1,
  })
  const [nutrientInfo, setNutrientInfo] = useState({
    moisture: '', //수분(g)
    protein: '', //단백질(g)
    fat: '', //지방(g)
    carbohydrate: '', //탄수화물(g)
    total_sugar: '', //총당류(g)
    total_dietary_fiber: '', //총식이섬유(g)
    soluble_dietary_fiber: '', //수용성 식이섬유(g)
    insoluble_dietary_fiber: '', //불용성 식이섬유	(g)
    calcium: '', //칼슘(mg)
    fe: '', //철(mg)
    magnesium: '', //마그네슘(mg)
    perfect_virtue: '', //인(㎎)
    potassium: '', //칼륨(㎎)
    sodium: '', //나트륨(㎎)
    zinc: '', //아연(㎎)
    copper: '', //구리(㎎)
    manganese: '', //망간(㎎)
    selenium: '', //셀레늄(㎍)
    molybdenum: '', //몰리브덴(㎍)
    iodine: '', //요오드(㎍)
    retinol: '', //레티놀(㎍)
    beta_carotene: '', //베타카로틴(㎍)
    vitamin_a: '', //비타민 A(D2+D3)(㎍)
    vitamin_d: '', //비타민 D(D2+D3)(㎍)
    vitamin_e: '', //비타민 E(㎎)
    vitamin_k: '', //비타민 K(㎍)
    vitamin_k1: '', //비타민 K1(㎍)
    vitamin_k2: '', //비타민 K2(㎍)
    vitamin_b: '', //비타민B(mg)
    vitamin_b1: '', //티아민 - 비타민 B1(㎎)
    vitamin_b2: '', //리보플라빈 - 비타민 B2(㎎)
    vitamin_multi: '', //멀티비타민(mg)
    niacin: '', //나이아신(㎎)
    niacin_1: '', //나이아신(㎎ NE)
    niacin_2: '', //나이아신(㎎)
    niacin_3: '', //나이아신(NE)(㎎)
    nicotinic_acid: '', //니코틴산 (㎎)
    nicotinamide: '', //니코틴아마이드(㎎)
    pantothenic_acid: '', //판토텐산(㎎)
    vitamin_b6: '', //비타민 B6(㎎)
    pyridoxine: '', //비타민 B6 - 피리독신(㎎)
    biotin: '', //비오틴(㎍)
    folic_acid: '', //엽산(DFE)(㎍)
    vitamin_b12: '', //비타민 B12(㎍)
    vitamin_c: '', //비타민 C(㎎)
    cholesterol: '', //콜레스테롤(g)
    cholesterol_1: '', //콜레스테롤(㎎)
    total_fatty_acids: '', //총 지방산(g)
    total_essential_fatty_acids: '', //총 필수 지방산(g)
    total_saturated_fatty_acids: '', //총 포화 지방산(g)
    total_saturated_fatty_acids_1: '', //총 포화 지방산(%)
    linoleic_acid: '', //리놀레산(18:2(n-6)c)(㎎)
    alpha_linolenic_acid: '', //알파 리놀렌산(18:3(n-3))(㎎)
    eicosadienoic_acid: '', //에이코사디에노산(20:2(n-6))(㎎)
    omega_3_fatty_acids: '', //오메가 3 지방산(g)
    omega_6_fatty_acids: '', //오메가 6 지방산(g)
    choline: '', //콜린(㎎)
    tryptophan: '', //트립토판(㎎)
    arginine: '', //아르기닌(㎎)
    cysteine: '', //시스테인(㎎)
    taurine: '', //타우린(㎎)
    gamma_linolenic_acid: '', //감마 리놀렌산(18:3(n-6))(㎎)
    arachidonic_acid: '', //아라키돈산(20:4(n-6))(㎎)
    docosahexaenoic_acid: '', //도코사헥사에노산(22:6(n-3))(㎎)
    trans_fatty_acids: '', //트랜스 지방산(g)
    caffeine: '', //카페인
    chrome: '', //크롬(μg)
    guaranteed: '', //보장균수(억CFU)
    lutein: '', //루테인(mg)
    zeaxanthin: '', //지아잔틴
    astaxanthin: '', //아스타잔틴(mg)
    silymarin: '', //실리마린(mg)
    coq10: '', //CoQ10(mg)
    ginsenoside: '', //진세노사이드(mg)
    flavonoids: '', //플라보노이드(mg)
    theanine: '', //테아닌(mg)
    collagen: '', //콜라겐(mg)
    l_lysine: '', //L-라이신
    l_arginine: '', //L-아르기닌(mg)
    inositol: '', //이노시톨(mg)
    octacosanol: '', //옥타코사놀(mg)
    hca: '', //HCA(mg)
    udca: '', //UDCA(mg)
    y_oryzanol: '', //γ-오리자놀
    glucosamine: '', //글루코사민(mg)
    betaglucan: '', //베타글루칸
    brewersyeast: '', //맥주효모(mg)
    oroticacidhydrate: '', //오로트산수화물
    hyaluronic_acid: '', //히알루론산(mg)
    glutamic_acid: '', //폴리감마글루탐산(mg)
    msm: '', //MSM(mg)
    total_anthocyanosides: '', //총 안토시아노사이드(mg)
    alpha_s_1_casein: '', //알파에스1카제인(mg)
    cultured_cells: '', //열처리배양균체(수)
    rosabine: '', //로사빈(mg)
    lauric_acid: '', //쏘팔메토-로르산(mg)
    linolenic_acid: '', //감마리놀렌산(mg)
    catechins: '', //녹차추출물-카테킨(mg)
    lactulose: '', //락추로스(mg)
    γ_oryzanol: '', //감마-오리자놀(mg)
    woman_proba: '', //보장균수(억CFU)
    bcaa: '', //BCAA(mg)
    aloe: '', //안트라퀴논계화합물(mg)
    corosol: '', //코로솔산(mg)
    flavonol: '', //은행잎추출물-플라보놀배당체(mg)
    monacholine: '', //총 모나콜린K(mg)
    dieckol: '', //디엑콜(mg)
    lactoferrin: '', //락토페린(mg)
    glabridin: '', //Glabridin(mg)
    glutathione: '', //글루타치온(mg)
    carnitine: '', //카르니틴(mg)
    enzyme: '', //효소(mg)
    prebiotics: '', //올리고당(mg)
    hyaluron: '', //히알루론산(mg)
    // Niacin: '',			                   	  //나이아신(mg NE)사용
  })
  const [nutrientsAllergy, setNutrientsAllergy] = useState({
    milk: false, //우유
    bean: false, //대두
    sulfurous_acid: false, //아황산
    beef: false, //소고기
    mackerel: false, //고등어
    squid: false, //오징어
    pork: false, //돼지고기
    peanut: false, //땅콩
    wheat: false, //밀
    buckwheat: false, //메밀
    crab: false, //게
    tomato: false, //토마토
    peach: false, //복숭아
    clam: false, //조개류(홍합)
    shrimp: false, //새우
    egg: false, //알류(계란)
    chicken: false, //닭고기
    nuts: false, //견과류
  })
  const [productKpi, setProductKpi] = useState({
    target: 99,
    unit: 0,
  })
  // const [relatedProductList, setRelatedProductList] = useState([])
  const [category1, setCategory1] = useState([])
  const [category2, setCategory2] = useState([])
  const [category3, setCategory3] = useState([])
  const [category4, setCategory4] = useState([])
  const [categoryOption, setCategoryOption] = useState({
    category1: { categoryLevel: 'LARGE', categoryParent: '0' },
    category2: { categoryLevel: 'MEDIUM', categoryParent: '' },
    category3: { categoryLevel: 'SMALL', categoryParent: '' },
    category4: { categoryLevel: 'SUB', categoryParent: '' },
  })
  const [nutrientCategoryList, setNutrientCategoryList] = useState({
    vitamin: [],
    mineral: [],
    nutrition: [],
  })
  const [nutrientSearchOption, setNutrientSearchOption] = useState({
    standardContent: [],
    additionalIngredient: [],
    effect: [],
  })
  const [selectNutrients, setSelectNutrients] = useState([])
  const [sellerList, setSellerList] = useState([])
  const [brandList, setBrandList] = useState([])
  const [productAdditionalEx1Cnt, setProductAdditionalEx1Cnt] = useState(0)
  const [productAdditionalEx2Cnt, setProductAdditionalEx2Cnt] = useState(0)
  const [productAdditionalEx3Cnt, setProductAdditionalEx3Cnt] = useState(0)
  const [productNameCnt, setProductNameCnt] = useState(0)
  const [options, setOptions] = useState({
    // 태그
    exposureTag: [],

    productType: '',
    refProductDetail: false,
    // 의료기기
    approvalNumber: true,
    medicalRatedVoltage: true,
    medicalPowerConsumption: true,

    // 가공식품
    productNutrient: true,

    // 생활화학제품 & 살생물제품
    importer: true,

    cancellationInformation: 1,
    cancellationImpossibleInformation: 1,
    qualityAssuranceStandardsInformation: 1,
    refundIndemnityInformation: 1,
    disputeInformation: 1,

    // 상품속성
    // gender: 0,
    // targetAge: 99,
    // pregnant: false,

    savingPoint: true,
    reviewPoint: true,

    // 기타
    productSeller: 0,
    selectNutrientUnit: '',
  })
  const [productImg, setProductImg] = useState({
    main: {},
    remainder: [],
  })
  const [deletedImageUid, setDeletedImageUid] = useState([])
  const [productDescriptionImg, setProductDescriptionImg] = useState([])
  const [refProductDescriptionImg, setRefProductDescriptionImg] = useState([])
  const [deletedImgCount, setDeletedImgCount] = useState({
    main: 0,
    remainder: 0,
    description: 0,
  })
  // const [productExplainImg, setProductExplainImg] = useState({
  // 	Image: [],
  // });
  const [clickImageUid, setClickImageUid] = useState('')
  const [isExplainProductModalOpen, setIsExplainProductModalOpen] =
    useState(false)
  const [isRelatedProductModalOpen, setIsRelatedProductModalOpen] =
    useState(false)
  const [searchOptions, setSearchOptions] = useState({
    productId: null,
    productMakerName: '',
    productName: '',
    brandName: '',
  })
  const [relatedProduct, setRelatedProduct] = useState({
    recommend_reason: '',
  })
  const [productItemList, setProductItemList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [orderBy, setOrderBy] = useState('desc')
  const [orderType, setOrderType] = useState('createdAt')
  const [isProgramModalVisible, setIsProgramModalVisible] = useState(false)
  const [programOption, setProgramOption] = useState([
    {
      programIncluded: false,
      mappings: [],
    },
  ])
  const [programs, setPrograms] = useState([])
  const [_programs, set_Programs] = useState([])
  const [modalMappingData, setModalMappingData] = useState([])
  const [modalDeletedMappingIds, setModalDeletedMappingIds] = useState([])
  const [currentOptionIndex, setCurrentOptionIndex] = useState(null)
  const [localDeletedMappingIds, setLocalDeletedMappingIds] = useState([])
  const [selectedProgramTypes, setSelectedProgramTypes] = useState([
    { label: '상품', value: 'PRODUCT' },
  ])
  const [optionsLoaded, setOptionsLoaded] = useState(false)

  const [isProductSelectModalVisible, setIsProductSelectModalVisible] =
    useState(false)
  const [selectedReviewProduct, setSelectedReviewProduct] = useState(null)

  // 세트 상품
  const [isSetProductSelectModalVisible, setIsSetProductSelectModalVisible] =
    useState(false)
  const [isSetProduct, setIsSetProduct] = useState([
    {
      isSetProduct: false,
      productSetMappingList: [],
      setProductOriginalPrice: 0,
      setProductPrice: 0,
    },
  ])
  const [customDetailTag, setCustomDetailTag] = useState([
    {
      tagId: null,
      text: '',
      backgroundColor: '',
      textColor: '',
      iconUrl: '',
      productTagType: 'DETAIL',
      isModified: false, // 변경 여부 추적
      originalIconUrl: '', // 원본 이미지 URL 보존
    },
    {
      tagId: null,
      text: '',
      backgroundColor: '',
      textColor: '',
      iconUrl: '',
      productTagType: 'DETAIL',
      isModified: false, // 변경 여부 추적
      originalIconUrl: '', // 원본 이미지 URL 보존
    },
  ])

  // 🔥 CustomTag 상태 관리 함수들
  // - tagIndex: 태그 인덱스 (0 또는 1)
  // - fieldName: 변경할 필드명 (text, backgroundColor, textColor, iconUrl, productTagType)
  // - value: 변경할 값
  // - TODO: isModified 플래그 추가하여 변경 감지
  const handleCustomTagChange = (tagIndex, fieldName, value) => {
    console.log('handleCustomTagChange 호출:', { tagIndex, fieldName, value })
    setCustomDetailTag((prev) => {
      console.log('이전 상태:', prev)
      const newTags = [...prev]
      newTags[tagIndex] = {
        ...newTags[tagIndex],
        [fieldName]: value,
        isModified: true, // 변경됨 표시
      }
      console.log('새로운 상태:', newTags)
      return newTags
    })
  }

  // 🔥 CustomTag 태그 삭제 처리 함수
  // - tagId: 삭제할 태그 ID
  const handleCustomTagDelete = async (tagId) => {
    try {
      console.log('태그 삭제 요청:', tagId)

      // 삭제 확인
      if (window.confirm('이 태그를 삭제하시겠습니까?')) {
        const deleteResult = await productApi.deleteProductTag(tagId)

        if (deleteResult.status === 200) {
          console.log('태그 삭제 성공:', deleteResult)

          // customDetailTag에서 해당 태그 제거
          setCustomDetailTag((prev) => {
            const newTags = prev.filter((tag) => tag.tagId !== tagId)

            // 최대 2개까지 태그를 보여주기 위해 빈 태그 추가
            while (newTags.length < 2) {
              newTags.push({
                tagId: null,
                text: '',
                backgroundColor: '',
                textColor: '',
                iconUrl: '',
                productTagType: 'DETAIL',
                isModified: false,
                originalIconUrl: '',
              })
            }

            return newTags
          })

          alert('태그가 성공적으로 삭제되었습니다.')
        } else {
          console.error('태그 삭제 실패:', deleteResult)
          alert('태그 삭제에 실패했습니다.')
        }
      }
    } catch (error) {
      console.error('태그 삭제 중 에러:', error)
      alert('태그 삭제 중 오류가 발생했습니다.')
    }
  }

  // 🔥 CustomTag 이미지 변경 처리 함수
  // - tagIndex: 태그 인덱스 (0 또는 1)
  // - file: 업로드된 파일 객체
  // - fileList: 전체 파일 리스트
  // - event: 이벤트 객체
  // - type: 변경 타입 ('tagIconUrl')
  // - TODO: isModified 플래그 추가하여 변경 감지
  const handleCustomTagImageChange = (
    tagIndex,
    file,
    fileList,
    event,
    type,
  ) => {
    if (type === 'tagIconUrl') {
      if (file.status === 'removed') {
        console.log('이미지 제거됨')
        handleCustomTagChange(tagIndex, 'iconUrl', null) // null로 설정하여 이미지 없음을 표시
      } else {
        console.log('새 이미지 설정:', file)
        const editFile = {
          uid: file.uid || crypto.randomUUID(),
          name: file.name,
          status: 'done',
          url: URL.createObjectURL(file),
          originFileObj: file, // S3 업로드용
        }
        console.log('생성된 editFile:', editFile)
        // 이미지 변경 시 isModified 플래그 설정
        setCustomDetailTag((prev) => {
          const newTags = [...prev]
          newTags[tagIndex] = {
            ...newTags[tagIndex],
            iconUrl: editFile,
            isModified: true,
          }
          return newTags
        })
      }
    }
  }

  const displayOptions = [
    { label: '판매', value: true },
    { label: '미판매', value: false },
  ]
  const applyOptions = [
    { label: '적용', value: true },
    { label: '미적용', value: false },
  ]
  const exposureOptions = [
    { label: '노출', value: true },
    { label: '미노출', value: false },
  ]
  const exposureInfoOptions = [
    { label: 'BEST', value: 'best' },
    { label: 'NEW', value: 'new' },
    { label: '무료배송', value: 'free_delivery' },
  ]
  const productTypeItems = [
    { label: '의료기기', value: 'MEDICAL_DEVICE' },
    { label: '화장품', value: 'COSMETICS' },
    { label: '가공식품', value: 'PROCESSED_FOOD' },
    { label: '건강기능식품', value: 'HEALTH_FUNCTIONAL_FOOD' },
    { label: '생활화학제품', value: 'LIVING_CHEMICAL_PRODUCTS' },
    { label: '살생물제품', value: 'BIOCIDAL_PRODUCT' },
    { label: '기타', value: 'ETC' },
  ]
  const inputOptions = [
    { label: '직접입력', value: true },
    { label: '해당사항 없음', value: false },
  ]
  const formulationItems = [
    { label: '정제', value: '정제' },
    { label: '작은 정제', value: '작은 정제' },
    { label: '캡슐', value: '캡슐' },
    { label: '작은 캡슐', value: '작은 캡슐' },
    { label: '환', value: '환' },
    { label: '분말', value: '분말' },
    { label: '츄어블', value: '츄어블' },
    { label: '액상', value: '액상' },
    { label: '필름', value: '필름' },
    { label: '혼합', value: '혼합' },
    { label: '젤리', value: '젤리' },
    { label: '발포형', value: '발포형' },
    { label: '스프레이', value: '스프레이' },
  ]
  const genderItems = [
    { label: '성별무관', value: 0 },
    { label: '남성', value: 1 },
    { label: '여성', value: 2 },
  ]
  const targetAgeItems = [
    { label: '0~2세', value: 0 },
    { label: '2~13세', value: 1 },
    { label: '0~13세', value: 2 },
    { label: '청소년', value: 3 },
    { label: '청소년부터 성인까지', value: 4 },
    { label: '성인', value: 5 },
    { label: '전 연령', value: 6 },
    // {label: "성인 여성", value: 7},
    // {label: "성인 남성", value: 8},
    { label: '50세 이상', value: 9 },
    // {label: "50세 이상 남성", value: 10},
    // {label: "50세 이상 여성", value: 11},
    // {label: "임산부", value: 12},
    { label: '추전 정보 없음', value: 99 },
  ]
  const forPersonUnitItems = [
    { label: 'g', value: 'g' },
    { label: 'ml', value: 'ml' },
    { label: '듀얼포', value: '듀얼포' },
    { label: '방울', value: '방울' },
    { label: '병', value: '병' },
    { label: '분사', value: '분사' },
    { label: '정', value: '정' },
    { label: '정제', value: '정제' },
    { label: '캡슐', value: '캡슐' },
    { label: '포', value: '포' },
    { label: '회', value: '회' },
  ]
  const allergyItems = [
    { label: '우유', value: 'milk' },
    { label: '대두', value: 'bean' },
    { label: '아황산', value: 'sulfurous_acid' },
    { label: '소고기', value: 'beef' },
    { label: '고등어', value: 'mackerel' },
    { label: '오징어', value: 'squid' },
    { label: '돼지고기', value: 'pork' },
    { label: '땅콩', value: 'peanut' },
    { label: '밀', value: 'wheat' },
    { label: '메밀', value: 'buckwheat' },
    { label: '게', value: 'crab' },
    { label: '토마토', value: 'tomato' },
    { label: '복숭아', value: 'peach' },
    { label: '조개류(홍합)', value: 'clam' },
    { label: '새우', value: 'shrimp' },
    { label: '알류(계란)', value: 'egg' },
    { label: '닭고기', value: 'chicken' },
    { label: '견과류', value: 'nuts' },
  ]
  const courierCompanyItems = [
    { label: '한진택배', value: '한진택배' },
    { label: 'CJ대한통운', value: 'CJ대한통운' },
    { label: '우체국택배', value: '우체국택배' },
    { label: '롯데택배', value: '롯데택배' },
    { label: '로젠택배', value: '로젠택배' },
    { label: '홈픽', value: '홈픽' },
    { label: 'GS25 편의점택배(CVSnet)', value: 'GS25 편의점택배(CVSnet)' },
    { label: 'CU 편의점택배', value: 'CU 편의점택배' },
    { label: '경동택배', value: '경동택배' },
    { label: '대신택배', value: '대신택배' },
    { label: '일양로지스', value: '일양로지스' },
    { label: '합동택배', value: '합동택배' },
    { label: '건영택배', value: '건영택배' },
    { label: '천일택배', value: '천일택배' },
    { label: '한의사랑택배', value: '한의사랑택배' },
    { label: 'EMS', value: 'EMS' },
    { label: 'TNT Express', value: 'TNT Express' },
    { label: 'UPS', value: 'UPS' },
    { label: 'Fedex', value: 'Fedex' },
    { label: 'USPS', value: 'USPS' },
    { label: '굿투럭', value: '굿투럭' },
    { label: '우리택배(구 호남택배)', value: '우리택배(구 호남택배)' },
    { label: 'SLX택배', value: 'SLX택배' },
    { label: '우리한방택배', value: '우리한방택배' },
    { label: 'Cway Express', value: 'Cway Express' },
    { label: '성원글로벌카고', value: '성원글로벌카고' },
    { label: 'DHL', value: 'DHL' },
  ]
  // const deliveryDueItems = [
  //   { label: '1일', value: 1 },
  //   { label: '2일', value: 2 },
  //   { label: '3일', value: 3 },
  //   { label: '4일', value: 4 },
  //   { label: '5일', value: 5 },
  //   { label: '6일', value: 6 },
  //   { label: '7일', value: 7 },
  // ]
  // const deliveryTypeItems = [
  //   { label: '당일 배송', value: '당일 배송' },
  //   { label: '국내 배송', value: '국내 배송' },
  //   { label: '브랜드사 배송', value: '브랜드사 배송' },
  //   { label: '당영한 무료배송', value: '당영한 무료배송' },
  // ]
  const usabilityOptions = [
    { label: '가능', value: true },
    { label: '불가능', value: false },
  ]
  const pointUseOptions = [
    { label: '허용', value: true },
    { label: '미허용', value: false },
  ]
  const paymentsOptions = [
    { label: '지급', value: true },
    { label: '미지급', value: false },
  ]
  const pointBenefitUnits = [
    { label: '원', value: 'WON' },
    { label: '%', value: 'PERCENT' },
  ]
  const programItems = [
    { label: '포함', value: 'true' },
    { label: '미포함', value: 'false' },
  ]
  // const rowSelection = {
  //   type: 'radio',
  //   selectedRowKeys,
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRowKeys(selectedRowKeys)
  //     setSelectedRows(selectedRows)
  //   },
  // }
  // const columns = [
  //   {
  //     title: '상품번호',
  //     width: 65,
  //     dataIndex: 'product_id',
  //     key: 'product_id',
  //     ellipsis: true,
  //     fixed: 'left',
  //     // sorter: (a, b) => {},
  //   },
  //   {
  //     title: '카테고리',
  //     width: 80,
  //     dataIndex: 'product_category_name',
  //     key: 'product_category_name',
  //     ellipsis: true,
  //     render: (value) => {
  //       if (value === '') {
  //         return <span>-</span>
  //       } else {
  //         return value
  //       }
  //     },
  //   },
  //   {
  //     title: '브랜드명',
  //     width: 130,
  //     dataIndex: 'product_brand_name',
  //     key: 'product_brand_name',
  //     ellipsis: true,
  //   },
  //   {
  //     title: '상품명',
  //     width: 150,
  //     dataIndex: 'product_name',
  //     key: 'product_name',
  //     ellipsis: true,
  //   },
  // ]

  useEffect(() => {
    getNutrientList()
    getSellerList()
    if (productId) {
      getProductInfo()
      getProductTag(productId)
    } else {
      getCategoryList(categoryOption.category1)
    }
  }, [productId])

  useEffect(() => {
    if (options.productSeller !== 0) {
      getBrandList()
    }
  }, [options.productSeller])

  useEffect(() => {
    readProductList()
  }, [orderType, orderBy])
  const getCategoryList = async (param) => {
    setIsLoading(true)
    try {
      const res = await productApi.readCategoryList(param)
      if (res.data.code === 200) {
        if (param.categoryLevel === 'LARGE') {
          setCategory1(res.data.result)
          setCategory2([])
          setCategory3([])
          setCategory4([])
        } else if (param.categoryLevel === 'MEDIUM') {
          setCategory2(res.data.result)
          setCategory3([])
          setCategory4([])
        } else if (param.categoryLevel === 'SMALL') {
          setCategory3(res.data.result)
          setCategory4([])
        } else if (param.categoryLevel === 'SUB') {
          setCategory4(res.data.result)
        }
      } else {
        alert('정상적인 요청이 아닙니다.')
        console.log('getCategoryList read res = ', res.data.code)
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getCategoryList read error', error)
    }
  }

  const getNutrientSearchOption = async (nutrientsId) => {
    setIsLoading(true)
    try {
      const param = {
        nutrientsId: nutrientsId,
      }
      const res = await productApi.readNutrientSearchOption(param, user.id)
      if (res.data.code === 200) {
        setNutrientSearchOption({
          ...nutrientSearchOption,
          standardContent: res.data.result.nutrientStandardContentList,
          additionalIngredient:
            res.data.result.nutrientAdditionalIngredientList,
          effect: res.data.result.nutrientEffectList,
        })
      } else {
        throw `선택한 카테고리에 해당하는 검색 조건을 가져오기 못했습니다. 다시 시도해주시길 바랍니다.`
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getNutrientSearchOption read error', error)
      alert(error)
    }
  }

  const getNutrientList = async () => {
    setIsLoading(true)
    try {
      const res = await productApi.readNutrientList(user.id)
      if (res.data.code === 200) {
        setNutrientCategoryList(res.data.result)
      } else {
        alert('정상적인 요청이 아닙니다.')
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getNutrientList read error', error)
    }
  }

  const getSellerList = async () => {
    setIsLoading(true)
    try {
      const res = await productApi.readSellerList(user.id)
      if (res.data.code === 200) {
        setSellerList(res.data.result)
      } else {
        alert('정상적인 요청이 아닙니다.')
        console.log('getSellerList read res = ', res.data.code)
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getSellerList read error', error)
    }
  }

  const getBrandList = async () => {
    setIsLoading(true)
    try {
      const param = {
        sellerId: options.productSeller,
      }
      const res = await productApi.readBrandList(param, user.id)
      if (res.data.code === 200) {
        setBrandList(res.data.result)
      } else {
        alert('정상적인 요청이 아닙니다.')
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getBrandList read error', error)
    }
  }

  const getProductInfo = async () => {
    setIsLoading(true)
    try {
      const categoryListRes = await productApi.readAllCategoryList()
      const NutrientsListRes = await productApi.readNutrientList(user.id)
      const res = await productApi.readProduct(
        { productId: productId },
        user.id,
      )
      console.log('res', res)

      if (
        res.data.code === 200 &&
        categoryListRes.data.code === 200 &&
        NutrientsListRes.data.code === 200
      ) {
        setProductInfo(
          res.data.result,
          categoryListRes.data.result,
          NutrientsListRes.data.result,
        )
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getProductInfo read error', error)
    }
  }

  const getProductTag = async (productId) => {
    setIsLoading(true)
    try {
      const res = await productApi.getProductTag(productId)
      // console.log('getProductTag res', res)
      if (res.status === 200) {
        // 🔥 태그 초기화 로직 추가
        // - 기존 태그 정보 조회하여 originalIconUrl 보존
        // - isModified = false로 초기화
        // - 태그 데이터 구조: { tagId, text, backgroundColor, textColor, iconUrl, productTagType, isModified, originalIconUrl }
        // - API 응답: { productTags: [{ tagId, text, textColor, backgroundColor, iconUrl, productTagType }] }
        if (res.data && res.data.productTags) {
          initializeTags(res.data.productTags)
        } else {
          // productTags가 없으면 빈 태그 2개로 초기화
          initializeTags([])
        }
      } else {
        alert('정상적인 요청이 아닙니다. getProductTag')
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getProductTag read error', error)
    }
  }

  // 🔥 태그 초기화 함수 (수정 시 기존 태그 정보 설정)
  // - productTags: API에서 받아온 기존 태그 정보
  // - API 응답 스펙: { tagId, text, textColor, backgroundColor, iconUrl, productTagType }
  // - 내부 상태: { tagId, text, backgroundColor, textColor, iconUrl, productTagType, isModified, originalIconUrl }
  // - 최대 2개까지 태그 등록 가능하도록 기존 태그 + 빈 태그 조합으로 설정
  const initializeTags = (productTags) => {
    if (productTags && productTags.length > 0) {
      // 기존 태그들을 내부 상태 구조로 변환
      const existingTags = productTags.map((tag) => ({
        tagId: tag.tagId,
        text: tag.text || '',
        backgroundColor: tag.backgroundColor || '',
        textColor: tag.textColor || '',
        iconUrl: tag.iconUrl || '',
        productTagType: tag.productTagType || 'DETAIL',
        isModified: false, // 수정 여부 초기화
        originalIconUrl: tag.iconUrl || '', // 원본 URL 보존
      }))

      // 최대 2개까지 태그를 보여주기 위해 빈 태그 추가
      const initializedTags = [...existingTags]

      // 기존 태그가 1개면 빈 태그 1개 추가, 2개면 그대로 유지
      while (initializedTags.length < 2) {
        initializedTags.push({
          tagId: null,
          text: '',
          backgroundColor: '',
          textColor: '',
          iconUrl: '',
          productTagType: 'DETAIL',
          isModified: false,
          originalIconUrl: '',
        })
      }

      setCustomDetailTag(initializedTags)
      console.log('태그 초기화 완료:', initializedTags)
    } else {
      // 기존 태그가 없으면 빈 태그 2개로 초기화
      setCustomDetailTag([
        {
          tagId: null,
          text: '',
          backgroundColor: '',
          textColor: '',
          iconUrl: '',
          productTagType: 'DETAIL',
          isModified: false,
          originalIconUrl: '',
        },
        {
          tagId: null,
          text: '',
          backgroundColor: '',
          textColor: '',
          iconUrl: '',
          productTagType: 'DETAIL',
          isModified: false,
          originalIconUrl: '',
        },
      ])
    }
  }

  // 🔥 태그 이미지 S3 업로드 함수
  // - productId: 상품 ID
  // - 반환값: 업로드 결과 배열 [{ tagIndex, success, s3Url, error?, deleted?, unchanged? }]
  const uploadTagImages = async (productId) => {
    const uploadResults = []

    for (let i = 0; i < customDetailTag.length; i++) {
      const tag = customDetailTag[i]
      console.log(`태그 ${i} 이미지 처리:`, {
        iconUrl: tag.iconUrl,
        originalIconUrl: tag.originalIconUrl,
        isModified: tag.isModified,
      })

      if (tag.iconUrl && tag.iconUrl.originFileObj) {
        // 새로 업로드된 이미지 (사진 변경)
        console.log(`태그 ${i} 새 이미지 업로드:`, tag.iconUrl.name)

        try {
          const uploadResult = await s3UploadTag(
            tag.iconUrl.originFileObj,
            i + 1, // idx (1부터 시작)
            productId,
            'DETAIL', // type
          )

          if (uploadResult) {
            // 업로드 성공 시 S3 URL로 교체 - 원본 파일 확장자 유지
            const fileExtension = tag.iconUrl.name.split('.').pop() || 'jpg'
            const s3Url = `https://sugarcoach-assets.s3.ap-northeast-2.amazonaws.com/images/product/tag/DETAIL/${productId}_tag_${
              i + 1
            }.${fileExtension}`
            uploadResults.push({
              tagIndex: i,
              success: true,
              s3Url: s3Url,
              changed: true, // 변경됨 표시
            })
            console.log(`태그 ${i} 이미지 업로드 성공:`, s3Url)
          } else {
            uploadResults.push({
              tagIndex: i,
              success: false,
              error: 'S3 업로드 실패',
            })
            console.error(`태그 ${i} S3 업로드 실패`)
          }
        } catch (error) {
          console.error(`태그 ${i} 이미지 업로드 에러:`, error)
          uploadResults.push({
            tagIndex: i,
            success: false,
            error: error.message,
          })
        }
      } else if (tag.iconUrl === null) {
        // 이미지가 삭제된 경우 (사진 삭제)
        console.log(`태그 ${i} 이미지 삭제됨`)
        uploadResults.push({
          tagIndex: i,
          success: true,
          s3Url: null, // null로 표시하여 이미지 없음을 나타냄
          deleted: true,
        })
      } else if (tag.originalIconUrl && tag.originalIconUrl.trim() !== '') {
        // 기존 이미지가 있고 변경되지 않음 (사진 유지)
        console.log(`태그 ${i} 기존 이미지 유지:`, tag.originalIconUrl)
        uploadResults.push({
          tagIndex: i,
          success: true,
          s3Url: tag.originalIconUrl,
          unchanged: true,
        })
      } else {
        // 이미지가 없는 경우 (처음부터 없음)
        console.log(`태그 ${i} 이미지 없음`)
        uploadResults.push({
          tagIndex: i,
          success: true,
          s3Url: '',
          unchanged: true,
        })
      }
    }

    console.log('이미지 업로드 결과:', uploadResults)
    return uploadResults
  }

  // 🔥 태그 생성/수정 처리 함수
  // - productId: 상품 ID
  // - isModified: 수정 모드 여부 (true: 수정, false: 생성)
  const processTags = async (productId, isModified) => {
    console.log('processTags 호출:', { productId, isModified })

    try {
      // 1. 이미지 업로드 처리
      const uploadResults = await uploadTagImages(productId)

      // 2. 업로드 실패한 태그가 있는지 확인
      const failedUploads = uploadResults.filter((result) => !result.success)
      if (failedUploads.length > 0) {
        console.error('이미지 업로드 실패:', failedUploads)
        throw new Error('태그 이미지 업로드에 실패했습니다.')
      }

      // 3. 태그 데이터 준비 (API 스펙에 맞게 변환)
      console.log('customDetailTag 상태:', customDetailTag)

      const tagData = customDetailTag
        .map((tag, index) => {
          console.log(`태그 ${index} 처리 중:`, tag)
          const uploadResult = uploadResults.find(
            (result) => result.tagIndex === index,
          )
          console.log(`태그 ${index} uploadResult:`, uploadResult)

          if (isModified) {
            // 수정 시: 기존 태그는 수정, 새 태그는 생성
            if (tag.tagId) {
              // 기존 태그 수정 로직
              const mappedTag = {
                tagId: tag.tagId, // 기존 태그 ID
                tagText: tag.text,
                tagTextColor: tag.textColor,
                tagBackgroundColor: tag.backgroundColor,
              }

              // iconUrl 처리: 변경/삭제/유지에 따른 처리
              if (uploadResult?.deleted) {
                // 이미지가 삭제된 경우 - tagIconUrl 필드를 아예 제외
                console.log(
                  `태그 ${index} 이미지 삭제됨 - tagIconUrl 필드 제외`,
                )
              } else if (uploadResult?.changed && uploadResult?.s3Url) {
                // 새로 업로드된 이미지 (변경됨)
                console.log(`태그 ${index} 새 이미지 설정:`, uploadResult.s3Url)
                mappedTag.tagIconUrl = uploadResult.s3Url
              } else if (
                uploadResult?.unchanged &&
                uploadResult?.s3Url &&
                uploadResult.s3Url.trim() !== ''
              ) {
                // 기존 이미지 유지 (변경되지 않음)
                console.log(
                  `태그 ${index} 기존 이미지 유지:`,
                  uploadResult.s3Url,
                )
                mappedTag.tagIconUrl = uploadResult.s3Url
              }
              // 이미지가 없는 경우는 tagIconUrl 필드를 아예 추가하지 않음

              console.log(`태그 ${index} 매핑 결과 (수정):`, mappedTag)
              return mappedTag
            } else if (tag.text && tag.text.trim() !== '') {
              // 새 태그 생성 로직 (수정 모드에서도)
              const mappedTag = {
                tagText: tag.text,
                tagTextColor: tag.textColor,
                tagBackgroundColor: tag.backgroundColor,
                tagType: tag.productTagType,
              }

              // iconUrl 처리: 새로 업로드된 이미지만 포함
              if (uploadResult?.s3Url) {
                mappedTag.tagIconUrl = uploadResult.s3Url
              }
              // 이미지가 없는 경우는 tagIconUrl 필드를 아예 추가하지 않음

              console.log(`태그 ${index} 매핑 결과 (생성):`, mappedTag)
              return mappedTag
            } else {
              console.log(`태그 ${index}는 내용이 없어서 제외됨`)
            }
          } else {
            // 생성 시 스펙 - 내용이 있는 태그만 포함
            if (tag.text && tag.text.trim() !== '') {
              const mappedTag = {
                tagText: tag.text,
                tagTextColor: tag.textColor,
                tagBackgroundColor: tag.backgroundColor,
                tagType: tag.productTagType,
              }

              // iconUrl 처리: 변경/삭제/유지에 따른 처리
              if (uploadResult?.deleted) {
                // 이미지가 삭제된 경우 - tagIconUrl 필드를 아예 제외
                console.log(
                  `태그 ${index} 이미지 삭제됨 - tagIconUrl 필드 제외`,
                )
              } else if (uploadResult?.changed && uploadResult?.s3Url) {
                // 새로 업로드된 이미지 (변경됨)
                console.log(`태그 ${index} 새 이미지 설정:`, uploadResult.s3Url)
                mappedTag.tagIconUrl = uploadResult.s3Url
              } else if (
                uploadResult?.unchanged &&
                uploadResult?.s3Url &&
                uploadResult.s3Url.trim() !== ''
              ) {
                // 기존 이미지 유지 (변경되지 않음)
                console.log(
                  `태그 ${index} 기존 이미지 유지:`,
                  uploadResult.s3Url,
                )
                mappedTag.tagIconUrl = uploadResult.s3Url
              }
              // 이미지가 없는 경우는 tagIconUrl 필드를 아예 추가하지 않음

              console.log(`태그 ${index} 매핑 결과:`, mappedTag)
              return mappedTag
            } else {
              console.log(`태그 ${index}는 텍스트가 없어서 제외됨`)
            }
          }
          return null // 빈 태그는 null 반환
        })
        .filter((tag) => tag !== null) // null인 태그 제외

      console.log('준비된 태그 데이터:', tagData)
      console.log('API 호출 모드:', isModified ? '수정' : '생성')
      if (isModified) {
        console.log('수정 시 전달할 데이터:', {
          userId: user.id ?? 1,
          productTags: tagData,
        })
      } else {
        console.log('생성 시 전달할 데이터:', {
          userId: user.id ?? 1,
          productId,
          productTags: tagData,
        })
      }

      // 4. API 호출
      if (isModified) {
        // 수정 모드: 기존 태그는 수정, 새 태그는 생성
        console.log('수정 모드 - tagData:', tagData)

        // 기존 태그와 새 태그 분리
        const existingTags = tagData.filter((tag) => tag.tagId)
        const newTags = tagData.filter((tag) => !tag.tagId)

        console.log('기존 태그 (수정):', existingTags)
        console.log('새 태그 (생성):', newTags)

        let results = []

        // 1. 기존 태그 수정
        if (existingTags.length > 0) {
          const updateData = {
            userId: user.id ?? 1,
            productTags: existingTags,
          }
          console.log('기존 태그 수정 API 호출:', updateData)

          const updateResult = await productApi.editProductTag(updateData)
          console.log('기존 태그 수정 결과:', updateResult)
          results.push({ type: 'update', result: updateResult })
        }

        // 2. 새 태그 생성
        if (newTags.length > 0) {
          const createData = {
            userId: user.id ?? 1,
            productId: productId,
            productTags: newTags,
          }
          console.log('새 태그 생성 API 호출:', createData)

          const createResult = await productApi.createProductTag(createData)
          console.log('새 태그 생성 결과:', createResult)
          results.push({ type: 'create', result: createResult })
        }

        console.log('수정 모드 전체 결과:', results)
        return results
      } else {
        // 생성 API 호출 - { userId, productId, productTags: [...] } 구조로 전달
        const createData = {
          userId: user.id ?? 1,
          productId: productId,
          productTags: tagData,
        }
        const createResult = await productApi.createProductTag(createData)
        console.log('태그 생성 결과:', createResult)
        return createResult
      }
    } catch (error) {
      console.error('태그 처리 중 에러:', error)
      alert('태그 처리 중 에러가 발생했습니다.')
      throw error
    }
  }

  const readProductList = async (type = '') => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          productId: null,
          productMakerName: '',
          productName: '',
          brandName: '',
          orderType: 'createdAt',
          orderBy: 'desc',
        }
      } else {
        param = {
          ...searchOptions,
          orderType: orderType,
          orderBy: orderBy,
        }
      }
      const res = await productApi.readProductListAll(param, user.id)
      if (res.data.code === 200) {
        setProductItemList(res.data.result)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        alert('정상적인 요청이 아닙니다.')
        console.log('readProductList read res = ', res.data.code)
      }
    } catch (error) {
      setIsLoading(false)
      console.log('readProductList read error', error)
    }
  }
  const s3Upload = async (file, idx, productId, name) => {
    console.log('file = ', file)

    // AntD Upload(originFileObj) 또는 일반 File 둘 다 처리
    const realFile = file?.originFileObj ?? file
    if (!realFile) {
      console.error('s3Upload: 유효하지 않은 파일입니다.', file)
      return false
    }

    const currIdx = `${idx}`
    let s3Path = ''
    if (name === 'main') {
      s3Path = `images/product/main/${productId}.jpg`
    } else if (name === 'additional') {
      s3Path = `images/product/addition/${productId}_addition_${currIdx}.jpg`
    } else {
      // description 또는 기타 용도
      s3Path = `images/product/description/${productId}_detail_${currIdx}.jpg`
    }

    const params = {
      Key: s3Path,
      Body: realFile,
      ContentType: realFile.type,
    }

    try {
      const data = await salusS3.putObject(params).promise()
      // utils/s3.js 기준: { success: true } 구조
      return data?.success === true
    } catch (e) {
      console.error('s3Upload error:', e)
      return false
    }
  }

  // 🔥 태그 이미지 S3 업로드 함수
  // - file: 업로드할 파일 객체
  // - idx: 태그 인덱스 (1부터 시작)
  // - productId: 상품 ID
  // - type: 태그 타입 (예: 'DETAIL')
  // - S3 경로: images/product/tag/{type}/{productId}_tag_{idx}.{확장자}
  const s3UploadTag = async (file, idx, productId, type) => {
    // AntD Upload(originFileObj) 또는 일반 File 둘 다 처리
    const realFile = file?.originFileObj ?? file
    if (!realFile) {
      console.error('s3UploadTag: 유효하지 않은 파일입니다.', file)
      return false
    }

    // 원본 파일 확장자 추출
    const fileName = realFile.name || 'tag-image.jpg'
    const fileExtension = fileName.split('.').pop() || 'jpg'
    const s3Path = `images/product/tag/${type}/${productId}_tag_${idx}.${fileExtension}`

    console.log(
      `S3 업로드 경로: ${s3Path}, 파일명: ${fileName}, 확장자: ${fileExtension}`,
    )

    const params = {
      Key: s3Path,
      Body: realFile,
      ContentType: realFile.type || 'image/jpeg',
    }

    try {
      const data = await salusS3.putObject(params).promise()
      return data?.success === true
    } catch (e) {
      console.error('s3UploadTag error:', e)
      return false
    }
  }

  //  aws > Blob > File
  async function urlToFile(url, filename, mimeType) {
    const res = await fetch(url)
    const blob = await res.blob()
    return new File([blob], filename, { type: mimeType })
  }

  const s3DeleteList = async (productId, name) => {
    let deleteList = [] // 초기화

    if (name === 'additional') {
      const deleteArray = Array.from(
        { length: deletedImgCount.remainder },
        (value, i) => i + 1,
      )
      deleteList = deleteArray?.map((deleteIdx) => {
        const s3Path = `images/product/addition/${productId}_addition_${deleteIdx}.jpg`
        return { Key: s3Path }
      })
      console.log(deleteList)
    } else {
      const deleteArray = Array.from(
        { length: deletedImageUid.length },
        (value, i) => i + 1,
      )
      deleteList = deleteArray?.map((deleteIdx) => {
        const s3Path = `images/product/description/${productId}_detail_${deleteIdx}.jpg`
        return { Key: s3Path }
      })
      console.log(deleteList)
    }

    if (deleteList.length === 0) {
      console.log('삭제할 이미지가 없습니다.')
      return { success: false, message: '삭제할 이미지가 없습니다.' }
    }

    const deleteParams = {
      Delete: {
        Objects: deleteList,
        Quiet: false,
      },
    }

    try {
      const data = await salusS3.deleteObjects(deleteParams).promise()
      return data?.success === true
    } catch (err) {
      console.log('s3DeleteList error:', err)
      return false
    }
  }

  const handleDeletedImageUid = (uid) => {
    setDeletedImageUid([...deletedImageUid, ...uid])
  }

  const s3Delete = async (productId, deleteIdx) => {
    const deleteParams = {
      Key: `images/product/description/${productId}_detail_${deleteIdx}.jpg`,
    }

    try {
      const data = await salusS3.deleteObject(deleteParams).promise()
      return data?.success === true
    } catch (e) {
      console.error('s3Delete error:', e)
      return false
    }
  }

  const s3CopyForTemplate = async (oldPath, newPath) => {
    const params = {
      CopySource: `${process.env.REACT_APP_S3_BUCKETNAME}/${oldPath}`,
      Key: newPath,
    }

    try {
      const data = await salusS3.copyObject(params).promise()
      return data?.success === true
    } catch (err) {
      console.error('s3CopyForTemplate error:', err)
      return false
    }
  }

  const s3Copy = async (refIdx, newIdx, productId) => {
    const currIdx = `${refIdx + 1}`
    const changeIdx = `${newIdx + 1}`
    const s3Path = `/images/product/description/${productId}_detail_${currIdx}.jpg`

    const copyParams = {
      CopySource: process.env.REACT_APP_S3_BUCKETNAME + s3Path,
      Key: `images/product/description/${productId}_detail_${changeIdx}-temp.jpg`,
    }

    const deleteParams = {
      Key: `images/product/description/${productId}_detail_${currIdx}.jpg`,
    }

    try {
      const copyRes = await salusS3.copyObject(copyParams).promise()
      const deleteRes = await salusS3.deleteObject(deleteParams).promise()
      return copyRes?.success === true && deleteRes?.success === true
    } catch (err) {
      console.error('s3Copy error:', err)
      return false
    }
  }

  const s3ReCopy = async (newIdx, productId) => {
    const changeIdx = `${newIdx + 1}`
    const s3Path = `/images/product/description/${productId}_detail_${changeIdx}-temp.jpg`

    const copyParams = {
      CopySource: process.env.REACT_APP_S3_BUCKETNAME + s3Path,
      Key: `images/product/description/${productId}_detail_${changeIdx}.jpg`,
    }

    const deleteParams = {
      Key: `images/product/description/${productId}_detail_${changeIdx}-temp.jpg`,
    }

    try {
      const copyRes = await salusS3.copyObject(copyParams).promise()
      const deleteRes = await salusS3.deleteObject(deleteParams).promise()
      return copyRes?.success === true && deleteRes?.success === true
    } catch (err) {
      console.error('s3ReCopy error:', err)
      return false
    }
  }

  const saveProduct = async () => {
    const valid = validation()
    if (valid) {
      let swalResult = true
      if (user.role === 'super_admin') {
        const swalText = `${
          product.brandName ? `[${product.brandName}] ` : ''
        }${
          product.productName
        } 의\n포인트 정책은 아래와 같습니다.\n구매 확정: ${
          options.savingPoint
            ? `${product.savingPoint}${
                product.savingPointType === 'WON' ? '원' : '%'
              } 지급`
            : '미지급'
        }\n리뷰 작성: ${
          options.reviewPoint
            ? `\n텍스트 리뷰 ${product.reviewPoint}${
                product.reviewPointType === 'WON' ? '원' : '%'
              } / 이미지 첨부 ${product.reviewImagePoint}${
                product.reviewImagePointType === 'WON' ? '원' : '%'
              } 지급`
            : '미지급'
        }${productId ? '수정' : '등록'}하시겠습니까?`
        swalResult = await Swal.fire({
          title: swalText,
          customClass: 'custom-alert',
          confirmButtonColor: '#117ffa',
          confirmButtonText: '확인',
          showCancelButton: true,
          cancelButtonText: '돌아가기',
        }).then(async ({ isConfirmed }) => {
          return isConfirmed
        })
      }
      if (swalResult) {
        setIsLoading(true)
        try {
          let addProduct = {
            descriptionImageNum: productDescriptionImg?.length,
            additionalImageNum: productImg.remainder?.length,
          }
          let addProductDetail = {}
          let addProductOption = []
          // let addProductKpi = {}
          for (const key in options) {
            if (
              key === 'approvalNumber' ||
              key === 'medicalRatedVoltage' ||
              key === 'medicalPowerConsumption' ||
              key === 'productNutrient' ||
              key === 'importer'
            ) {
              if (!options[key]) {
                addProductDetail[key] = '해당사항 없음'
              }
            } else if (
              key === 'cancellationInformation' ||
              key === 'cancellationImpossibleInformation' ||
              key === 'qualityAssuranceStandardsInformation' ||
              key === 'refundIndemnityInformation' ||
              key === 'disputeInformation'
            ) {
              if (options[key] === 1) {
                switch (key) {
                  case 'cancellationInformation':
                    addProduct[key] =
                      '전자상거래등에서의소비자보호에관한법률 등에 의한 제품의 하자 또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가 부담합니다.'
                    break
                  case 'cancellationImpossibleInformation':
                    addProduct[key] =
                      '전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에 준하는 것으로 인정되는 경우 청약철회가 제한될 수 있습니다.'
                    break
                  case 'qualityAssuranceStandardsInformation':
                    addProduct[key] =
                      '소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.'
                    break
                  case 'refundIndemnityInformation':
                    addProduct[key] =
                      '주문취소 및 대금의 환불은 당신의 영양제 마이페이지에서 신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한 법률에 따라 소비자의 청약철회 후 판매자가 재화 등을 반환 받은 날로부터 3영업일 이내에 지급받은 대금의 환급을 정당한 사유 없이 지연하는 때에는 소비자는 지연기간에 대해서 연 15%의 지연배상금을 판매자에게 청구할 수 있습니다.'
                    break
                  case 'disputeInformation':
                    addProduct[key] =
                      '소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.'
                    break
                }
              } else if (options[key] === 2) {
                addProduct[key] = '상품상세 참조'
              }
            } else if (key === 'savingPoint' || key === 'reviewPoint') {
              if (!options[key]) {
                addProduct[key] = 0
              }
            }
          }
          if (
            product.productType === 'PROCESSED_FOOD' ||
            product.productType === 'HEALTH_FUNCTIONAL_FOOD'
          ) {
            if (
              !Object.prototype.hasOwnProperty.call(
                productDetail,
                'isGeneticModification',
              )
            ) {
              addProductDetail['isGeneticModification'] = false
            }
            if (
              !Object.prototype.hasOwnProperty.call(productDetail, 'isImported')
            ) {
              addProductDetail['isImported'] = false
            }
          }
          console.log('saveProduct :: productOptions = ', productOptions)
          console.log('modalMappingData = ', modalMappingData)
          console.log('modalDeletedMappingIds = ', modalDeletedMappingIds)
          for (const option of productOptions) {
            if (
              option.optionTitle !== null &&
              option.optionTitle !== '' &&
              option.price1 !== '' &&
              option.price1 !== '0' &&
              option.discount !== '' &&
              option.price2 !== ''
            ) {
              // id도 추가
              const { notExposed, id, ...filteredData } = option
              filteredData['isShow'] = !notExposed
              if (id !== undefined) {
                filteredData['id'] = id
              }

              // ✅ 매핑 정보와 삭제 ID 처리
              const optionIndex = productOptions.indexOf(option)
              const program = programOption[optionIndex]
              const mappings = program?.mappings || []
              const hasMappings = mappings?.length > 0
              // console.log('program', program)

              // 타입 설정
              const programType = selectedProgramTypes[optionIndex]?.value
              if (
                !hasMappings &&
                (programType === 'PROGRAM' ||
                  programType === 'PROGRAM_WITH_PRODUCT')
              ) {
                Swal.fire({
                  icon: 'error',
                  title: '프로그램 타입 오류',
                  text: '프로그램이나 상품+프로그램 타입을 선택한 경우 반드시 프로그램을 선택해야 합니다.',
                  confirmButtonText: '확인',
                })
                setIsLoading(false)
                return
              }
              filteredData['productProgramType'] = programType

              // 위임 청구 상품: 수량 필드 포함
              if (
                categoryOption?.category4?.categoryParent ===
                'delegated_claims_product'
              ) {
                filteredData['delegationProductOptionQuantity'] =
                  option.delegationProductOptionQuantity ?? 0
              }

              const deletedIds = modalDeletedMappingIds
                .filter((item) => item.optionId === id)
                .map((item) => item.mappingId)
              console.log('deletedIds = ', deletedIds)

              if (hasMappings || deletedIds.length > 0) {
                if (hasMappings) {
                  const mappingList = mappings?.map((mapping) => {
                    const result = {
                      programId: mapping.programId,
                      programOptionId: mapping.programOptionId,
                      programTicketsToIssue: mapping.programTicketsToIssue || 1,
                    }

                    if (
                      mapping.mappingId !== undefined &&
                      mapping.mappingId !== null
                    ) {
                      result.mappingId = mapping.mappingId
                    }

                    return result
                  })

                  if (mappingList.length > 0) {
                    filteredData['productProgramMappingList'] = mappingList
                  }
                }

                if (deletedIds.length > 0) {
                  filteredData['deleteMappingIds'] = [...new Set(deletedIds)]
                }
              }

              // ✅ 세트 상품 정보 추가
              const setProductInfo = isSetProduct[optionIndex] || {}
              const finalData = {
                ...filteredData,
                ...setProductInfo,
              }
              addProductOption.push(finalData)
            }
          }
          console.log('addProductOption = ', addProductOption)

          let nutrientsAllergyVertical =
            nutrientInfoTransform('nutrientsAllergy')
          let nutrientsNutrientVertical =
            nutrientInfoTransform('nutrientInfomation')

          console.log('saveProduct :: product = ', product)
          console.log('saveProduct :: addProduct = ', addProduct)
          const excludeProductKeys = [
            'sellerName',
            'brandName',
            'categoryName',
            'topNutrientUnit',
          ]
          const mergedProduct = { ...product, ...addProduct }
          const filteredProduct = Object.keys(mergedProduct).reduce(
            (acc, key) => {
              if (!excludeProductKeys.includes(key)) {
                acc[key] = mergedProduct[key]
              }
              return acc
            },
            {},
          )

          // If category4 is empty, set categorySubId to null
          if (Array.isArray(category4) && category4.length === 0) {
            filteredProduct.categorySubId = null
          }

          if (productId && !location.search.includes('template')) {
            const editProduct = {
              productNutrientInformation: nutrientsNutrientVertical,
              productAllergy: nutrientsAllergyVertical,
              productItemMasterInfo: filteredProduct,
              productItemDetail: { ...productDetail, ...addProductDetail },
              productProgramMappingOptionList: addProductOption,
              idList: deleteOption,
            }
            console.log('editProduct = ', editProduct)

            // TODO: product edit
            const res = await productApi.v2EditProduct(editProduct, user.id)
            if (res.data.code === 200) {
              const productId = res.data.result
              let resultList = []

              // 상품메인이미지 수정
              if (
                Object.prototype.hasOwnProperty.call(
                  productImg.main,
                  'originFileObj',
                )
              ) {
                const updateResult = await s3Upload(
                  productImg.main.originFileObj,
                  0,
                  productId,
                  'main',
                )
                resultList.push(updateResult)
              }

              // 상품추가이미지 수정
              if (productImg.remainder?.length !== 0) {
                // 전체 삭제 후 업로드 진행
                if (deletedImgCount.remainder !== 0) {
                  console.log('상품추가이미지 전체 삭제 후 업로드 진행')
                  const deleteRes = await s3DeleteList(productId, 'additional')
                  if (deleteRes) {
                    const uploadResult = await Promise.all(
                      productImg.remainder.map(async (img, idx) => {
                        return await s3Upload(
                          img.originFileObj,
                          idx + 1,
                          productId,
                          'additional',
                        )
                      }),
                    )
                    resultList = [...resultList, ...uploadResult]
                  } else {
                    throw `기존 이미지를 삭제하는데 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.`
                  }
                } else {
                  // 업로드만 진행
                  if (
                    Object.prototype.hasOwnProperty.call(
                      productImg.remainder[0],
                      'originFileObj',
                    )
                  ) {
                    console.log('상품추가이미지 업로드 진행')
                    const uploadResult = await Promise.all(
                      productImg.remainder.map(async (img, idx) => {
                        return await s3Upload(
                          img.originFileObj,
                          idx + 1,
                          productId,
                          'additional',
                        )
                      }),
                    )
                    resultList = [...resultList, ...uploadResult]
                  }
                }
              } else {
                if (deletedImgCount.remainder !== 0) {
                  console.log('상품추가이미지 전체 삭제')
                  // s3에 존재하는 파일 전체 삭제
                  const deletedRes = await s3DeleteList(productId, 'additional')
                  if (deletedRes) {
                    resultList.push(deletedRes)
                  } else {
                    throw `기존 이미지를 삭제하는데 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.`
                  }
                }
              }

              // 🔥 태그 수정 로직
              // - 기존 태그 정보 조회하여 originalIconUrl 보존
              // - 변경된 태그만 isModified = true로 표시
              // - 새로 업로드된 이미지는 S3에 업로드 (productId_tag_idx.jpg)
              // - 기존 이미지는 originalIconUrl 유지
              // - 변경된 태그만 API로 업데이트 (editProductTag)
              // - 기존 태그가 있거나 새로 입력한 태그가 있는 경우 처리
              if (
                customDetailTag.some(
                  (tag) => tag.tagId || (tag.text && tag.text.trim() !== ''),
                )
              ) {
                await processTags(productId, true) // 수정 모드
              }

              // 상품상세페이지 수정
              if (productDescriptionImg?.length !== 0) {
                // 삭제
                for (const id of deletedImageUid) {
                  const nameArray = id.split('_')
                  const deleteIdx = Number(nameArray[nameArray.length - 1])
                  const deletedRes = await s3Delete(productId, deleteIdx)
                  if (deletedRes) {
                    resultList.push(deletedRes)
                  }
                }

                // 추가 및 복사하기
                let upLoadList = []
                let reCopyList = []

                for (let i = productDescriptionImg.length - 1; i >= 0; i--) {
                  const item = productDescriptionImg[i]
                  // 기존 image랑 새로운 image랑 동일한 uid값을 가지고 있는지 확인 (중복인지)
                  const refIdx = refProductDescriptionImg.findIndex(
                    (img) => img.uid === item?.uid,
                  )
                  if (refIdx >= 0) {
                    // 기존 이미지 복사
                    if (refIdx !== i) {
                      const newIdx = i
                      const copyResult = await s3Copy(refIdx, newIdx, productId)
                      reCopyList.push(newIdx)
                      resultList = [...resultList, copyResult]
                    }
                  } else {
                    // 기존에 없는 file 새로 업로드 해야 할 대상들 저장하기
                    upLoadList.push({ item, index: i })
                  }
                }

                reCopyList?.map(async (value) => {
                  await s3ReCopy(value, productId)
                })
                for (const { item, index } of upLoadList) {
                  const uploadResult = await s3Upload(
                    item.originFileObj,
                    index + 1,
                    productId,
                  )

                  resultList = [...resultList, uploadResult]
                }
              } else if (
                productDescriptionImg &&
                productDescriptionImg?.length === 0
              ) {
                // s3에 존재하는 파일 전체 삭제
                const deletedRes = await s3DeleteList(productId, 'description')
                console.log('상품상세이미지 전체 삭제', deletedRes)
                if (deletedRes) {
                  resultList = [...resultList, deletedRes]
                } else {
                  throw `기존 이미지를 삭제하는데 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.`
                }
              }
              if (resultList?.length !== 0) {
                if (resultList.every((result) => result)) {
                  const invalidateProductImg =
                    await productApi.invalidateProduct(productId)
                  console.log('캐시 무효화 요청', invalidateProductImg)

                  if (invalidateProductImg) {
                    setIsLoading(false)
                    alert('해당 상품을 성공적으로 수정했습니다.')
                    navigate(`/product/list`)
                  }
                } else {
                  throw `이미지 업로드에 실패하였습니다.`
                }
              } else {
                const invalidateProductImg =
                  await productApi.invalidateProduct(productId)
                console.log('캐시 무효화 요청', invalidateProductImg)

                if (invalidateProductImg) {
                  setIsLoading(false)
                  alert('해당 상품을 성공적으로 수정했습니다.')
                  navigate(`/product/list`)
                }
              }
            } else {
              throw `수정된 상품 정보를 저장하는데 실패하였습니다.`
            }
          } else if (
            (productId && location.search.includes('template')) ||
            !productId
          ) {
            /**🔥 기존 상품으로 등록하고 싶을 때*/
            const isReUse = productId && location.search.includes('template')
            let reuseFilteredProduct
            if (isReUse) {
              reuseFilteredProduct = normalizeProductItemMasterInfo(
                filteredProduct,
                user.id,
              )

              addProductOption.forEach((item) => {
                if (Array.isArray(item.productProgramMappingList)) {
                  item.productProgramMappingList.forEach((mapping) => {
                    if ('mappingId' in mapping) {
                      delete mapping.mappingId
                    }
                  })
                }

                if ('productId' in item) {
                  delete item.productId
                }
              })
            }

            const newProduct = {
              productNutrientInformation: nutrientsNutrientVertical,
              productAllergy: nutrientsAllergyVertical,
              productItemMasterInfo: isReUse
                ? reuseFilteredProduct
                : filteredProduct,
              productItemDetail: { ...productDetail, ...addProductDetail },
              productProgramMappingOptionList: addProductOption,
            }

            console.log(
              'createProduct :: param = ',
              newProduct,
              '\nuser.id = ',
              user.id,
            )

            if (isReUse) {
              handleProductRegisterOrReuse(
                newProduct,
                productImg,
                productDescriptionImg,
                deletedImgCount,
                deletedImageUid,
                refProductDescriptionImg,
              )
              return
            }
            //TODO: 생성!
            const res = await productApi.v2CreateProduct(newProduct, user.id)
            if (res.data.code === 200 || res.code === 200) {
              console.log('res.data ', res)
              const productId = res.data.result ?? res.result
              let resultList = []

              if (Object.keys(productImg.main)?.length > 0) {
                let result = await s3Upload(
                  productImg.main,
                  1,
                  productId,
                  'main',
                )
                resultList.push(result)
              }
              if (productImg.remainder?.length !== 0) {
                const uploadResult = await Promise.all(
                  productImg.remainder.map(async (img, idx) => {
                    return await s3Upload(
                      img.originFileObj,
                      idx + 1,
                      productId,
                      'additional',
                    )
                  }),
                )
                resultList = [...resultList, ...uploadResult]
              }
              if (productDescriptionImg?.length !== 0) {
                const uploadResult = await Promise.all(
                  productDescriptionImg.map(async (img, idx) => {
                    return await s3Upload(
                      img.originFileObj,
                      idx + 1,
                      productId,
                      'description',
                    )
                  }),
                )
                resultList = [...resultList, ...uploadResult]
              }

              // 🔥 태그 생성 로직
              // - productId + idx로 S3 경로 생성 (예: productId_tag_1.jpg)
              // - 새로 업로드된 이미지만 S3에 업로드
              // - S3 URL을 받아서 태그 데이터 생성
              // - API로 태그 생성 (createProductTag)
              // - 기존 태그가 있거나 새로 입력한 태그가 있는 경우 처리
              if (
                customDetailTag.some(
                  (tag) => tag.tagId || (tag.text && tag.text.trim() !== ''),
                )
              ) {
                await processTags(productId, false) // 생성 모드
              }

              if (resultList.every((result) => result)) {
                const invalidateProductImg =
                  await productApi.invalidateProduct(productId)
                console.log('캐시 무효화 요청', invalidateProductImg)

                if (invalidateProductImg) {
                  setIsLoading(false)
                  alert('해당 상품을 성공적으로 생성했습니다.')
                  navigate(`/product/list`)
                }
              } else {
                setIsLoading(false)
                window.alert('정상적인 요청이 아닙니다.')
              }
            } else if (res.data.code === 418) {
              setIsLoading(false)
              let duplication = ''
              for (let i = 0; i < res.data.result?.length; i++) {
                duplication += `${res.data.result[i].name}, `
              }
              window.alert(`중복된 정보가 있습니다. \n [${duplication}]`)
            } else if (res.data.code === 999) {
              setIsLoading(false)
              window.alert(res.data.msg)
            } else {
              setIsLoading(false)
              window.alert('정상적인 요청이 아닙니다.')
            }
          }
        } catch (error) {
          setIsLoading(false)
          console.log('saveProduct save error', error)
          alert(error)
        }
      }
    }
  }
  const normalizeProductItemMasterInfo = (info, userId) => {
    const {
      productId, // 제거 대상
      price1,
      price2,
      quantity,
      createdBy,
      ...rest
    } = info

    return {
      ...rest,
      price1: typeof price1 === 'string' ? Number(price1) : (price1 ?? 0),
      price2: typeof price2 === 'string' ? Number(price2) : (price2 ?? 0),
      quantity:
        typeof quantity === 'string' ? Number(quantity) : (quantity ?? 0),
      createdBy: createdBy ?? userId,
    }
  }

  async function handleProductRegisterOrReuse(
    newProduct,
    productImg,
    productDescriptionImg,
    deletedImgCount,
    deletedImageUid,
    refProductDescriptionImg,
  ) {
    const res = await productApi.v2CreateProduct(newProduct, user.id)
    const newProductId = res.data.result ?? res.result

    if (res.data.code === 200 || res.code === 200) {
      let resultList = []

      // 1️⃣ 메인 이미지 업로드
      if (Object.keys(productImg.main)?.length > 0) {
        if (productImg.main.originFileObj) {
          const updateResult = await s3Upload(
            productImg.main.originFileObj,
            0,
            newProductId,
            'main',
          )
          resultList.push(updateResult)
        } else {
          const oldPath = `images/product/main/${productId}.jpg`
          const newPath = `images/product/main/${newProductId}.jpg`
          const copyResult = await s3CopyForTemplate(oldPath, newPath) // productId → newProductId
          resultList.push(copyResult)
        }
        console.log('메인 이미지 업로드 결과 = ', resultList)
      }

      // 2️⃣ 추가 이미지 처리
      if (productImg.remainder?.length !== 0) {
        // deletedImgCount.remainder => 새로 업데이트하려고 전체 삭제한 이미지 개수
        // deletedImgCount.remainder이 0개이면 결국 그대로 복사해서 업로드하겠다는 의미
        if (deletedImgCount.remainder !== 0) {
          console.log('상품추가이미지 전체 삭제 후 업로드 진행')
          const deleteRes = await s3DeleteList(newProductId, 'additional') // 여기 productId → newProductId
          if (deleteRes) {
            const uploadResult = await Promise.all(
              productImg.remainder.map(async (img, idx) => {
                return await s3Upload(
                  img.originFileObj,
                  idx + 1,
                  newProductId,
                  'additional',
                )
              }),
            )
            resultList = [...resultList, ...uploadResult]
          }
        } else {
          const uploadResult = await Promise.all(
            productImg.remainder.map(async (img, idx) => {
              const oldPath = `images/product/addition/${productId}_addition_${
                idx + 1
              }.jpg`
              const newPath = `images/product/addition/${newProductId}_addition_${
                idx + 1
              }.jpg`
              return await s3CopyForTemplate(oldPath, newPath)
            }),
          )
          resultList = [...resultList, ...uploadResult]
        }
      } else if (deletedImgCount.remainder !== 0) {
        const deletedRes = await s3DeleteList(newProductId, 'additional') // productId → newProductId
        if (deletedRes) {
          resultList.push(deletedRes)
        } else {
          throw `기존 이미지를 삭제하는데 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.`
        }
        console.log('추가 이미지 업로드 결과2 = ', resultList)
      }

      // 3️⃣ 상세 이미지 처리
      if (productDescriptionImg?.length !== 0) {
        // 삭제 처리
        for (const id of deletedImageUid) {
          const nameArray = id.split('_')
          const deleteIdx = Number(nameArray[nameArray.length - 1])
          const deletedRes = await s3Delete(newProductId, deleteIdx)
          if (deletedRes) {
            resultList.push(deletedRes)
          }
        }
        console.log('🗑️ 삭제 완료 결과 = ', resultList)

        // 복사 및 신규 업로드 리스트
        const upLoadList = []
        const reCopyList = []

        // 기존 이미지 리스트 (originFileObj 없는 것)
        const existingImgs = productDescriptionImg
          .map((img, index) => ({ ...img, index }))
          .filter((img) => !img.originFileObj)

        // 신규 업로드 대상 리스트
        const newImgs = productDescriptionImg
          .map((img, index) => ({ ...img, index }))
          .filter((img) => img.originFileObj)

        // ✅ 기존 이미지 복사
        for (const { index } of existingImgs) {
          const oldPath = `images/product/description/${productId}_detail_${
            index + 1
          }.jpg`
          const newPath = `images/product/description/${newProductId}_detail_${
            index + 1
          }.jpg`

          const copyResult = await s3CopyForTemplate(oldPath, newPath)
          reCopyList.push(index)
          resultList.push(copyResult)
        }
        console.log('📄 이미지 복사 결과 = ', resultList)

        // ✅ 신규 이미지 업로드
        for (const { originFileObj, index } of newImgs) {
          const uploadResult = await s3Upload(
            originFileObj,
            index + 1,
            newProductId,
          )
          resultList.push(uploadResult)
        }
        console.log('⬆️ 신규 이미지 업로드 결과 = ', resultList)

        // ❌ 복사 후 임시파일 삭제 (주석 처리되어 있음, 필요시 복구)
        // await Promise.all(
        //   reCopyList.map(async (value) => {
        //     await s3ReCopy(value, newProductId)
        //   }),
        // )
      } else if (productDescriptionImg && productDescriptionImg.length === 0) {
        // 상세 이미지 전체 삭제
        const deletedRes = await s3DeleteList(newProductId, 'description') // productId → newProductId
        console.log('상품상세이미지 전체 삭제', deletedRes)
        if (deletedRes) {
          resultList.push(deletedRes)
          console.log('추가 이미지 업로드 결과6 = ', resultList)
        } else {
          throw `기존 이미지를 삭제하는데 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.`
        }
      }

      // 🔥 태그 생성 로직
      // - productId + idx로 S3 경로 생성 (예: productId_tag_1.jpg)
      // - 새로 업로드된 이미지만 S3에 업로드
      // - S3 URL을 받아서 태그 데이터 생성
      // - API로 태그 생성 (createProductTag)
      // - 기존 태그가 있거나 새로 입력한 태그가 있는 경우 처리
      if (
        customDetailTag.some(
          (tag) => tag.tagId || (tag.text && tag.text.trim() !== ''),
        )
      ) {
        await processTags(newProductId, false) // 생성 모드
      }

      console.log('resultList = 🔥', resultList)

      if (resultList.every((result) => result)) {
        const invalidateProductImg =
          await productApi.invalidateProduct(newProductId) // productId → newProductId
        console.log('캐시 무효화 요청', invalidateProductImg)

        if (invalidateProductImg) {
          setIsLoading(false)
          alert('해당 상품을 성공적으로 생성했습니다.')
          navigate(`/product/list`)
        }
      } else {
        setIsLoading(false)
        window.alert('정상적인 요청이 아닙니다.')
      }
    }
  }

  /**
   * category 선택 함수
   */
  const handleCategorySelect = (category) => {
    let searchCategory = {}
    if (category.categoryLevel === 'LARGE') {
      searchCategory = {
        categoryLevel: 'MEDIUM',
        categoryParent: category.categoryId,
      }
      setCategoryOption({
        ...categoryOption,
        category2: searchCategory,
        category3: {},
      })
      setProduct({
        ...product,
        categoryId: '',
        categoryName: '',
      })
      getCategoryList(searchCategory)
    } else if (category.categoryLevel === 'MEDIUM') {
      searchCategory = {
        categoryLevel: 'SMALL',
        categoryParent: category.categoryId,
      }
      setCategoryOption({ ...categoryOption, category3: searchCategory })
      setProduct({
        ...product,
        categoryId: '',
        categoryName: '',
      })
      getCategoryList(searchCategory)
    } else if (category.categoryLevel === 'SMALL') {
      searchCategory = {
        categoryLevel: 'SUB',
        categoryParent: category.categoryId,
      }
      setCategoryOption({ ...categoryOption, category4: searchCategory })
      setProduct({
        ...product,
        categoryId: category.categoryId,
        categoryName: category.categoryName,
      })
      getCategoryList(searchCategory)
    } else if (category.categoryLevel === 'SUB') {
      setProduct({
        ...product,
        categoryId: category.categoryParent,
        categorySubId: category.categoryId,
        // 필요하다면 topNutrientId 등도 추가
      })
      setNutrients({ ...nutrients, category: category.categoryId })
      setProductKpi({ ...productKpi, category: category.categoryId })
    }
  }
  const handleChange = (e) => {
    const { name, value } = e.target

    let otherFieldsLength = 0
    if (name === 'productDuration') {
      otherFieldsLength =
        (product.dailyUsageGuide?.length || 0) +
        (product.detailDescription?.length || 0)
    } else if (name === 'dailyUsageGuide') {
      otherFieldsLength =
        (product.productDuration?.length || 0) +
        (product.detailDescription?.length || 0)
    } else if (name === 'detailDescription') {
      otherFieldsLength =
        (product.productDuration?.length || 0) +
        (product.dailyUsageGuide?.length || 0)
    }

    if (
      ['productDuration', 'dailyUsageGuide', 'detailDescription'].includes(name)
    ) {
      const maxAllowedLength = 30 - otherFieldsLength

      if (value.length > maxAllowedLength) {
        const trimmedValue = value.slice(0, maxAllowedLength)
        setProduct({ ...product, [name]: trimmedValue })
        if (name === 'productDuration') {
          setProductAdditionalEx1Cnt(trimmedValue.length)
        } else if (name === 'dailyUsageGuide') {
          setProductAdditionalEx2Cnt(trimmedValue.length)
        } else if (name === 'detailDescription') {
          setProductAdditionalEx3Cnt(trimmedValue.length)
        }
        return
      }

      if (name === 'productDuration') {
        setProductAdditionalEx1Cnt(value.length)
      } else if (name === 'dailyUsageGuide') {
        setProductAdditionalEx2Cnt(value.length)
      } else if (name === 'detailDescription') {
        setProductAdditionalEx3Cnt(value.length)
      }
    }

    if (name === 'isPurchase') {
      setProduct({
        ...product,
        [name]: value,
        quantity: value ? product.quantity : 0,
      })
    } else if (name === 'productName') {
      setProductNameCnt(value?.length)
      setProduct({
        ...product,
        [name]: value,
        seoTitle: `${
          product.brandName ? product.brandName : ''
        } ${value} 효능, 효과, 가격, 부작용, 후기 (${dayjs().format(
          'YYYY',
        )}) | 슈가코치`,
        seoDescription: `${
          product.brandName ? product.brandName : ''
        } ${value} 정보, 효과, 효능, 부작용, 가격, 추천, 섭취 시간, 믿을 수 있는 후기를 슈가코치에서 확인해보세요!`,
        seoKeywords: `${value} 정보, ${value} 부작용, ${value} 효과, ${value} 가격, ${value} 효능, ${value} 먹는 시간, ${value} 복용시간, ${value} 복용순서, ${value} 구매, ${value} 직구, ${value} 종류, ${value} 사이트, ${value} 갤러리, ${value} 맞춤 영양제, ${value} 영양제 후기, ${value} 영양제 순위, ${value} 영양제 비교`,
      })
      setNutrients({ ...nutrients, name: value })
      setProductKpi({ ...productKpi, name: value })
    } else if (name === 'productMakerName') {
      setProduct({ ...product, [name]: value })
      setProductKpi({ ...productKpi, maker_name: value })
    } else if (name === 'price1') {
      if (
        value !== null &&
        value !== '' &&
        value !== '0' &&
        product.discount !== null &&
        product.discount !== '' &&
        product.discount !== '0'
      ) {
        setProduct({
          ...product,
          [name]: value,
          price2: value - value * (product.discount / 100),
        })
      } else {
        setProduct({ ...product, [name]: value, price2: value })
      }
      if (!product.price2 || !product.discount) {
        setProduct({ ...product, [name]: value, price2: value })
      }
      setProductKpi({ ...productKpi, price: value })
    } else if (name === 'discount') {
      if (
        value !== null &&
        value !== '' &&
        value !== '0' &&
        product.price1 !== null &&
        product.price1 !== '' &&
        product.price1 !== '0'
      ) {
        setProduct({
          ...product,
          [name]: value,
          price2: product.price1 - product.price1 * (value / 100),
        })
      } else {
        setProduct({ ...product, [name]: value, price2: '' })
      }
    } else if (name === 'quantity') {
      setProduct({ ...product, [name]: value })
    } else if (
      name === 'approvalNumber' ||
      name === 'medicalRatedVoltage' ||
      name === 'medicalPowerConsumption' ||
      name === 'productNutrient' ||
      name === 'importer'
    ) {
      setOptions({ ...options, [name]: value })
      if (!value) {
        setProductDetail({ ...productDetail, [name]: '' })
      }
    } else if (name === 'topNutrientContent') {
      setProduct({ ...product, [name]: value })
      setProductKpi({ ...productKpi, [name]: parseInt(value) })
    } else if (
      name === 'savingPoint' ||
      name === 'reviewPoint' ||
      name === 'reviewImagePoint'
    ) {
      // 포인트 지급 여부
      if (typeof value === 'boolean') {
        setOptions({ ...options, [name]: value })
        if (!value) {
          if (name === 'reviewPoint') {
            setProduct({ ...product, [name]: 0, reviewImagePoint: 0 })
          } else {
            setProduct({ ...product, [name]: 0 })
          }
        }
      } else {
        // 지급 포인트 액수
        if (name === 'savingPoint' && product.savingPointType === 'WON') {
          setProduct({ ...product, [name]: value?.replaceAll(/[^0-9]/g, '') })
        } else if (
          name === 'reviewPoint' &&
          product.reviewPointType === 'WON'
        ) {
          setProduct({ ...product, [name]: value?.replaceAll(/[^0-9]/g, '') })
        } else if (
          name === 'reviewImagePoint' &&
          product.reviewImagePointType === 'WON'
        ) {
          setProduct({ ...product, [name]: value?.replaceAll(/[^0-9]/g, '') })
        } else {
          setProduct({ ...product, [name]: value })
        }
      }
    } else if (Object.prototype.hasOwnProperty.call(e.target, 'checked')) {
      // case: checkbox
      const checked = e.target.checked
      if (checked) {
        if (name === 'vitamin' || name === 'mineral' || name === 'nutrition') {
          const findNutrient = nutrientCategoryList[name].find(
            (nutrient) => nutrient.nutrientId === e.target.id,
          )
          if (findNutrient) {
            setSelectNutrients([...selectNutrients, findNutrient])
          }
          setNutrientInfo({ ...nutrientInfo, [e.target.id]: 0 })
        } else if (name === 'nutrientAllergy') {
          setNutrientsAllergy({ ...nutrientsAllergy, [e.target.id]: value })
        } else if (name === 'nutrientEffect') {
          if (product[name] === '') {
            setProduct({ ...product, [name]: value })
          } else {
            setProduct({ ...product, [name]: product[name] + ',' + value })
          }
        } else if (name === 'formulation') {
          setProduct({ ...product, [name]: value })
          setProductKpi({ ...productKpi, [name]: value })
        } else if (name === 'targetGender' || name === 'productTarget') {
          setProduct({ ...product, [name]: value })
        } else if (name === 'pregnant' || name === 'began') {
          setProduct({ ...product, [name]: checked })
        } else if (name === 'nutrientAdditionalIngredient') {
          if (product[name] === '') {
            setProduct({ ...product, [name]: value })
          } else {
            setProduct({ ...product, [name]: product[name] + ',' + value })
          }
        } else if (name === 'refProductDetail') {
          setOptions({ ...options, [name]: checked })
          let editProductDetail
          switch (options.productType) {
            case 'MEDICAL_DEVICE':
              editProductDetail = {
                productDetailName: value,
                productModelName: value,
                adPreDeliberation: value,
                releaseDateSameModel: value,
                productDetailMaker: value,
                purpose: value,
                instruction: value,
                caution: value,
                qualityAssuranceStandards: value,
              }
              if (options.approvalNumber) {
                editProductDetail['approvalNumber'] = value
              }
              if (options.medicalRatedVoltage) {
                editProductDetail['medicalRatedVoltage'] = value
              }
              if (options.medicalPowerConsumption) {
                editProductDetail['medicalPowerConsumption'] = value
              }
              break
            case 'COSMETICS':
              editProductDetail = {
                capacity: value,
                productSpecification: value,
                validationDate: value,
                instruction: value,
                productDetailMaker: value,
                makerCountry: value,
                importer: value,
                productSubstanceInformation: value,
                foodDragMinistry: value,
                caution: value,
                qualityAssuranceStandards: value,
              }
              break
            case 'PROCESSED_FOOD':
              editProductDetail = {
                productDetailName: value,
                foodType: value,
                importer: value,
                location: value,
                makeDate: value,
                validationDate: value,
                capacityPackaging: value,
                quantityPackaging: value,
                productSubstanceInformation: value,
                caution: value,
              }
              if (options.productNutrient) {
                editProductDetail['productNutrient'] = value
              }
              break
            case 'HEALTH_FUNCTIONAL_FOOD':
              editProductDetail = {
                productDetailName: value,
                foodType: value,
                productDetailMaker: value,
                location: value,
                makeDate: value,
                validationDate: value,
                capacityPackaging: value,
                quantityPackaging: value,
                productSubstanceInformation: value,
                productNutrient: value,
                productSpecification: value,
                cautionIntake: value,
                notDrugInformation: value,
                caution: value,
              }
              break
            case 'LIVING_CHEMICAL_PRODUCT':
              editProductDetail = {
                productDetailName: value,
                usageFormulation: value,
                makeDate: value,
                validationDate: value,
                capacity: value,
                effectiveness: value,
                makerCountry: value,
                productDetailMaker: value,
                childProtectivePackagingProduct: value,
                productSubstanceInformation: value,
                caution: value,
                approvalNumber: value,
              }
              if (options.importer) {
                editProductDetail['importer'] = value
              }
              break
            case 'BIOCIDAL_PRODUCT':
              editProductDetail = {
                productDetailName: value,
                capacity: value,
                effectiveness: value,
                usageInformation: value,
                makerCountry: value,
                productDetailMaker: value,
                childProtectivePackagingProduct: value,
                productSubstanceInformation: value,
                productHazardInformation: value,
                caution: value,
                approvalNumber: value,
              }
              if (options.importer) {
                editProductDetail['importer'] = value
              }
              break
          }
          setProductDetail({ ...productDetail, ...editProductDetail })
        } else if (name === 'eventTag') {
          if (checked) {
            setProduct({ ...product, [name]: checked })
          } else {
            // 체크 해제 시 관련 색상 값들도 초기화
            setProduct({
              ...product,
              [name]: checked,
              eventColor: '',
              eventTextColor: '',
            })
          }
        } else if (name === 'pickTag') {
          if (checked) {
            setProduct({ ...product, [name]: checked })
          } else {
            // 체크 해제 시 관련 색상 값들도 초기화
            setProduct({
              ...product,
              [name]: checked,
              pickColor: '',
              pickTextColor: '',
            })
          }
        } else if (name === 'isGeneticModification' || name === 'isImported') {
          setProductDetail({ ...productDetail, [name]: checked })
        } else if (
          name === 'cancellationInformation' ||
          name === 'cancellationImpossibleInformation' ||
          name === 'qualityAssuranceStandardsInformation' ||
          name === 'refundIndemnityInformation' ||
          name === 'disputeInformation'
        ) {
          if (value !== 3) {
            setProduct({ ...product, [name]: '' })
          }
          setOptions({ ...options, [name]: value })
        } else {
          setProduct({ ...product, [name]: value })
        }
      } else {
        if (name === 'vitamin' || name === 'mineral' || name === 'nutrition') {
          const deletedArr = selectNutrients.filter(
            (nutrients) => !(nutrients.nutrientId === e.target.id),
          )
          setSelectNutrients(deletedArr)
          setNutrientInfo({ ...nutrientInfo, [e.target.id]: 0 })
        } else if (name === 'nutrientAllergy') {
          setNutrientsAllergy({ ...nutrientsAllergy, [e.target.id]: false })
        } else if (name === 'nutrientEffect') {
          let effectList = product[name]
            .split(',')
            .filter((effect) => effect !== value)
          setProduct({ ...product, [name]: effectList.join(',') })
        } else if (name === 'targetGender' || name === 'productTarget') {
          setProduct({ ...product, [name]: value })
        } else if (name === 'pregnant' || name === 'began') {
          setProduct({ ...product, [name]: checked })
        } else if (name === 'nutrientAdditionalIngredient') {
          let ingredientList = product[name]
            .split(',')
            .filter((ingredient) => ingredient !== value)
          setProduct({ ...product, [name]: ingredientList.join(',') })
        } else if (name === 'refProductDetail') {
          setOptions({ ...options, [name]: checked })
        } else if (name === 'eventTag') {
          if (checked) {
            setProduct({ ...product, [name]: checked })
          } else {
            // 체크 해제 시 관련 색상 값들도 초기화
            setProduct({
              ...product,
              [name]: checked,
              eventColor: '',
              eventTextColor: '',
            })
          }
        } else if (name === 'pickTag') {
          if (checked) {
            setProduct({ ...product, [name]: checked })
          } else {
            // 체크 해제 시 관련 색상 값들도 초기화
            setProduct({
              ...product,
              [name]: checked,
              pickColor: '',
              pickTextColor: '',
            })
          }
        } else if (name === 'isGeneticModification' || name === 'isImported') {
          setProductDetail({ ...productDetail, [name]: checked })
        } else {
          setProduct({ ...product, [name]: 0 })
        }
      }
    } else if (name === 'information') {
      setProduct({ ...product, [name]: value })
    } else {
      setProduct({ ...product, [name]: value })
    }
  }

  const handleProductExposureCheck = (checkValue) => {
    setProduct({
      ...product,
      isBest: false,
      isNew: false,
      isFreeDelivery: false,
    })
    let isBest = false
    let isNew = false
    let isFreeDelivery = false
    for (const value of checkValue) {
      if (value === 'best') {
        isBest = true
      } else if (value === 'new') {
        isNew = true
      } else if (value === 'free_delivery') {
        isFreeDelivery = true
      }
    }
    setProduct({
      ...product,
      isBest: isBest,
      isNew: isNew,
      isFreeDelivery: isFreeDelivery,
    })
    setOptions({ ...options, exposureTag: checkValue })

    console.log('checkValue !!! ', checkValue)
    console.log('product !!! ', product)
    console.log('options !!! ', options)
  }

  const handleCheckRecentBuyer = (e) => {
    // ColorPicker에서 직접 객체로 넘긴 경우
    if (e && typeof e === 'object' && 'name' in e && 'value' in e) {
      setProduct((prev) => ({ ...prev, [e.name]: e.value }))
      return
    }
    // Input에서 온 경우
    if (e && e.target) {
      const { name, value } = e.target
      setProduct((prev) => ({ ...prev, [name]: value }))
    }
  }

  const handleProductDetailChange = (e) => {
    const { name, value } = e.target
    setProductDetail({ ...productDetail, [name]: value })
  }

  const handleNutrientsChange = (e) => {
    const { name, value } = e.target
    setProduct({ ...product, [name]: value })
  }

  const handleNutrientInfoChange = (e) => {
    const { name, value } = e.target
    setNutrientInfo({ ...nutrientInfo, [name]: value })
  }

  const handleProductKpiChange = (e) => {
    const { name, value } = e.target
    if (name === 'unit') {
      setProduct({ ...product, [name]: value })
    }
    setProductKpi({ ...productKpi, [name]: value })
  }

  const handleSelectChange = (value, e) => {
    if (e.id === 'productBrand') {
      const findBrand = brandList.find((brand) => brand.id === value)
      if (findBrand) {
        setProduct({
          ...product,
          brandId: findBrand.id,
          brandName: findBrand.brandName,
          // shipmentPlace: findBrand.shipmentPlace,
          shipmentPlaceReturnExchange:
            findBrand.returnShipmentPlace +
            (findBrand.returnShipmentPlaceDetail
              ? ` ${findBrand.returnShipmentPlaceDetail}`
              : ''),
          seoTitle: `${findBrand.brandName} ${
            product.productName ? product.productName : ''
          } 효능, 효과, 가격, 부작용, 후기 (${dayjs().format(
            'YYYY',
          )}) | 슈가코치`,
          seoDescription: `${findBrand.brandName} ${
            product.productName ? product.productName : ''
          } 정보, 효과, 효능, 부작용, 가격, 추천, 섭취 시간, 믿을 수 있는 후기를 슈가코치에서 확인해보세요!`,
        })
        setNutrients({ ...nutrients, brandName: findBrand.brandName })
        setProductKpi({ ...productKpi, brandName: findBrand.brandName })
      }
    } else if (e.id === 'productSeller') {
      const findSeller = sellerList.find((seller) => seller.sellerId === value)
      if (findSeller) {
        setProduct({
          ...product,
          sellerId: findSeller.sellerId,
          sellerName: findSeller.sellerName,
          csNumber: findSeller.phone,
          asPhone: findSeller.phone,
        })
      }
      setOptions({ ...options, [e.id]: value })
    } else if (e.id === 'productType') {
      setProduct({ ...product, [e.id]: value })
      if (Object.prototype.hasOwnProperty.call(productDetail, 'id')) {
        setProductDetail({
          id: productDetail.id,
          productId: productDetail.productId,
        })
      } else {
        setProductDetail({})
      }
      setOptions({ ...options, [e.id]: value, ref_product_detail: false })
    } else if (e.id === 'forPersonUnit') {
      setNutrients({ ...nutrients, [e.id]: value })
      setProduct({ ...product, [e.id]: value })
      setProductKpi({ ...productKpi, [e.id]: value })
    } else if (
      e.id === 'deliveryCompany' ||
      e.id === 'deliveryCompanyReturnExchange'
    ) {
      setProduct({ ...product, [e.id]: value })
    } else if (
      e.id === 'savingPointType' ||
      e.id === 'reviewPointType' ||
      e.id === 'reviewImagePointType'
    ) {
      // 적립 포인트 단위 '원'으로 변경시, 입력했던 포인트 값 내림처리 (2025.01.14) - ksb
      if (value === 'WON') {
        if (e.id === 'savingPointType') {
          setProduct({
            ...product,
            [e.id]: value,
            savingPoint: Math.floor(product.savingPoint),
          })
        } else if (e.id === 'reviewPointType') {
          setProduct({
            ...product,
            [e.id]: value,
            reviewPoint: Math.floor(product.reviewPoint),
          })
        } else {
          setProduct({
            ...product,
            [e.id]: value,
            reviewImagePoint: Math.floor(product.reviewImagePoint),
          })
        }
      } else {
        setProduct({ ...product, [e.id]: value })
      }
    } else {
      setOptions({ ...options, [e.id]: value })
    }
  }

  // const handleProductSearchOptionChange = (e) => {
  //   const { name, value } = e.target
  //   setSearchOptions({ ...searchOptions, [name]: value })
  // }

  const handlePreview = async (file) => {
    let src = file.url
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file.originFileObj)
        reader.onload = () => resolve(reader.result)
      })
    }
    const image = new Image()
    image.src = src
    const imgWindow = window.open(src)
    imgWindow?.document.write(image.outerHTML)
  }

  /**
   * Image 업로드
   */
  const handleImageChange = (file, fileList, event, name) => {
    if (name === 'main') {
      if (productId) {
        if (file.status === 'removed') {
          setProductImg({ ...productImg, main: {} })
        } else {
          const editFile = {
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: URL.createObjectURL(file),
            originFileObj: file,
          }
          setProductImg({ ...productImg, main: editFile })
        }
      } else {
        setProductImg({ ...productImg, main: file })
      }
    } else if (name === 'additional') {
      if (fileList?.length > 9) {
        const saveFileList = fileList.slice(0, 9)
        setProductImg({ ...productImg, remainder: saveFileList })
        if (fileList[fileList?.length - 1].uid === file.uid) {
          alert('최대 9개의 파일만 업로드가 가능합니다.')
        }
      } else {
        setProductImg({ ...productImg, remainder: fileList })
      }
    } else {
      const addFiles = {
        uid: file.uid,
        name: file.name,
        status: 'done',
        url: URL.createObjectURL(file),
        originFileObj: file,
      }
      setProductDescriptionImg((prev) => [...prev, addFiles])
    }
  }

  /**
   * 영양소 함량 정보 항목 삭제 버튼
   */
  const deleteNutritionInfo = (deleteValue) => {
    const deletedArr = selectNutrients.filter(
      (nutrients) => !(nutrients.nutrientId === deleteValue.nutrientId),
    )
    setSelectNutrients(deletedArr)
    setNutrientInfo({ ...nutrientInfo, [deleteValue.nutrientId]: 0 })
  }

  /**
   * 취소 버튼
   */
  const cancelBtnClick = () => {
    if (
      window.confirm(
        '해당 페이지에서 나가면 지금까지 작성했던 기록들이 전부 사라집니다.\n그래도 나가시겠습니까?',
      )
    ) {
      navigate('/product/list')
    }
  }

  /**
   * 연관 상품 검색
   */
  // const handleProductSearch = () => {
  //   setSelectedRows([])
  //   setSelectedRowKeys([])
  //   // readProductList();
  // }

  /**
   * 연관 상품 검색 초기화
   */
  // const handleInitialBtnClick = () => {
  //   setSearchOptions({
  //     product_id: 0,
  //     product_maker_name: '',
  //     product_name: '',
  //     product_brand_name: '',
  //   })
  //   setSelectedRows([])
  //   setSelectedRowKeys([])
  //   // readProductList("initial");
  // }

  // const handleRowEvent = (record) => {
  //   return {
  //     onClick: () => {
  //       setSelectedRowKeys([record.product_id])
  //       setSelectedRows([record])
  //     },
  //   }
  // }

  // const tableOnChange = (pagination, filters, sorter) => {
  //   if (sorter) {
  //     //sorting 이벤트가 이루어졌을때
  //     if (sorter.order) {
  //       if (sorter.order === 'descend') {
  //         setOrderBy('desc')
  //       } else if (sorter.order === 'ascend') {
  //         setOrderBy('asc')
  //       }
  //       setOrderType(sorter.field)
  //       //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
  //     } else {
  //       setOrderType('created_at')
  //       setOrderBy('desc')
  //     }
  //   }
  // }

  /**
   * 연관 상품 삭제
   */
  // const handleRelatedProductDelete = async (product) => {
  // 	setIsLoading(true);
  // 	try {
  // 		const removedIdx = relatedProductList.findIndex(
  // 			(relatedProduct) =>
  // 				relatedProduct.related_product_id === product.related_product_id
  // 		);
  // 		if (removedIdx !== -1) {
  // 			relatedProductList.splice(removedIdx, 1);
  // 		} else {
  // 			throw "삭제한 정보를 다시 불러오지 못했습니다. 페이지를 다시 불러와주시길 바랍니다.";
  // 		}
  // 		// const res = await productApi.deleteRelatedProduct(product.main_product_id, product.related_product_id, user.id)
  // 		// if (res.code === 200) {
  // 		//     const removedIdx = relatedProductList.findIndex((relatedProduct) => relatedProduct.main_product_id === product.main_product_id && relatedProduct.related_product_id === product.related_product_id)
  // 		//     if (removedIdx !== -1) {
  // 		//         relatedProductList.splice(removedIdx, 1)
  // 		//     } else {
  // 		//         throw "삭제한 정보를 다시 불러오지 못했습니다. 페이지를 다시 불러와주시길 바랍니다."
  // 		//     }
  // 		// } else {
  // 		//     throw "해당 연관 상품을 삭제하는데 실패하였습니다.\n다시 시도하거나 관리자에게 문의하시길 바랍니다."
  // 		// }
  // 		setIsLoading(false);
  // 	} catch (error) {
  // 		setIsLoading(false);
  // 		setError(error);
  // 		console.log("handleRelatedProductDelete delete error", error);
  // 	}
  // };

  /**
   * 상품 설명 이미지 확인 Modal Open
   */
  const handleExplainProductModalOpen = () => {
    setClickImageUid(productDescriptionImg[0]?.uid)
    setIsExplainProductModalOpen(true)
  }

  const handleExplainProductModalCancel = () => {
    if (window.confirm('변경 사항이 저장되지 않습니다. 나가시겠습니까?')) {
      setIsExplainProductModalOpen(false)
    }
  }
  /**
   * 상품 설명 이미지 확인 Modal handle ok
   */
  const handleExplainProductModalOk = () => {
    setIsExplainProductModalOpen(false)
  }

  /**
   * 상품 설명 이미지 확인 Modal 저장하기
   */
  const handleExplainProductImageSave = (productExplainImgList) => {
    setIsExplainProductModalOpen(false)
    setProductDescriptionImg(productExplainImgList)
  }

  /**
   * 연관 상품 등록 Modal handle open
   */
  // const handleRelatedProductModalOpen = () => {
  //   setIsRelatedProductModalOpen(true)
  //   // readProductList("initial");
  // }

  /**
   * 연관 상품 등록 Modal handle cancel
   */
  // const handleRelatedProductModalCancel = () => {
  //   setSearchOptions({
  //     product_id: 0,
  //     product_maker_name: '',
  //     product_name: '',
  //     product_brand_name: '',
  //   })
  //   setRelatedProduct({ recommend_reason: '' })
  //   setOrderType('created_at')
  //   setOrderBy('desc')
  //   setSelectedRows([])
  //   setSelectedRowKeys([])
  //   setIsRelatedProductModalOpen(false)
  // }

  /**
   * 연관 상품 등록 Modal handle ok
   */
  // const handleRelatedProductModalOk = () => {
  // 	try {
  // 		const findAddProductIdx = relatedProductList.findIndex(
  // 			(relatedProduct) =>
  // 				relatedProduct.related_product_id === selectedRowKeys[0]
  // 		);
  // 		if (findAddProductIdx === -1) {
  // 			const addProduct = {
  // 				related_product_id: selectedRowKeys[0],
  // 				recommend_reason: relatedProduct.recommend_reason,
  // 				product_brand_name: selectedRows[0].product_brand_name,
  // 				product_name: selectedRows[0].product_name,
  // 				target_id: selectedRows[0].target_id,
  // 			};
  // 			setRelatedProductList([...relatedProductList, addProduct]);
  // 			setSearchOptions({
  // 				product_id: 0,
  // 				product_maker_name: "",
  // 				product_name: "",
  // 				product_brand_name: "",
  // 			});
  // 			setRelatedProduct({ recommend_reason: "" });
  // 			setOrderType("created_at");
  // 			setOrderBy("desc");
  // 			setSelectedRows([]);
  // 			setSelectedRowKeys([]);
  // 			setIsRelatedProductModalOpen(false);
  // 		} else {
  // 			throw "이미 연관상품에 등록한 상품입니다.\n삭제한 뒤 다시 시도하거나 다른 상품으로 등록해주시길 바랍니다.";
  // 		}
  // 	} catch (error) {
  // 		setIsLoading(false);
  // 		setError(error);
  // 		console.log("handleRelatedProductModalOk add error", error);
  // 		alert(error);
  // 	}
  // };

  /**
   * 옵션 추가
   */
  const addOption = () => {
    setProductOptions([
      ...productOptions,
      {
        optionTitle: '[N%, 1+1] N박스 (N개월분)',
        price1: 0,
        price2: 0,
        discount: 0,
        optionQuantity: 1,
        optionDescription: '',
        notExposed: false,
        delegationProductOptionQuantity: 0,
      },
    ])
    setProgramOption((prev) => [
      ...prev,
      { programIncluded: false, mappings: [] },
    ])
    setSelectedProgramTypes((prev) => [
      ...prev,
      { label: '상품', value: 'PRODUCT' },
    ])
    setIsSetProduct((prev) => [
      ...prev,
      {
        isSetProduct: false,
        productSetMappingList: [],
        setProductOriginalPrice: null,
        setProductPrice: null,
      },
    ])
  }

  /**
   * 옵션 삭제
   */
  const deleteOptions = (index, option) => {
    let currList = [...productOptions]
    currList.splice(index, 1)
    if (productId) {
      if (Object.prototype.hasOwnProperty.call(option, 'id')) {
        setDeleteOption([...deleteOption, option.id])
      }
    }
    setProductOptions(currList)

    // programOption 삭제
    setProgramOption((prev) => {
      const updated = [...prev]
      updated.splice(index, 1)
      return updated
    })

    // selectedProgramTypes 삭제
    setSelectedProgramTypes((prev) => {
      const updated = [...prev]
      updated.splice(index, 1)
      return updated
    })

    // isSetProduct 삭제
    setIsSetProduct((prev) => {
      const updated = [...prev]
      updated.splice(index, 1)
      return updated
    })
  }

  /**
   * 옵션 handleChange
   */
  const handleOptionChange = (e, index, fieldName = null) => {
    // InputNumber처럼 값만 전달되는 경우 처리
    let name, value
    if (e && e.target) {
      // 일반 input 이벤트
      name = e.target.name
      value = e.target.value
    } else if (fieldName !== null) {
      // InputNumber처럼 값만 전달된 경우 (fieldName 파라미터로 필드명 전달)
      name = fieldName
      value = e
    } else {
      // 기본 처리
      name = e?.target?.name
      value = e?.target?.value
    }

    // e.target이 없으면(예: InputNumber) 여기서 바로 처리 후 종료
    if (!e || !e.target) {
      const currOptions = [...productOptions]
      currOptions[index][name] = value
      setProductOptions(currOptions)
      return
    }

    let currOptions = [...productOptions]
    if (name === 'discount') {
      if (
        productOptions[index].price1 !== null &&
        productOptions[index].price1 !== 0 &&
        value !== '' &&
        value !== '0'
      ) {
        currOptions[index]['price2'] =
          productOptions[index].price1 -
          productOptions[index].price1 * (parseInt(value) / 100)
      } else if (
        productOptions[index].price1 !== null &&
        productOptions[index].price1 !== 0 &&
        value !== ''
      ) {
        currOptions[index]['price2'] = productOptions[index].price1
      }
    }
    if (name === 'delegationProductOptionQuantity') {
      currOptions[index]['delegationProductOptionQuantity'] = value
    }

    if (Object.prototype.hasOwnProperty.call(e.target, 'checked')) {
      const checked = e.target.checked
      currOptions[index][name] = checked
      if (name === 'isSetProduct') {
        currOptions[index].isSetProduct = checked

        setIsSetProduct((prev) => {
          const updated = [...prev]
          while (updated.length <= index) {
            updated.push({ isSetProduct: false, productSetMappingList: [] })
          }
          updated[index] = {
            ...updated[index],
            isSetProduct: checked,
            productSetMappingList: checked
              ? updated[index]?.productSetMappingList || []
              : [],
            setProductOriginalPrice: checked
              ? updated[index]?.setProductOriginalPrice || null
              : null,
            setProductPrice: checked
              ? updated[index]?.setProductPrice || null
              : null,
          }
          return updated
        })
      }
      if (name === 'isSetProduct' && checked) {
        setCurrentOptionIndex(index)
        setIsSetProductSelectModalVisible(true)
      }
    } else {
      // InputNumber나 일반 input의 값 변경 (숫자, 텍스트 등)
      currOptions[index][name] = value
    }
    setProductOptions(currOptions)
  }

  /**
   * 옵션 handlePriceChange
   */
  const handleOptionPriceChange = (value, name, index) => {
    let currOptions = [...productOptions]
    if (name === 'price1') {
      if (
        productOptions[index].discount !== '' &&
        productOptions[index].discount !== '0' &&
        value !== null &&
        value !== 0
      ) {
        currOptions[index]['price2'] =
          value - value * (parseInt(productOptions[index].discount) / 100)
      } else if (
        !productOptions[index].discount &&
        value !== null &&
        value !== 0
      ) {
        currOptions[index]['price2'] = value
      }
    } else if (name === 'price2') {
      if (
        productOptions[index].price1 !== null &&
        productOptions[index].price1 !== 0 &&
        value !== null
      ) {
        currOptions[index]['discount'] = Math.floor(
          ((productOptions[index].price1 - value) /
            productOptions[index].price1) *
            100,
        )
      }
    }
    currOptions[index][name] = value
    setProductOptions(currOptions)
  }

  const validation = () => {
    if (
      typeof product['isPurchase'] === 'undefined' ||
      product['isPurchase'] === null ||
      typeof product['isShow'] === 'undefined' ||
      product['isShow'] === null ||
      typeof product['categoryId'] === 'undefined' ||
      product['categoryId'] === null ||
      product['categoryId'] === '' ||
      typeof product['productName'] === 'undefined' ||
      product['productName'] === null ||
      product['productName'] === '' ||
      typeof product['sellerId'] === 'undefined' ||
      product['sellerId'] === null ||
      product['sellerId'] === '' ||
      typeof product['brandId'] === 'undefined' ||
      product['brandId'] === null ||
      product['brandId'] === '' ||
      typeof product['price1'] === 'undefined' ||
      product['price1'] === null ||
      typeof product['quantity'] === 'undefined' ||
      product['quantity'] === null ||
      Object.keys(productImg.main)?.length === 0 ||
      typeof product['productType'] === 'undefined' ||
      product['productType'] === null
    ) {
      alert('필수 입력란에 값이 없습니다. 다시 확인해보시고 입력바랍니다.')
      return false
    }

    for (const option of productOptions) {
      const optionIndex = productOptions.indexOf(option)
      if (
        typeof option['optionTitle'] === 'undefined' ||
        option['optionTitle'] === null ||
        option['optionTitle'] === '' ||
        typeof option['price1'] === 'undefined' ||
        option['price1'] === null ||
        option['price1'] === 0 ||
        typeof option['optionQuantity'] === 'undefined' ||
        option['optionQuantity'] === null ||
        option['optionQuantity'] === 0
      ) {
        alert(
          '옵션의 필수 항목이 빠졌거나 가격이 0원입니다. 다시 확인해 주세요.',
        )
        return false
      }

      if (!selectedProgramTypes[optionIndex]?.value) {
        alert('프로그램 타입이 선택되지 않았습니다. 다시 확인해 주세요.')
        return false
      }
    }

    // EVENT/PICK 태그 validation 및 기본값 설정
    if (product.eventTag && (!product.eventColor || !product.eventTextColor)) {
      product.eventColor = product.eventColor || '#117ffa'
      product.eventTextColor = product.eventTextColor || '#FFF'
    }
    if (product.pickTag && (!product.pickColor || !product.pickTextColor)) {
      product.pickColor = product.pickColor || '#117ffa'
      product.pickTextColor = product.pickTextColor || '#FFF'
    }

    return true
  }

  /**
   * 영양제 상품군 선택여부
   */
  const isNutritionalPro = () => {
    if (
      Object.prototype.hasOwnProperty.call(
        categoryOption.category3,
        'categoryParent',
      )
    ) {
      if (
        categoryOption.category3.categoryParent === 'vitamin' ||
        categoryOption.category3.categoryParent === 'mineral' ||
        categoryOption.category3.categoryParent === 'nutrition' ||
        categoryOption.category3.categoryParent === 'beauty' ||
        categoryOption.category3.categoryParent === 'red_ginseng' ||
        categoryOption.category3.categoryParent === 'protein'
      ) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  const nutrientInfoTransform = (type) => {
    let result = {}
    if (type === 'nutrientInfomation') {
      for (const key in nutrientInfo) {
        if (
          key === 'id' ||
          key === 'productId' ||
          key === 'createdAt' ||
          key === 'createdBy' ||
          key === 'updatedAt' ||
          key === 'updatedBy' ||
          key === 'isDelete'
        ) {
          /* empty */
        } else if (nutrientInfo[key]) {
          // result.push({
          //   nutrientId: key,
          //   nutrientContent: nutrientInfo[key],
          // })
          result[key] = nutrientInfo[key]
        }
      }
    } else if (type === 'nutrientsAllergy') {
      for (const key in nutrientsAllergy) {
        if (
          key === 'id' ||
          key === 'productId' ||
          key === 'createdAt' ||
          key === 'createdBy' ||
          key === 'updatedAt' ||
          key === 'updatedBy' ||
          key === 'isDelete'
        ) {
          /* empty */
        } else if (nutrientsAllergy[key]) {
          // result.push({
          //   nutrientId: key,
          //   nutrientAllergy: nutrientsAllergy[key],
          // })
          result[key] = nutrientsAllergy[key]
        }
      }
    }

    return result
  }

  const setProductInfo = (
    {
      productItemMasterInfo,
      productItemDetail,
      productNutrientInformation,
      productAllergy,
      productItemOptionList,
    },
    categoryList,
    nutrientsList,
  ) => {
    let editProduct = {}
    let editProductDetail = {}
    let editNutrientInfo = {}
    let editImage = { main: {}, remainder: [], description: [] }
    let editCategoryOption = {}
    let editOptions = {}
    let editSelectNutrients = []
    let allCategory2 = []
    let allCategory3 = []
    let allCategory4 = []
    const productType = productItemMasterInfo['productType']

    for (const key in productItemMasterInfo) {
      if (key === 'productId') {
        const thumbnail = {
          uid: `${productItemMasterInfo[key]}`,
          name: `${productItemMasterInfo[key]}.jpg`,
          status: 'done',
          mode: 's3',
          url: `${process.env.REACT_APP_S3_HOST}/images/product/main/${productItemMasterInfo[key]}.jpg`,
        }
        editImage.main = thumbnail
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'categoryId') {
        getNutrientSearchOption(productItemMasterInfo[key])
        const findCategory4 = categoryList?.level4.find(
          (category) =>
            category.categoryId === productItemMasterInfo['categorySubId'],
        )
        if (findCategory4) {
          editCategoryOption['category4'] = {
            categoryLevel: 'SUB',
            categoryParent: findCategory4.categoryParent,
          }
          allCategory4 = categoryList.level4.filter(
            (category) =>
              category.categoryParent === findCategory4.categoryParent,
          )
        }
        const findCategory3 = categoryList.level3.find(
          (category) => category.categoryId === productItemMasterInfo[key],
        )

        if (findCategory3) {
          editCategoryOption['category3'] = {
            categoryLevel: 'SMALL',
            categoryParent: findCategory3.categoryParent,
          }
          allCategory3 = categoryList.level3.filter(
            (category) =>
              category.categoryParent === findCategory3.categoryParent,
          )
          const findCategory2 = categoryList.level2.find(
            (category) => category.categoryId === findCategory3.categoryParent,
          )
          if (findCategory2) {
            editCategoryOption['category2'] = {
              categoryLevel: 'MEDIUM',
              categoryParent: findCategory2.categoryParent,
            }
            allCategory2 = categoryList.level2.filter(
              (category) =>
                category.categoryParent === findCategory2.categoryParent,
            )
            const findCategory1 = categoryList.level1.find(
              (category) =>
                category.categoryId === findCategory2.categoryParent,
            )
            if (findCategory1) {
              editCategoryOption['category1'] = {
                categoryLevel: 'LARGE',
                categoryParent: '0',
              }
            }
          }
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'productName') {
        setProductNameCnt(productItemMasterInfo[key]?.length)
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'sellerId') {
        editOptions['productSeller'] = productItemMasterInfo[key]
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'brandId') {
        editProduct[key] = productItemMasterInfo[key]
      } else if (
        key === 'isBest' ||
        key === 'isNew' ||
        key === 'isFreeDelivery'
      ) {
        if (
          productItemMasterInfo['isBest'] &&
          productItemMasterInfo['isNew'] &&
          productItemMasterInfo['isFreeDelivery']
        ) {
          editOptions['exposureTag'] = ['best', 'new', 'free_delivery']
        } else if (
          productItemMasterInfo['isBest'] &&
          productItemMasterInfo['isNew']
        ) {
          editOptions['exposureTag'] = ['best', 'new']
        } else if (
          productItemMasterInfo['isBest'] &&
          productItemMasterInfo['isFreeDelivery']
        ) {
          editOptions['exposureTag'] = ['best', 'free_delivery']
        } else if (productItemMasterInfo['isBest']) {
          editOptions['exposureTag'] = ['best']
        } else if (
          productItemMasterInfo['isNew'] &&
          productItemMasterInfo['isFreeDelivery']
        ) {
          editOptions['exposureTag'] = ['new', 'free_delivery']
        } else if (productItemMasterInfo['isNew']) {
          editOptions['exposureTag'] = ['new']
        } else if (productItemMasterInfo['isFreeDelivery']) {
          editOptions['exposureTag'] = ['free_delivery']
        } else {
          editOptions['exposureTag'] = []
        }
        // console.log('editOptions', editOptions)
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'eventTag') {
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'eventColor') {
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'eventTextColor') {
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'pickTag') {
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'pickColor') {
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'pickTextColor') {
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'productDuration') {
        if (productItemMasterInfo[key]) {
          setProductAdditionalEx1Cnt(productItemMasterInfo[key]?.length)
        } else {
          setProductAdditionalEx1Cnt(0)
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'dailyUsageGuide') {
        if (productItemMasterInfo[key]) {
          setProductAdditionalEx2Cnt(productItemMasterInfo[key]?.length)
        } else {
          setProductAdditionalEx2Cnt(0)
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'detailDescription') {
        if (productItemMasterInfo[key]) {
          setProductAdditionalEx3Cnt(productItemMasterInfo[key]?.length)
        } else {
          setProductAdditionalEx3Cnt(0)
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'productType') {
        editOptions[key] = productItemMasterInfo[key]
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'additionalImageNum') {
        let additionalImgList = []
        for (let i = 0; i < productItemMasterInfo[key]; i++) {
          const thumbnail = {
            uid: `${productItemMasterInfo['productId']}_addition_${i + 1}`,
            name: `${productItemMasterInfo['productId']}_addition_${i + 1}.jpg`,
            status: 'done',
            mode: 's3',
            url: `${process.env.REACT_APP_S3_HOST}/images/product/addition/${
              productItemMasterInfo['productId']
            }_addition_${i + 1}.jpg`,
          }
          additionalImgList.push(thumbnail)
        }
        editImage.remainder = additionalImgList
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'descriptionImageNum') {
        let descriptionImgList = []
        for (let i = 0; i < productItemMasterInfo[key]; i++) {
          const thumbnail = {
            uid: `${productItemMasterInfo['productId']}_detail_${i + 1}`,
            name: `${productItemMasterInfo['productId']}_detail_${i + 1}.jpg`,
            status: 'done',
            url: `${process.env.REACT_APP_S3_HOST}/images/product/description/${
              productItemMasterInfo['productId']
            }_detail_${i + 1}.jpg`,
          }
          descriptionImgList.push(thumbnail)
        }
        editImage.description = descriptionImgList
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'cancellationInformation') {
        if (
          productItemMasterInfo[key] ===
          '전자상거래등에서의소비자보호에관한법률 등에 의한 제품의 하자 또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가 부담합니다.'
        ) {
          editOptions[key] = 1
        } else if (productItemMasterInfo[key] === '상품상세 참조') {
          editOptions[key] = 2
        } else {
          editOptions[key] = 3
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'cancellationImpossibleInformation') {
        if (
          productItemMasterInfo[key] ===
          '전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에 준하는 것으로 인정되는 경우 청약철회가 제한될 수 있습니다.'
        ) {
          editOptions[key] = 1
        } else if (productItemMasterInfo[key] === '상품상세 참조') {
          editOptions[key] = 2
        } else {
          editOptions[key] = 3
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'qualityAssuranceStandardsInformation') {
        if (
          productItemMasterInfo[key] ===
          '소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.'
        ) {
          editOptions[key] = 1
        } else if (productItemMasterInfo[key] === '상품상세 참조') {
          editOptions[key] = 2
        } else {
          editOptions[key] = 3
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'refundIndemnityInformation') {
        if (
          productItemMasterInfo[key] ===
          '주문취소 및 대금의 환불은 당신의 영양제 마이페이지에서 신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한 법률에 따라 소비자의 청약철회 후 판매자가 재화 등을 반환 받은 날로부터 3영업일 이내에 지급받은 대금의 환급을 정당한 사유 없이 지연하는 때에는 소비자는 지연기간에 대해서 연 15%의 지연배상금을 판매자에게 청구할 수 있습니다.'
        ) {
          editOptions[key] = 1
        } else if (productItemMasterInfo[key] === '상품상세 참조') {
          editOptions[key] = 2
        } else {
          editOptions[key] = 3
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (key === 'disputeInformation') {
        if (
          productItemMasterInfo[key] ===
          '소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.'
        ) {
          editOptions[key] = 1
        } else if (productItemMasterInfo[key] === '상품상세 참조') {
          editOptions[key] = 2
        } else {
          editOptions[key] = 3
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (
        key === 'savingPoint' ||
        key === 'reviewPoint' ||
        key === 'reviewImagePoint'
      ) {
        if (productItemMasterInfo[key] === 0) {
          editOptions[key] = false
        } else {
          editOptions[key] = true
        }
        editProduct[key] = productItemMasterInfo[key]
      } else if (
        key === 'nutrientEffect' ||
        key === 'nutrientAdditionalIngredient'
      ) {
        if (!productItemMasterInfo[key]) {
          editProduct[key] = ''
        } else {
          editProduct[key] = productItemMasterInfo[key]
        }
      } else if (
        key === 'updatedAt' ||
        key === 'updatedBy' ||
        key === 'updatedByName'
      ) {
        /* empty */
      } else if (key === 'reviewRefId') {
        if (productItemMasterInfo[key]) {
          getReviewProduct(productItemMasterInfo[key])
        }
        editProduct[key] = productItemMasterInfo[key]
      } else {
        editProduct[key] = productItemMasterInfo[key]
      }
    }

    if (productItemDetail) {
      for (const key in productItemDetail) {
        if (productItemDetail[key] !== null) {
          switch (productType) {
            case 'MEDICAL_DEVICE':
              if (
                key === 'approvalNumber' ||
                key === 'medicalRatedVoltage' ||
                key === 'medicalPowerConsumption'
              ) {
                if (productItemDetail[key] === '해당사항 없음') {
                  editOptions[key] = false
                } else {
                  editProductDetail[key] = productItemDetail[key]
                }
              } else if (
                key === 'updatedAt' ||
                key === 'updatedBy' ||
                key === 'updatedByName'
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key]
              }
              break
            case 'COSMETICS':
              if (
                key === 'updatedAt' ||
                key === 'updatedBy' ||
                key === 'updatedByName'
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key]
              }
              break
            case 'PROCESSED_FOOD':
              if (key === 'productNutrient') {
                if (productItemDetail[key] === '해당사항 없음') {
                  editOptions[key] = false
                } else {
                  editProductDetail[key] = productItemDetail[key]
                }
              } else if (
                key === 'updatedAt' ||
                key === 'updatedBy' ||
                key === 'updatedByName'
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key]
              }
              break
            case 'HEALTH_FUNCTIONAL_FOOD':
              if (
                key === 'updatedAt' ||
                key === 'updatedBy' ||
                key === 'updatedByName'
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key]
              }
              break
            case 'LIVING_CHEMICAL_PRODUCT':
              if (key === 'importer') {
                if (productItemDetail[key] === '해당사항 없음') {
                  editOptions[key] = false
                } else {
                  editProductDetail[key] = productItemDetail[key]
                }
              } else if (
                key === 'updatedAt' ||
                key === 'updatedBy' ||
                key === 'updatedByName'
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key]
              }
              break
            case 'BIOCIDAL_PRODUCT':
              if (key === 'importer') {
                if (productItemDetail[key] === '해당사항 없음') {
                  editOptions[key] = false
                } else {
                  editProductDetail[key] = productItemDetail[key]
                }
              } else if (
                key === 'updatedAt' ||
                key === 'updatedBy' ||
                key === 'updatedByName'
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key]
              }
              break
            default:
              if (
                key === 'updatedAt' ||
                key === 'updatedBy' ||
                key === 'updatedByName'
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key]
              }
              break
          }
        }
      }
    } else {
      editProductDetail['productId'] = productItemMasterInfo['productId']
    }

    const editProductOption = productItemOptionList
      .filter((option) => !option.isDelete)
      .map((option) => {
        const { isShow, ...filteredData } = option
        filteredData['notExposed'] = !isShow
        return filteredData
      })

    for (const key in productNutrientInformation) {
      if (
        key === 'updatedAt' ||
        key === 'updatedBy' ||
        key === 'updatedByName' ||
        key === 'totalNutrientsType'
      ) {
        /* empty */
      } else if (key === 'id' || key === 'targetId' || key === 'targetType') {
        editNutrientInfo[key] = productNutrientInformation[key]
      } else {
        editNutrientInfo[key] = productNutrientInformation[key]
        if (productNutrientInformation[key] !== 0) {
          const findVitamin = nutrientsList.vitamin.find(
            (nutrient) => nutrient.nutrientId === key,
          )
          if (findVitamin) {
            editSelectNutrients.push(findVitamin)
          } else {
            const findMineral = nutrientsList.mineral.find(
              (nutrient) => nutrient.nutrientId === key,
            )
            if (findMineral) {
              editSelectNutrients.push(findMineral)
            } else {
              const findNutrition = nutrientsList.nutrition.find(
                (nutrient) => nutrient.nutrientId === key,
              )
              if (findNutrition) {
                editSelectNutrients.push(findNutrition)
              }
            }
          }
        }
      }
    }

    setCategory1(categoryList.level1)
    setCategory2(allCategory2)
    setCategory3(allCategory3)
    setCategory4(allCategory4)
    setProduct({ ...product, ...editProduct })
    setProductDetail({ ...productDetail, ...editProductDetail })
    setProductOptions(
      editProductOption?.length === 0
        ? [
            {
              optionTitle: '1박스 1개월분',
              price1: 0,
              price2: 0,
              discount: 0,
              optionQuantity: 1,
              optionDescription: '',
              notExposed: false,
              delegationProductOptionQuantity: 0,
            },
          ]
        : editProductOption,
    )
    setProductImg({
      ...productImg,
      main: editImage.main,
      remainder: editImage.remainder,
    })
    setProductDescriptionImg(editImage.description)
    setRefProductDescriptionImg(editImage.description)
    setNutrientInfo({ ...nutrientInfo, ...editNutrientInfo })
    setNutrientsAllergy({ ...nutrientsAllergy, ...productAllergy })
    setSelectNutrients(editSelectNutrients)
    setCategoryOption({ ...categoryOption, ...editCategoryOption })
    setOptions({ ...options, ...editOptions })
    setOptionsLoaded(true)
  }

  useEffect(() => {
    if (user.role !== 'super_admin' && sellerList?.length > 0 && !productId) {
      setOptions({ ...options, productSeller: sellerList[0].sellerId })
      if (brandList?.length > 0) {
        setProduct({
          ...product,
          sellerId: sellerList[0].sellerId,
          sellerName: sellerList[0].sellerName,
          brandId: brandList[0].id,
          brandName: brandList[0].brandName,
          shipmentPlace: '',
          shipmentPlaceReturnExchange:
            brandList[0].returnShipmentPlace +
            (brandList[0].returnShipmentPlaceDetail
              ? ` ${brandList[0].returnShipmentPlaceDetail}`
              : ''),
          csNumber: sellerList[0].phone,
          asPhone: sellerList[0].phone,
          seoTitle: `${brandList[0].brandName} ${
            product.productName ? product.productName : ''
          } 효능, 효과, 가격, 부작용, 후기 (${dayjs().format(
            'YYYY',
          )}) | 슈가코치`,
          seoDescription: `${brandList[0].brandName} ${
            product.productName ? product.productName : ''
          } 정보, 효과, 효능, 부작용, 가격, 추천, 섭취 시간, 믿을 수 있는 후기를 슈가코치에서 확인해보세요!`,
        })
      }
    }
  }, [productId, user, sellerList, brandList])

  const getCategoryName = () => {
    const findIdx = category3.findIndex(
      (category) => category.categoryId === product.categoryId,
    )
    if (findIdx > -1) {
      return category3[findIdx].categoryName
    } else {
      return ''
    }
  }

  const [exampleShow, setExampleShow] = useState(false)
  const [exampleTitle, setExampleTitle] = useState({
    id: '',
    title: '',
  })

  const handleExampleModal = (e, mainImageId) => {
    const id = e.target.id
    setExampleShow(true)
    if (id === 'exposure') {
      setExampleTitle({
        id: id,
        title: '상품 카드 구성',
      })
    } else if (id === 'tag') {
      setExampleTitle({
        id: id,
        title: '상품 카드 구성',
      })
    } else if (id === 'option') {
      setExampleTitle({
        id: id,
        title: '옵션 예시',
      })
    } else if (id === 'pick') {
      setExampleTitle({
        id: id,
        title: '상품 설명 예시',
      })
    } else if (mainImageId === 'main-image') {
      setExampleTitle({
        id: mainImageId,
        title: '대표 이미지 예시',
      })
    }
  }

  useEffect(() => {
    if (!productId || !optionsLoaded) {
      return
    }

    const loadAndUpdate = async () => {
      const results = await loadProgramMappings(productOptions)

      setProgramOption((prevOptions) => {
        const updatedOptions = [...prevOptions]
        const newLength = productOptions.length
        const currentLength = prevOptions.length

        if (newLength > currentLength) {
          const newOptions = Array.from(
            { length: newLength - currentLength },
            () => ({
              programIncluded: false,
              mappings: [],
            }),
          )
          updatedOptions.push(...newOptions)
        } else if (newLength < currentLength) {
          updatedOptions.splice(newLength)
        }

        results.forEach(({ index, mappings }) => {
          if (index < updatedOptions.length) {
            const hasProgram = mappings?.length > 0
            updatedOptions[index] = {
              ...updatedOptions[index],
              mappings: mappings,
              programIncluded: hasProgram,
            }
          }
        })

        return updatedOptions
      })

      setSelectedProgramTypes((prev) => {
        const newLength = productOptions.length
        const currentLength = prev.length
        const updated = [...prev]

        if (newLength > currentLength) {
          const newOptions = Array.from(
            { length: newLength - currentLength },
            () => ({
              label: '상품',
              value: 'PRODUCT',
            }),
          )
          updated.push(...newOptions)
        } else if (newLength < currentLength) {
          updated.splice(newLength)
        }

        results.forEach(({ index, mappings }) => {
          if (index < updated.length) {
            const option = productOptions[index]
            const programType =
              option?.productProgramType ||
              (mappings?.length > 0 ? 'PROGRAM_WITH_PRODUCT' : 'PRODUCT')

            updated[index] = {
              label:
                programType === 'PROGRAM'
                  ? '프로그램'
                  : programType === 'PROGRAM_WITH_PRODUCT'
                    ? '상품+프로그램'
                    : '상품',
              value: programType,
            }
          }
        })

        return updated
      })
    }

    loadAndUpdate()
  }, [productId, optionsLoaded])
  useEffect(() => {
    setSelectedProgramTypes((prev) => {
      return prev.map((type, index) => {
        const option = productOptions[index]
        if (option?.productProgramType) {
          return {
            label:
              option.productProgramType === 'PROGRAM'
                ? '프로그램'
                : option.productProgramType === 'PROGRAM_WITH_PRODUCT'
                  ? '상품+프로그램'
                  : option.productProgramType === 'DELEGATED_CLAIMS_PRODUCT'
                    ? '위임 청구 상품'
                    : '상품',
            value: option.productProgramType,
          }
        }
        return type
      })
    })
  }, [productOptions.map((o) => o.productProgramType).join(',')])

  const loadProgramMappings = async (options) => {
    const mappingPromises = options.map(async (option, index) => {
      if (!option?.id) {
        return { index, mappings: [] }
      }
      try {
        const mappings = await getProductProgram(option.id)
        return { index, mappings }
      } catch (error) {
        console.error(`옵션 ${option.id} 프로그램 로드 에러:`, error)
        return { index, mappings: [] }
      }
    })

    const results = await Promise.all(mappingPromises)
    return results
  }

  const getProductProgram = async (optionId) => {
    if (!optionId) {
      return
    }
    try {
      const res = await productApi.readProductProgram({
        productOptionId: optionId,
      })

      if (res.status === 200) {
        const mappings = res.data.map((program) => ({
          mappingId: program.id,
          productId: program.productId,
          programId: program.programId,
          programOptionId: program.programOptionId,
          programTicketsToIssue: program.programTicketsToIssue || 1,
          programOptionName: program.programOptionName,
        }))
        return mappings
      }
      return []
    } catch (error) {
      console.log(`옵션 ID ${optionId}에 대한 프로그램 정보 로드 실패:`, error)
      if (error.response && error.response.data.errorCode) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: error.response.data.detail[0].description,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        })
      }
      return []
    }
  }

  // 전체 프로그램 조회
  const getPrograms = async () => {
    setIsLoading(true)
    try {
      const res = await programApi.getPrograms()
      const rawData = res.data || []
      setPrograms(rawData) // 원본 데이터 저장

      const transformedData = rawData.flatMap((programItem) => {
        const programInfo = programItem.program
        const featuresString =
          Array.isArray(programItem.programFeatures) &&
          programItem.programFeatures.length > 0
            ? programItem.programFeatures.map((f) => f.feature).join(', ')
            : 'N/A'

        return programItem.programOptions.map((option) => ({
          programName: programInfo?.name || '이름 없음',
          programOptionName: option.programOptionName || '',
          programOptionId: option.id,
          programId: programInfo?.id,
          activeDays: option.activeDays,
          features: featuresString,
        }))
      })

      set_Programs(transformedData.reverse())
    } catch (err) {
      console.log('getPrograms err', err)
      setPrograms([])
      set_Programs([])
    } finally {
      setIsLoading(false)
    }
  }
  useEffect(() => {
    getPrograms()
  }, [])

  // 상품 옵션의 '프로그램 포함' Select 변경 시 핸들러
  const handleProgramSelectChange = async (value, index) => {
    const isIncluded = value === 'PROGRAM' || value === 'PROGRAM_WITH_PRODUCT'
    const optionId = productOptions[index]?.id

    // 프로그램 타입 상태 먼저 업데이트
    setSelectedProgramTypes((prev) => {
      const updated = [...prev]
      updated[index] = {
        label:
          value === 'PROGRAM'
            ? '프로그램'
            : value === 'PROGRAM_WITH_PRODUCT'
              ? '상품+프로그램'
              : value === 'DELEGATED_CLAIMS_PRODUCT'
                ? '위임 청구 상품'
                : '상품',
        value: value,
      }
      return updated
    })

    // 프로그램 옵션 상태 업데이트
    setProgramOption((prev) => {
      const updated = [...prev]

      // 상품만 선택한 경우 (프로그램 제외)
      if (!isIncluded) {
        // 기존 매핑이 있었다면 삭제 처리
        const mappingsToDelete =
          updated[index]?.mappings?.filter(
            (m) => typeof m.mappingId === 'number' && m.mappingId > 0,
          ) || []

        // 삭제 목록에 추가
        if (mappingsToDelete.length > 0 && optionId) {
          const deletedItems = mappingsToDelete.map((m) => ({
            mappingId: m.mappingId,
            optionId: optionId,
            programId: m.programId,
          }))

          setModalDeletedMappingIds((prev) => [...prev, ...deletedItems])
        }

        // 매핑 초기화
        updated[index] = {
          ...updated[index],
          programIncluded: false,
          mappings: [],
        }

        return updated
      }

      // 프로그램 포함 옵션으로 변경된 경우
      updated[index] = {
        ...updated[index],
        programIncluded: true,
      }

      return updated
    })

    // 프로그램 포함 옵션이 선택된 경우 모달 표시
    if (isIncluded) {
      if (_programs.length === 0) {
        await getPrograms()
      }
      setCurrentOptionIndex(index)
      const currentMappings = programOption[index]?.mappings || []
      setModalMappingData(currentMappings)
      setIsProgramModalVisible(true)
    }
  }

  // 체크
  const handleModalCheckboxChange = (e, item) => {
    const checked = e.target.checked
    const { programId, programOptionId } = item

    setModalMappingData((prev = []) => {
      if (checked) {
        const mappingExists = prev?.some(
          (m) =>
            m.programId === programId && m.programOptionId === programOptionId,
        )
        console.log('mappingExists', mappingExists)
        if (!mappingExists) {
          return [
            ...prev,
            {
              programId,
              programOptionId,
              programTicketsToIssue: 1,
            },
          ]
        } else {
          return prev
        }
      } else {
        const mappingToRemove = prev.find(
          (m) =>
            m.programId === programId && m.programOptionId === programOptionId,
        )

        if (
          mappingToRemove &&
          typeof mappingToRemove.mappingId === 'number' &&
          mappingToRemove.mappingId > 0
        ) {
          setLocalDeletedMappingIds((prev) => {
            const newItem = {
              mappingId: mappingToRemove.mappingId,
              optionId: productOptions[currentOptionIndex].id,
              programId: mappingToRemove.programId,
            }

            const exists = prev.some(
              (p) =>
                p.mappingId === newItem.mappingId &&
                p.optionId === newItem.optionId,
            )

            return exists ? prev : [...prev, newItem]
          })
        }

        return prev.filter(
          (m) =>
            !(
              m.programId === programId && m.programOptionId === programOptionId
            ),
        )
      }
    })
  }

  // 모달 내 수량 변경 시
  const handleModalQuantityChange = (value, item) => {
    const { programId, programOptionId } = item

    setModalMappingData((prev) =>
      prev.map((m) => {
        if (
          m.programId === programId &&
          m.programOptionId === programOptionId
        ) {
          return { ...m, programTicketsToIssue: value === null ? 0 : value }
        }
        return m
      }),
    )
  }

  // 데이터 저장 전 일관성 확인 및 수정 함수
  const validateAndFixDataConsistency = () => {
    let hasFixes = false
    const fixedProgramOption = [...programOption]
    const fixedSelectedTypes = [...selectedProgramTypes]

    for (let i = 0; i < programOption.length; i++) {
      const option = programOption[i]
      const programType = selectedProgramTypes[i]?.value || 'PRODUCT'
      const productOption = productOptions[i]

      // productProgramType이 있는 경우는 그대로 둔다
      if (productOption?.productProgramType) {
        continue
      }

      // 1. 매핑이 없는데 프로그램 타입인 경우
      if (
        (programType === 'PROGRAM' || programType === 'PROGRAM_WITH_PRODUCT') &&
        (!option.mappings || option.mappings.length === 0)
      ) {
        // 타입을 상품으로 수정
        fixedSelectedTypes[i] = {
          label: '상품',
          value: 'PRODUCT',
        }

        fixedProgramOption[i] = {
          ...option,
          programIncluded: false,
        }

        hasFixes = true
      }
      // 2. 매핑이 있는데 상품 타입인 경우
      else if (
        programType === 'PRODUCT' &&
        option.mappings &&
        option.mappings.length > 0
      ) {
        // 미리 매핑을 삭제 대상에 추가
        const optionId = productOptions[i]?.id
        if (optionId) {
          const mappingsToDelete = option.mappings.filter(
            (m) => typeof m.mappingId === 'number' && m.mappingId > 0,
          )
          if (mappingsToDelete.length > 0) {
            const deletedItems = mappingsToDelete.map((m) => ({
              mappingId: m.mappingId,
              optionId: optionId,
              programId: m.programId,
            }))
            setModalDeletedMappingIds((prev) => [...prev, ...deletedItems])
          }
        }
        // 매핑 초기화
        fixedProgramOption[i] = {
          ...option,
          programIncluded: false,
          mappings: [],
        }
        hasFixes = true
      }
    }

    // 수정사항이 있으면 상태 업데이트
    if (hasFixes) {
      setProgramOption(fixedProgramOption)
      setSelectedProgramTypes(fixedSelectedTypes)

      // 사용자에게 알림
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: '일부 데이터가 자동으로 조정되었습니다.',
        text: '타입과 매핑 데이터의 일관성을 유지하기 위해 조정했습니다.',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      })

      return true // 데이터가 수정되었음
    }

    return false // 데이터가 일관됨
  }

  const handleSaveModalSelection = () => {
    if (currentOptionIndex !== null) {
      // 현재 상태 확인
      const currentType = selectedProgramTypes[currentOptionIndex]?.value
      const isIncluded =
        currentType === 'PROGRAM' || currentType === 'PROGRAM_WITH_PRODUCT'
      const hasMappings = modalMappingData && modalMappingData.length > 0

      // 옵션 상태 업데이트
      setProgramOption((prev) => {
        const currOptions = [...prev]

        // 매핑이 있는데 타입이 맞지 않는 경우 처리
        if (hasMappings && !isIncluded) {
          // 프로그램이 있으면 프로그램 타입으로 변경
          setSelectedProgramTypes((prevTypes) => {
            const updated = [...prevTypes]
            updated[currentOptionIndex] = {
              label: '상품+프로그램',
              value: 'PROGRAM_WITH_PRODUCT',
            }
            return updated
          })
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'info',
            title: '상품+프로그램으로 변경되었습니다.',
            showConfirmButton: false,
          })
        }
        // 매핑이 없는데 프로그램 타입인 경우 처리
        else if (!hasMappings && isIncluded) {
          // 유지 (사용자가 이후에 프로그램을 추가할 수 있음)
          setSelectedProgramTypes((prevTypes) => {
            const updated = [...prevTypes]
            updated[currentOptionIndex] = {
              label: '상품',
              value: 'PRODUCT',
            }
            return updated
          })
        }

        currOptions[currentOptionIndex] = {
          ...currOptions[currentOptionIndex],
          programIncluded: hasMappings,
          mappings: modalMappingData,
        }

        return currOptions
      })
    }

    // 삭제된 매핑 처리
    setModalDeletedMappingIds((prev) => [...prev, ...localDeletedMappingIds])

    // 모달 상태 초기화
    setIsProgramModalVisible(false)
    setCurrentOptionIndex(null)
    setModalMappingData([])

    setTimeout(() => {
      setLocalDeletedMappingIds([])
      // const isFixed = validateAndFixDataConsistency()
      // if (isFixed) {
      //   console.log('데이터 일관성 확인 및 수정 완료')
      // }
    }, 1000)
  }

  const closeModalAndReset = () => {
    setIsProgramModalVisible(false)
    setCurrentOptionIndex(null)
  }

  const handleEditProgramsClick = async (index) => {
    // 프로그램 목록이 없다면 불러오기 (먼저 호출)
    if (_programs.length === 0) {
      await getPrograms()
    }

    const currentMappings = programOption[index]?.mappings || []

    // 현재 옵션 인덱스 설정
    setCurrentOptionIndex(index)
    setModalMappingData(currentMappings)
    setIsProgramModalVisible(true)
  }

  const getProgramIncludedSelectValue = (index) => {
    const option = programOption[index]
    const type = selectedProgramTypes[index]?.value

    // 이미 타입이 설정되어 있다면 그 값을 사용
    if (type && type !== 'PRODUCT') {
      return type
    }

    // 매핑이 있는 경우 PROGRAM_WITH_PRODUCT로 설정
    if (option?.mappings?.length > 0) {
      return 'PROGRAM_WITH_PRODUCT'
    }

    // 기본값은 PRODUCT
    return 'PRODUCT'
  }

  const handleProductSelect = (selectedProduct) => {
    // console.log('선택된 상품:', selectedProduct)
    setSelectedReviewProduct(selectedProduct)
    handleChange({
      target: {
        name: 'reviewRefId',
        value: selectedProduct.productId,
      },
    })
  }

  const handleReviewProductDelete = () => {
    setSelectedReviewProduct(null)
    // handleChange를 사용하여 reviewRefId를 null로 설정
    handleChange({
      target: {
        name: 'reviewRefId',
        value: null,
      },
    })
  }

  const getReviewProduct = async (productId) => {
    try {
      const res = await productApi.readProductList(
        {
          productId: productId,
          orderType: 'createdAt',
          orderBy: 'desc',
          offset: 0,
          pageSize: 1,
        },
        user.id,
      )
      if (res.data.code === 200 && res.data.result.productDTOList.length > 0) {
        const reviewProduct = res.data.result.productDTOList[0]
        setSelectedReviewProduct(reviewProduct)
      }
    } catch (error) {
      console.error('리뷰 참조 상품 조회 실패:', error)
    }
  }

  // <--- 세트 상품 옵션 로직 시작 -->
  const handleEditSetOptionsClick = async (index) => {
    setCurrentOptionIndex(index)
    setIsSetProductSelectModalVisible(true)
  }

  // ✅ ProductSetOptionComponent에서 변경된 값을 처리하는 함수
  const handleSetProductChange = (newValue, index) => {
    // ProductSetOptionComponent에서 특정 인덱스의 값과 인덱스 정보를 전달받음
    const targetIndex = index !== undefined ? index : currentOptionIndex

    // ✅ productOptions의 isSetProduct 필드도 함께 업데이트
    setProductOptions((prev) => {
      const updated = [...prev]
      if (updated[targetIndex]) {
        updated[targetIndex] = {
          ...updated[targetIndex],
          isSetProduct: newValue.isSetProduct,
        }
      }
      return updated
    })

    setIsSetProduct((prev) => {
      const updated = [...prev]
      updated[targetIndex] = newValue
      return updated
    })
  }

  // 매핑된 세트 옵션 조회
  const getProductSet = async (optionId) => {
    try {
      const res = await productApi.readProductSetOption({
        productSetOptionId: optionId,
      })

      if (res.status === 200) {
        console.log('getProductSet res', res.data)
        return res.data
      }
      return []
    } catch (error) {
      console.log(`옵션 ID ${optionId}에 대한 세트 옵션 정보 로드 실패:`, error)
      if (error.response && error.response.data.errorCode) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: error.response.data.detail[0].description,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        })
      }
      return []
    }
  }
  // 모든 옵션의 세트 정보 로드
  const loadAllProductSetMappings = async () => {
    if (!productOptions || productOptions.length === 0) {
      return
    }

    const newIsSetProduct = [...isSetProduct]

    for (let i = 0; i < productOptions.length; i++) {
      const option = productOptions[i]
      if (option && option.id) {
        try {
          const setMappings = await getProductSet(option.id)

          if (setMappings && setMappings.length > 0) {
            // linkedOptionId들을 배열로 추출
            const linkedOptionIds = setMappings.map(
              (mapping) => mapping.linkedOptionId,
            )

            newIsSetProduct[i] = {
              isSetProduct: true,
              productSetMappingList: linkedOptionIds,
              setProductOriginalPrice: option.setProductOriginalPrice,
              setProductPrice: option.setProductPrice,
            }
          } else {
            newIsSetProduct[i] = {
              isSetProduct: false,
              productSetMappingList: [],
              setProductOriginalPrice: null,
              setProductPrice: null,
            }
          }
        } catch (error) {
          console.log(`옵션 ${i}의 세트 매핑 로드 실패:`, error)
          newIsSetProduct[i] = {
            isSetProduct: false,
            productSetMappingList: [],
            setProductOriginalPrice: null,
            setProductPrice: null,
          }
        }
      }
    }

    setIsSetProduct(newIsSetProduct)
  }

  // ✅ productId와 optionsLoaded가 모두 true일 때 동기화 후 세트 매핑 로드
  useEffect(() => {
    if (productId && optionsLoaded) {
      // 1단계: productOptions와 isSetProduct 동기화
      setIsSetProduct((prev) => {
        const newIsSetProduct = []

        for (let i = 0; i < productOptions.length; i++) {
          if (prev[i]) {
            // 기존 데이터가 있으면 유지
            newIsSetProduct.push(prev[i])
          } else {
            // 새로운 옵션이면 기본값으로 초기화
            newIsSetProduct.push({
              isSetProduct: false,
              productSetMappingList: [],
              setProductOriginalPrice: null,
              setProductPrice: null,
            })
          }
        }

        return newIsSetProduct
      })

      console.log('loadAllProductSetMappings 실행')
      loadAllProductSetMappings()
    }
  }, [productId, optionsLoaded])

  return (
    <>
      {/* <ContentHeader
        title={isLoading ? null : productId ? '상품 수정' : '상품 등록'}
      /> */}
      <Flex
        align={'center'}
        className={`content-header`}
        dir="row"
        style={{ justifyContent: 'space-between' }}
      >
        <h1 className="header-title-text">
          {isLoading ? null : productId ? '상품 수정' : '상품 등록'}
        </h1>
        {productId && !isReUse && (
          <Button
            onClick={() =>
              navigate(`/product/register/${productId}?type=template`)
            }
          >
            상품 정보 재사용
          </Button>
        )}
      </Flex>
      <div
        className={`${styles['product-register-wrap']}`}
        style={{
          marginBottom: '7em',
        }}
      >
        {/*품절 상태*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          style={{ marginTop: 20, marginBottom: 18 }}
        >
          <span className={`${styles['product-register-box-title']}`}>
            품절 상태
          </span>
          <span className={`${styles['product-register-box-sign']}`}>*</span>
          <Radio.Group
            name="isPurchase"
            options={displayOptions}
            onChange={handleChange}
            value={product.isPurchase}
            className={`${styles['product-register-purchase-status-wrap']}`}
            optionType="button"
            buttonStyle="solid"
          />
        </Row>

        {/*노출여부*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          style={{ marginTop: 20, marginBottom: 18 }}
        >
          <span className={`${styles['product-register-box-title']}`}>
            노출여부
          </span>
          <span className={`${styles['product-register-box-sign']}`}>*</span>
          <Radio.Group
            name="isShow"
            options={exposureOptions}
            onChange={handleChange}
            value={product.isShow}
            className={`${styles['product-register-purchase-status-wrap']}`}
            optionType="button"
            buttonStyle="solid"
          />
        </Row>

        {/*카테고리*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
          >
            <span className={`${styles['product-register-box-title']}`}>
              카테고리
            </span>
            <span className={`${styles['product-register-box-sign']}`}>*</span>
            <span className={`${styles['product-register-box-subtitle']}`}>
              (카테고리부터 선택해주세요)
            </span>
          </Row>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ borderTop: 0, padding: '30px 33px', height: 300 }}
          >
            <Col
              className={`${styles['product-register-category-wrap']}`}
              span={6}
            >
              {category1?.length > 0 ? (
                <>
                  {category1.map((categoryItem, idx) => (
                    <Row
                      key={`${categoryItem.categoryLevel}_${categoryItem.categoryName}_${idx}_1`}
                      className={`${styles['product-register-category-item-wrap']} ${
                        categoryOption.category2.categoryParent ===
                        categoryItem.categoryId
                          ? styles.selected
                          : ''
                      }`}
                      wrap={false}
                      onClick={() => handleCategorySelect(categoryItem)}
                    >
                      <Col
                        className={`${styles['product-register-category-name']}`}
                        flex="auto"
                      >
                        {categoryItem.categoryName}
                      </Col>
                      <img
                        className={`${styles['product-register-category-icon']}`}
                        src={`${process.env.REACT_APP_HOST}/assets/icon/product/right-arrow-dark-gray.png`}
                      />
                    </Row>
                  ))}
                </>
              ) : null}
            </Col>
            <Col
              className={`${styles['product-register-category-wrap']}`}
              span={6}
            >
              {category2?.length > 0 ? (
                <>
                  {category2.map((categoryItem, idx) => (
                    <Row
                      key={`${categoryItem.categoryLevel}_${categoryItem.categoryName}_${idx}_2`}
                      className={`${styles['product-register-category-item-wrap']} ${
                        categoryOption.category3.categoryParent ===
                        categoryItem.categoryId
                          ? styles.selected
                          : ''
                      }`}
                      wrap={false}
                      onClick={() => handleCategorySelect(categoryItem)}
                    >
                      <Col
                        className={`${styles['product-register-category-name']}`}
                        flex="auto"
                      >
                        {categoryItem.categoryName}
                      </Col>
                      <img
                        className={`${styles['product-register-category-icon']}`}
                        src={`${process.env.REACT_APP_HOST}/assets/icon/product/right-arrow-dark-gray.png`}
                      />
                    </Row>
                  ))}
                </>
              ) : null}
            </Col>
            <Col
              className={`${styles['product-register-category-wrap']}`}
              span={6}
            >
              {category3?.length > 0 ? (
                <>
                  {category3.map((categoryItem, idx) => (
                    <Row
                      key={`${categoryItem.categoryLevel}_${categoryItem.categoryName}_${idx}_3`}
                      className={`${styles['product-register-category-item-wrap']} ${
                        categoryOption.category4.categoryParent ===
                          categoryItem.categoryId ||
                        product.categoryId === categoryItem.categoryId
                          ? styles.selected
                          : ''
                      }`}
                      wrap={false}
                      onClick={() => handleCategorySelect(categoryItem)}
                    >
                      <Col
                        className={`${styles['product-register-category-name']}`}
                        flex="auto"
                      >
                        {categoryItem.categoryName}
                      </Col>
                      <img
                        className={`${styles['product-register-category-icon']}`}
                        src={`${process.env.REACT_APP_HOST}/assets/icon/product/right-arrow-dark-gray.png`}
                      />
                    </Row>
                  ))}
                </>
              ) : null}
            </Col>
            <Col
              className={`${styles['product-register-category-wrap']}`}
              span={6}
            >
              {category4?.length > 0 ? (
                <>
                  {category4.map((categoryItem, idx) => (
                    <Row
                      key={`${categoryItem.categoryLevel}_${categoryItem.categoryName}_${idx}_4`}
                      className={`${styles['product-register-category-item-wrap']} ${
                        product.categorySubId === categoryItem.categoryId
                          ? styles.selected
                          : ''
                      }`}
                      wrap={false}
                      onClick={() => handleCategorySelect(categoryItem)}
                    >
                      <Col
                        className={`${styles['product-register-category-name']}`}
                        flex="auto"
                      >
                        {categoryItem.categoryName}
                      </Col>
                    </Row>
                  ))}
                </>
              ) : null}
            </Col>
          </Row>
        </>

        {/*상품명/정보*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              상품명 / 정보
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '20px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
              label="상품명"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
              required
            >
              <Input
                name="productName"
                value={product.productName}
                maxLength={50}
                onChange={handleChange}
              />
              <div className={`${styles['product-name-count-wrap']}`}>
                <span className={`${styles['product-name-count']}`}>
                  {productNameCnt}
                </span>
                /50
              </div>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            {user.role === 'super_admin' && (
              <>
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="판매자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{
                    flex: '0 0 120px',
                    style: {
                      minWidth: 120,
                      whiteSpace: 'nowrap',
                      fontWeight: 500,
                    },
                  }}
                  wrapperCol={{ flex: '0 0 240px' }}
                  required
                >
                  <Select
                    placeholder="판매자를 선택해주세요."
                    value={
                      options.productSeller !== 0 ? options.productSeller : null
                    }
                    onChange={handleSelectChange}
                  >
                    {sellerList?.length > 0 && (
                      <>
                        {sellerList.map((seller, idx) => (
                          <Select.Option
                            key={`seller_${idx}`}
                            id="productSeller"
                            value={seller.sellerId}
                          >
                            {seller.sellerName}
                          </Select.Option>
                        ))}
                      </>
                    )}
                  </Select>
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
              </>
            )}
            <Form.Item
              className={`${styles['center-label']}`}
              label="브랜드명"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
              required
            >
              <Select
                placeholder="브랜드를 선택해주세요."
                value={brandList?.length !== 0 ? product.brandId : null}
                onChange={handleSelectChange}
              >
                {brandList?.length !== 0 && (
                  <>
                    {brandList.map((brand, idx) => (
                      <Select.Option
                        key={`brand_${idx}`}
                        id="productBrand"
                        value={brand.id}
                      >
                        {brand.brandName}
                      </Select.Option>
                    ))}
                  </>
                )}
              </Select>
            </Form.Item>
          </div>
        </>
        {/* 최근 구매자 수 설정 */}
        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <span className="product-register-box-title">
            최근 구매자 수 설정
          </span>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            borderTop: 0,
            padding: '25px 25px',
            height: 'fit-content',
          }}
        >
          <Form.Item
            labelAlign="left"
            colon={false}
            labelCol={{
              flex: '0 0 120px',
            }}
          >
            <div style={{ display: 'flex', gap: 8 }}>
              <div
                style={{
                  display: 'flex',
                  gap: 8,
                  alignItems: 'center',
                  width: '20%',
                }}
              >
                <Input
                  placeholder="ex) 최근 OO기간 동안"
                  type="text"
                  name="recentBuyerText1"
                  value={product.recentBuyerText1}
                  min={0}
                  onChange={handleCheckRecentBuyer}
                />
                <ColorPicker
                  defaultValue="#fff"
                  value={product.recentBuyerColor1}
                  onChange={(color) =>
                    handleCheckRecentBuyer({
                      name: 'recentBuyerColor1',
                      value: color.toHexString(),
                    })
                  }
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: 8,
                  alignItems: 'center',
                  width: '20%',
                }}
              >
                <Input
                  placeholder="OOO명"
                  type="text"
                  name="recentBuyerText2"
                  value={product.recentBuyerText2}
                  min={0}
                  onChange={handleCheckRecentBuyer}
                />
                <ColorPicker
                  defaultValue="#ffffff"
                  value={product.recentBuyerColor2}
                  onChange={(color) =>
                    handleCheckRecentBuyer({
                      name: 'recentBuyerColor2',
                      value: color.toHexString(),
                    })
                  }
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: 8,
                  alignItems: 'center',
                  width: '20%',
                }}
              >
                <Input
                  placeholder="ex) 이 구매했어요"
                  type="text"
                  name="recentBuyerText3"
                  value={product.recentBuyerText3}
                  min={0}
                  onChange={handleCheckRecentBuyer}
                />
                <ColorPicker
                  defaultValue="#fff"
                  value={product.recentBuyerColor3}
                  onChange={(color) =>
                    handleCheckRecentBuyer({
                      name: 'recentBuyerColor3',
                      value: color.toHexString(),
                    })
                  }
                />
              </div>
            </div>
          </Form.Item>
        </div>
        {/* 유닛 단위 */}
        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <span className="product-register-box-title">
            최대 할인가 텍스트 설정
          </span>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            borderTop: 0,
            padding: '25px 25px',
            height: 'fit-content',
            gap: 16,
          }}
        >
          <Form.Item>
            <Input
              placeholder="ex) 세트 상품 최저가"
              type="text"
              name="maximumDiscountLabel"
              value={product.maximumDiscountLabel}
              min={0}
              style={{ width: 200 }}
              onChange={(e) =>
                setProduct((prev) => ({
                  ...prev,
                  maximumDiscountLabel: e.target.value,
                }))
              }
            />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            colon={false}
            labelCol={{
              flex: '0 0 120px',
            }}
          >
            <Input
              placeholder="ex) 박스당 최대"
              type="text"
              name="maximumDiscountUnitText"
              value={product.maximumDiscountUnitText}
              min={0}
              style={{ width: 200 }}
              onChange={(e) =>
                setProduct((prev) => ({
                  ...prev,
                  maximumDiscountUnitText: e.target.value,
                }))
              }
            />
          </Form.Item>
        </div>
        {/* 리뷰 참조 상품 */}
        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <span className="product-register-box-title">리뷰 참조 상품</span>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            borderTop: 0,
            padding: '25px 25px',
            height: 'fit-content',
          }}
        >
          <Button
            type="primary"
            onClick={() => setIsProductSelectModalVisible(true)}
          >
            리뷰 참조 상품 선택
          </Button>

          {selectedReviewProduct && (
            <div
              style={{
                marginTop: 16,
                padding: 16,
                border: '1px solid #f0f0f0',
                borderRadius: 4,
              }}
            >
              <h4 style={{ marginBottom: 16 }}>선택된 리뷰 참조 상품</h4>
              <div
                style={{
                  display: 'flex',
                  gap: 16,
                  alignItems: 'center',
                }}
              >
                <div>상품번호: {selectedReviewProduct.productId}</div>
                <div>상품명: {selectedReviewProduct.productName}</div>
                <div>브랜드: {selectedReviewProduct.brandName}</div>
                <div>
                  판매가: {selectedReviewProduct.price1?.toLocaleString()}원
                </div>
                <Button
                  type="text"
                  danger
                  onClick={handleReviewProductDelete}
                  style={{
                    padding: '10px',
                    height: 'auto',
                    lineHeight: 'inherit',
                  }}
                >
                  × 삭제
                </Button>
              </div>
            </div>
          )}
          <Col
            flex="none"
            className="product-price-help"
            style={{ marginTop: 10 }}
          >
            *해당 상품의 리뷰가 슈가코치 슈가몰 리뷰에 조회됩니다.
          </Col>
        </div>

        <ProductReviewRefComponent
          visible={isProductSelectModalVisible}
          onClose={() => setIsProductSelectModalVisible(false)}
          onSelect={handleProductSelect}
          currentProductId={product.productId}
          selectedReviewProduct={selectedReviewProduct}
        />

        {/*판매가*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              판매가
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '25px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
              label="판매가"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
              required
            >
              <Input
                type="number"
                name="price1"
                value={product.price1}
                min={0}
                onChange={handleChange}
                addonAfter={
                  <span className={`${styles['product-price-label']}`}>원</span>
                }
              />
              <Col flex="none" className={`${styles['product-price-help']}`}>
                *정가를 입력해주세요.
              </Col>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
              label="할인율"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
            >
              <Input
                type="number"
                name="discount"
                value={product.discount}
                min={0}
                onChange={handleChange}
                addonAfter={
                  <span className={`${styles['product-price-label']}`}>%</span>
                }
              />
              <Col flex="none" className={`${styles['product-price-help']}`}>
                *할인 할 퍼센트를 입력해주세요.
              </Col>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
              label="할인가"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
            >
              <Input
                type="number"
                name="price2"
                value={product.price2}
                min={0}
                onChange={handleChange}
                addonAfter={
                  <span className={`${styles['product-price-label']}`}>원</span>
                }
              />
              <Col flex="none" className={`${styles['product-price-help']}`}>
                *할인가를 할인율을 적용하여 계산 후 입력해주세요.
              </Col>
            </Form.Item>
          </div>
        </>

        {/*재고수량*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              재고수량
            </span>
            <span className={`${styles['product-register-box-sign']}`}>*</span>
          </Row>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{
              borderTop: 0,
              padding: '25px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item wrapperCol={{ span: 16 }} required>
              <Input
                type="number"
                name="quantity"
                value={product.quantity}
                min={0}
                onChange={handleChange}
                addonAfter={
                  <span className={`${styles['product-price-label']}`}>개</span>
                }
                disabled={!product.isPurchase}
              />
            </Form.Item>
          </Row>
        </>

        {/*상품 카드 구성*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              상품 카드 구성
            </span>
            <span
              className={`${styles['product-register-box-subtitle']}`}
              style={{
                fontSize: '0.9rem',
                cursor: 'pointer',
                borderBottom: 'solid 1px #117ffa',
              }}
              id={'tag'}
              onClick={handleExampleModal}
            >
              예시
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '20px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              label="태그"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
            >
              {user?.role === 'super_admin' && (
                <>
                  <div
                    className={`${styles['product-exposure-help-text']}`}
                    style={{ marginBottom: 10 }}
                  >
                    슈가몰 내외부 공통 상품 태그
                  </div>
                  <Checkbox.Group
                    className={`${styles['product-exposure-checkbox-wrap']}`}
                    options={exposureInfoOptions}
                    value={options.exposureTag}
                    onChange={handleProductExposureCheck}
                  />

                  <Col gutter={16}>
                    {/* 이벤트 태그 */}
                    <Row
                      style={{ marginBottom: '8px', marginTop: '8px' }}
                      gutter={4}
                    >
                      <Checkbox
                        checked={product.eventTag}
                        onChange={handleChange}
                        name="eventTag"
                        className={`${styles['product-exposure-checkbox-wrap']}`}
                        style={{ alignItems: 'center', width: '100px' }}
                      >
                        EVENT
                      </Checkbox>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                        }}
                      >
                        <ColorPicker
                          disabled={!product.eventTag}
                          value={product.eventColor}
                          onChange={(color) => {
                            handleChange({
                              target: {
                                name: 'eventColor',
                                value: color.toHexString(),
                              },
                            })
                          }}
                          style={{ width: '100%' }}
                        >
                          <Input
                            className={`${styles['product-exposure-tag-input']}`}
                            placeholder="이벤트 태그 배경 색상"
                            value={product.eventColor}
                            disabled={!product.eventTag}
                          />
                        </ColorPicker>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                          marginTop: '4px',
                        }}
                      >
                        <ColorPicker
                          disabled={!product.eventTag}
                          value={product.eventTextColor}
                          onChange={(color) => {
                            handleChange({
                              target: {
                                name: 'eventTextColor',
                                value: color.toHexString(),
                              },
                            })
                          }}
                          style={{ width: '100%' }}
                        >
                          <Input
                            className={`${styles['product-exposure-tag-input']}`}
                            placeholder="이벤트 태그 폰트 색상"
                            value={product.eventTextColor}
                            disabled={!product.eventTag}
                          />
                        </ColorPicker>

                        {product.eventTag &&
                          product.eventColor &&
                          product.eventTextColor && (
                            <div
                              style={{
                                backgroundColor: product.eventColor || '#FFF',
                                color: product.eventTextColor || '#000',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                display: 'inline-block',
                                marginTop: '8px',
                                border: '1px solid #d9d9d9',
                              }}
                            >
                              EVENT
                            </div>
                          )}
                      </div>
                    </Row>

                    {/* PICK 태그 */}
                    <Row
                      style={{ marginBottom: '8px', marginTop: '8px' }}
                      gutter={4}
                    >
                      <Checkbox
                        checked={product.pickTag}
                        onChange={handleChange}
                        name="pickTag"
                        className={`${styles['product-exposure-checkbox-wrap']}`}
                        style={{ alignItems: 'center', width: '100px' }}
                      >
                        PICK
                      </Checkbox>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                        }}
                      >
                        <ColorPicker
                          disabled={!product.pickTag}
                          value={product.pickColor}
                          onChange={(color) => {
                            handleChange({
                              target: {
                                name: 'pickColor',
                                value: color.toHexString(),
                              },
                            })
                          }}
                          style={{ width: '100%' }}
                        >
                          <Input
                            className={`${styles['product-exposure-tag-input']}`}
                            placeholder="픽 태그 배경 색상"
                            value={product.pickColor}
                            disabled={!product.pickTag}
                          />
                        </ColorPicker>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                          marginTop: '4px',
                        }}
                      >
                        <ColorPicker
                          disabled={!product.pickTag}
                          value={product.pickTextColor}
                          onChange={(color) => {
                            handleChange({
                              target: {
                                name: 'pickTextColor',
                                value: color.toHexString(),
                              },
                            })
                          }}
                          style={{ width: '100%' }}
                        >
                          <Input
                            className={`${styles['product-exposure-tag-input']}`}
                            placeholder="픽 태그 폰트 색상"
                            value={product.pickTextColor}
                            disabled={!product.pickTag}
                          />
                        </ColorPicker>

                        {product.pickTag &&
                          product.pickColor &&
                          product.pickTextColor && (
                            <div
                              style={{
                                backgroundColor: product.pickColor || '#FFF',
                                color: product.pickTextColor || '#000',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                display: 'inline-block',
                                marginTop: '8px',
                                border: '1px solid #d9d9d9',
                              }}
                            >
                              PICK
                            </div>
                          )}
                      </div>
                    </Row>
                  </Col>
                </>
              )}
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
              >
                <div
                  className={`${styles['product-exposure-help-text']}`}
                  style={{ marginTop: 24, marginBottom: 10 }}
                >
                  슈가몰 상품 상세 태그 (슈가몰 내외부 공통 상품 태그와 합쳐
                  최대 2개까지만 만들어주세요)
                </div>
                {customDetailTag[0] && (
                  <CustomTag
                    tagId={customDetailTag[0]?.tagId}
                    tagText={customDetailTag[0]?.text}
                    tagBackgroundColor={customDetailTag[0]?.backgroundColor}
                    tagTextColor={customDetailTag[0]?.textColor}
                    tagIconUrl={customDetailTag[0]?.iconUrl}
                    tagType={customDetailTag[0]?.productTagType}
                    onTagChange={(fieldName, value) =>
                      handleCustomTagChange(0, fieldName, value)
                    }
                    onImageChange={(file, fileList, event, type) =>
                      handleCustomTagImageChange(0, file, fileList, event, type)
                    }
                    onDelete={handleCustomTagDelete}
                  />
                )}
                {customDetailTag[1] && (
                  <CustomTag
                    tagId={customDetailTag[1]?.tagId}
                    tagText={customDetailTag[1]?.text}
                    tagBackgroundColor={customDetailTag[1]?.backgroundColor}
                    tagTextColor={customDetailTag[1]?.textColor}
                    tagIconUrl={customDetailTag[1]?.iconUrl}
                    tagType={customDetailTag[1]?.productTagType}
                    onTagChange={(fieldName, value) =>
                      handleCustomTagChange(1, fieldName, value)
                    }
                    onImageChange={(file, fileList, event, type) =>
                      handleCustomTagImageChange(1, file, fileList, event, type)
                    }
                    onDelete={handleCustomTagDelete}
                  />
                )}
              </div>
              <div
                className={`${styles['product-exposure-help-text']}`}
                style={{ marginTop: 24, marginBottom: 10 }}
              >
                슈가몰 외곽 상품 태그
              </div>
              <Col gutter={16}>
                {/* 태그 1 */}
                <Row style={{ marginBottom: '8px' }}>
                  <Input
                    className={`${styles['product-exposure-tag-input']}`}
                    name="exposureTag1"
                    value={product.exposureTag1 || ''}
                    onChange={handleChange}
                    placeholder="태그1"
                    style={{ marginBottom: '4px' }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <ColorPicker
                      disabled={
                        !product.exposureTag1 ||
                        product.exposureTag1.trim().length === 0
                      }
                      value={product.exposureTag1Color}
                      onChange={(color) => {
                        handleChange({
                          target: {
                            name: 'exposureTag1Color',
                            value: color.toHexString(),
                          },
                        })
                      }}
                      style={{ width: '100%' }}
                    >
                      <Input
                        className={`${styles['product-exposure-tag-input']}`}
                        placeholder="태그1 배경 색상"
                        value={product.exposureTag1Color}
                        disabled={
                          !product.exposureTag1 ||
                          product.exposureTag1.trim().length === 0
                        }
                      />
                    </ColorPicker>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                      marginTop: '4px',
                    }}
                  >
                    <ColorPicker
                      disabled={
                        !product.exposureTag1 ||
                        product.exposureTag1.trim().length === 0
                      }
                      value={product.exposureTag1TextColor}
                      onChange={(color) => {
                        handleChange({
                          target: {
                            name: 'exposureTag1TextColor',
                            value: color.toHexString(),
                          },
                        })
                      }}
                      style={{ width: '100%' }}
                    >
                      <Input
                        className={`${styles['product-exposure-tag-input']}`}
                        placeholder="태그1 폰트 색상"
                        value={product.exposureTag1TextColor}
                        disabled={
                          !product.exposureTag1 ||
                          product.exposureTag1.trim().length === 0
                        }
                      />
                    </ColorPicker>
                  </div>
                  {/* 미리보기 */}
                  {product.exposureTag1 &&
                    product.exposureTag1Color &&
                    product.exposureTag1TextColor && (
                      <div
                        style={{
                          backgroundColor: product.exposureTag1Color || '#FFF',
                          color: product.exposureTag1TextColor || '#000',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          display: 'inline-block',
                          marginTop: '8px',
                          border: '1px solid #d9d9d9',
                        }}
                      >
                        {product.exposureTag1}
                      </div>
                    )}
                </Row>

                {/* 태그 2 */}
                <Row style={{ marginBottom: '8px' }}>
                  <Input
                    className={`${styles['product-exposure-tag-input']}`}
                    name="exposureTag2"
                    value={product.exposureTag2 || ''}
                    onChange={handleChange}
                    placeholder="태그2"
                    style={{ marginBottom: '4px' }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <ColorPicker
                      disabled={
                        !product.exposureTag2 ||
                        product.exposureTag2.trim().length === 0
                      }
                      value={product.exposureTag2Color}
                      onChange={(color) => {
                        handleChange({
                          target: {
                            name: 'exposureTag2Color',
                            value: color.toHexString(),
                          },
                        })
                      }}
                      style={{ width: '100%' }}
                    >
                      <Input
                        className={`${styles['product-exposure-tag-input']}`}
                        placeholder="태그2 배경 색상"
                        value={product.exposureTag2Color}
                        disabled={
                          !product.exposureTag2 ||
                          product.exposureTag2.trim().length === 0
                        }
                      />
                    </ColorPicker>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                      marginTop: '4px',
                    }}
                  >
                    <ColorPicker
                      disabled={
                        !product.exposureTag2 ||
                        product.exposureTag2.trim().length === 0
                      }
                      value={product.exposureTag2TextColor}
                      onChange={(color) => {
                        handleChange({
                          target: {
                            name: 'exposureTag2TextColor',
                            value: color.toHexString(),
                          },
                        })
                      }}
                      style={{ width: '100%' }}
                    >
                      <Input
                        className={`${styles['product-exposure-tag-input']}`}
                        placeholder="태그2 폰트 색상"
                        value={product.exposureTag2TextColor}
                        disabled={
                          !product.exposureTag2 ||
                          product.exposureTag2.trim().length === 0
                        }
                      />
                    </ColorPicker>
                  </div>
                  {/* 미리보기 */}
                  {product.exposureTag2 &&
                    product.exposureTag2Color &&
                    product.exposureTag2TextColor && (
                      <div
                        style={{
                          backgroundColor: product.exposureTag2Color || '#FFF',
                          color: product.exposureTag2TextColor || '#000',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          display: 'inline-block',
                          marginTop: '8px',
                          border: '1px solid #d9d9d9',
                        }}
                      >
                        {product.exposureTag2}
                      </div>
                    )}
                </Row>

                {/* 태그 3 */}
                <Row style={{ marginBottom: '8px' }}>
                  <Input
                    className={`${styles['product-exposure-tag-input']}`}
                    name="exposureTag3"
                    value={product.exposureTag3 || ''}
                    onChange={handleChange}
                    placeholder="태그3"
                    style={{ marginBottom: '4px' }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <ColorPicker
                      disabled={
                        !product.exposureTag3 ||
                        product.exposureTag3.trim().length === 0
                      }
                      value={product.exposureTag3Color}
                      onChange={(color) => {
                        handleChange({
                          target: {
                            name: 'exposureTag3Color',
                            value: color.toHexString(),
                          },
                        })
                      }}
                      style={{ width: '100%' }}
                    >
                      <Input
                        className={`${styles['product-exposure-tag-input']}`}
                        placeholder="태그3 배경 색상"
                        value={product.exposureTag3Color}
                        disabled={
                          !product.exposureTag3 ||
                          product.exposureTag3.trim().length === 0
                        }
                      />
                    </ColorPicker>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                      marginTop: '4px',
                    }}
                  >
                    <ColorPicker
                      disabled={
                        !product.exposureTag3 ||
                        product.exposureTag3.trim().length === 0
                      }
                      value={product.exposureTag3TextColor}
                      onChange={(color) => {
                        handleChange({
                          target: {
                            name: 'exposureTag3TextColor',
                            value: color.toHexString(),
                          },
                        })
                      }}
                      style={{ width: '100%' }}
                    >
                      <Input
                        className={`${styles['product-exposure-tag-input']}`}
                        placeholder="태그3 폰트 색상"
                        value={product.exposureTag3TextColor}
                        disabled={
                          !product.exposureTag3 ||
                          product.exposureTag3.trim().length === 0
                        }
                      />
                    </ColorPicker>
                  </div>
                  {/* 미리보기 */}
                  {product.exposureTag3 &&
                    product.exposureTag3Color &&
                    product.exposureTag3TextColor && (
                      <div
                        style={{
                          backgroundColor: product.exposureTag3Color || '#FFF',
                          color: product.exposureTag3TextColor || '#000',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          display: 'inline-block',
                          marginTop: '8px',
                          border: '1px solid #d9d9d9',
                        }}
                      >
                        {product.exposureTag3}
                      </div>
                    )}
                </Row>

                <Row
                  flex="none"
                  className={`${styles['product-exposure-right-text']}`}
                  style={{ marginLeft: 6 }}
                >
                  선택 태그 포함 합산 최대 12글자
                </Row>
              </Col>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              label="하단 상품 상세"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
            >
              <Row>
                <Col span={12}>
                  상품 지속 시간
                  <Input
                    name="productDuration"
                    value={product.productDuration}
                    onChange={handleChange}
                    style={{ marginBottom: 10 }}
                    placeholder="합산 최대 30글자"
                  />
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  일일 사용 가이드
                  <Input
                    name="dailyUsageGuide"
                    value={product.dailyUsageGuide}
                    onChange={handleChange}
                    style={{ marginBottom: 10 }}
                    placeholder="합산 최대 30글자"
                  />
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  상세 설명
                  <Input
                    name="detailDescription"
                    value={product.detailDescription}
                    onChange={handleChange}
                    style={{ marginBottom: 10 }}
                    placeholder="합산 최대 30글자"
                  />
                </Col>
              </Row>
              <div className={`${styles['product-name-count-wrap']}`}>
                <span style={{ color: '#117ffa', fontWeight: '600' }}>
                  {productAdditionalEx1Cnt +
                    productAdditionalEx2Cnt +
                    productAdditionalEx3Cnt}
                  &nbsp;
                </span>
                / 30 (합산 최대 30글자)
              </div>
            </Form.Item>
          </div>
        </>

        {/*옵션*/}
        {/* <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              옵션
            </span>
            <span
              className={`${styles['product-register-box-subtitle']}`}
              style={{
                fontSize: '0.9rem',
                cursor: 'pointer',
                borderBottom: 'solid 1px #117ffa',
              }}
              id={'option'}
              onClick={handleExampleModal}
            >
              예시
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '25px 25px 40px',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['product-option-wrap']}`}
              label={`옵션 목록(${productOptions?.length ?? 0}개)`}
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{
                flex: '1 1 auto',
                style: {
                  marginTop: '8px',
                },
              }}
              // labelCol={{ span: 2 }}
              // wrapperCol={{ span: 22 }}
            >
              <div className={`${styles['product-option-list-wrap']}`}>
                {productOptions.map((option, index) => {
                  return (
                    <div
                      key={`product-option-${productId}-${option.id || index}`}
                    >
                      {index === 0 ? (
                        <>
                          <Row
                            wrap={false}
                            gutter={8}
                            className={`${styles['product-option-text']}`}
                            style={{ marginBottom: 4 }}
                            key={`product-option-${productId}-${index}`}
                          >
                            <Col flex="none">
                              <div
                                className={`${styles['product-option-button-wrap']}`}
                                style={{
                                  width: 'auto',
                                  minWidth: 'auto',
                                }}
                              />
                            </Col>
                            <Col span={5} style={{ textAlign: 'center' }}>
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              >
                                *
                              </span>
                              옵션명
                            </Col>
                            <Col
                              span={3}
                              style={{ textAlign: 'center', cursor: 'pointer' }}
                              onClick={() => setIsProgramModalVisible(true)}
                            >
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              >
                                *
                              </span>
                              프로그램 포함
                            </Col>
                            <Col span={3} style={{ textAlign: 'center' }}>
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              >
                                *
                              </span>
                              판매가
                            </Col>
                            <Col
                              span={2}
                              style={{
                                textAlign: 'center',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              ></span>
                              할인율
                            </Col>
                            <Col span={3} style={{ textAlign: 'center' }}>
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              ></span>
                              할인가
                            </Col>
                            <Col span={2} style={{ textAlign: 'center' }}>
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              >
                                *
                              </span>
                              구매 수량
                            </Col>
                            <Col span={5} style={{ textAlign: 'center' }}>
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              ></span>
                              옵션 설명
                            </Col>
                            <Col span={5} style={{ textAlign: 'center' }}>
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              ></span>
                              혜택 안내
                            </Col>
                            <Col span={2} style={{ textAlign: 'center' }}>
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              ></span>
                              미노출
                            </Col>
                            <Col span={2} style={{ textAlign: 'center' }}>
                              <span
                                className={`${styles['product-register-box-sign']}`}
                              ></span>
                              최대 구매 가능 개수
                            </Col>
                          </Row>

                          <Row
                            wrap={false}
                            gutter={8}
                            className={`${styles['product-option-row-wrap']}`}
                          >
                            <Col flex="none" style={{ textAlign: 'end' }}>
                              <div
                                className={`${styles['product-option-button-wrap']}`}
                                style={{
                                  width: 'auto',
                                  minWidth: 'auto',
                                }}
                              >
                                {productOptions?.length !== 1 ? (
                                  <img
                                    className={`${styles['product-option-button']}`}
                                    style={{
                                      width: '22px',
                                      height: '22px',
                                      cursor: 'pointer',
                                    }}
                                    src={`${process.env.REACT_APP_HOST}/assets/icon/product/product-option-delete.png`}
                                    onClick={() => deleteOptions(index, option)}
                                  />
                                ) : null}
                              </div>
                            </Col>
                            <Col span={5}>
                              <Input
                                name="optionTitle"
                                placeholder="옵션명을 입력해주세요."
                                value={option.optionTitle}
                                onChange={(e) => handleOptionChange(e, index)}
                              />
                            </Col>
                            <Col span={3}>
                              <Select
                                placeholder="선택"
                                value={
                                  option.programIncluded === null ||
                                  option.programIncluded === undefined
                                    ? undefined
                                    : String(option.programIncluded)
                                }
                                onChange={(value) =>
                                  handleProgramSelectChange(value, index)
                                }
                              >
                                <Select.Option value="true">포함</Select.Option>
                                <Select.Option value="false">
                                  미포함
                                </Select.Option>
                              </Select>
                            </Col>
                            <Col span={3}>
                              <InputNumber
                                formatter={(value) =>
                                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                                parser={(value) =>
                                  value.replace(/\$\s?|(,*)/g, '')
                                }
                                min={0}
                                value={option.price1}
                                onChange={(value) =>
                                  handleOptionPriceChange(
                                    value,
                                    'price1',
                                    index,
                                  )
                                }
                              />
                            </Col>
                            <Col span={2}>
                              <Input
                                type="number"
                                min={0}
                                name="discount"
                                value={option.discount}
                                onChange={(e) => handleOptionChange(e, index)}
                              />
                            </Col>
                            <Col span={3}>
                              <InputNumber
                                formatter={(value) =>
                                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                                parser={(value) =>
                                  value.replace(/\$\s?|(,*)/g, '')
                                }
                                min={0}
                                value={option.price2}
                                onChange={(value) =>
                                  handleOptionPriceChange(
                                    value,
                                    'price2',
                                    index,
                                  )
                                }
                              />
                            </Col>
                            <Col span={2}>
                              <Input
                                type="number"
                                min={1}
                                name="optionQuantity"
                                value={option.optionQuantity}
                                onChange={(e) => handleOptionChange(e, index)}
                              />
                            </Col>
                            <Col span={5}>
                              <Input
                                name="optionDescription"
                                placeholder="옵션 설명을 입력해주세요"
                                value={option.optionDescription}
                                onChange={(e) => handleOptionChange(e, index)}
                              />
                            </Col>
                            <Col span={5}>
                              <Input
                                name="optionBenefit"
                                placeholder="혜택 설명을 입력해주세요"
                                value={option.optionBenefit}
                                onChange={(e) => handleOptionChange(e, index)}
                              />
                            </Col>
                            <Col span={2}>
                              <Checkbox
                                className={`${styles['product-option-checkbox']}`}
                                name="notExposed"
                                checked={option.notExposed}
                                value={true}
                                onChange={(e) => handleOptionChange(e, index)}
                              />
                            </Col>
                            <Col span={2}>
                              <Input
                                type="number"
                                min={1}
                                name="maxPurchasableQuantity"
                                value={option.maxPurchasableQuantity}
                                onChange={(e) => handleOptionChange(e, index)}
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Row
                          wrap={false}
                          gutter={8}
                          className={`${styles['product-option-row-wrap']}`}
                          key={`product-option-${index}`}
                        >
                          <Col flex="none" style={{ textAlign: 'end' }}>
                            <div
                              className={`${styles['product-option-button-wrap']}`}
                              style={{
                                width: 'auto',
                                minWidth: 'auto',
                              }}
                            >
                              {productOptions?.length !== 1 ? (
                                <img
                                  className={`${styles['product-option-button']}`}
                                  style={{
                                    width: '22px',
                                    height: '22px',
                                    cursor: 'pointer',
                                  }}
                                  src={`${process.env.REACT_APP_HOST}/assets/icon/product/product-option-delete.png`}
                                  onClick={() => deleteOptions(index, option)}
                                />
                              ) : null}
                            </div>
                          </Col>
                          <Col span={5}>
                            <Input
                              name="optionTitle"
                              placeholder="옵션명을 입력해주세요."
                              value={option.optionTitle}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={3}>
                            <Select
                              placeholder="선택"
                              // value={product.productType}
                              // onChange={handleSelectChange}
                              onChange={handleProgramSelectChange}
                            >
                              {programItems.map((item, idx) => (
                                <Select.Option
                                  key={`${item.id}_${idx}`}
                                  id="programItems"
                                  value={item.value}
                                >
                                  {item.label}
                                </Select.Option>
                              ))}
                            </Select>
                          </Col>
                          <Col span={3}>
                            <InputNumber
                              formatter={(value) =>
                                value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                              }
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                              min={0}
                              value={option.price1}
                              onChange={(value) =>
                                handleOptionPriceChange(value, 'price1', index)
                              }
                            />
                          </Col>
                          <Col span={2}>
                            <Input
                              type="number"
                              min={0}
                              name="discount"
                              value={option.discount}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={3}>
                            <InputNumber
                              formatter={(value) =>
                                value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                              }
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                              min={0}
                              value={option.price2}
                              onChange={(value) =>
                                handleOptionPriceChange(value, 'price2', index)
                              }
                            />
                          </Col>
                          <Col span={2}>
                            <Input
                              type="number"
                              min={1}
                              name="optionQuantity"
                              value={option.optionQuantity}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={5}>
                            <Input
                              name="optionDescription"
                              placeholder="옵션 설명을 입력해주세요"
                              value={option.optionDescription}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={5}>
                            <Input
                              name="optionBenefit"
                              placeholder="혜택 설명을 입력해주세요"
                              value={option.optionBenefit}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={2}>
                            <Checkbox
                              className={`${styles['product-option-checkbox']}`}
                              name="notExposed"
                              checked={option.notExposed}
                              value={true}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={2}>
                            <Input
                              type="number"
                              min={1}
                              name="maxPurchasableQuantity"
                              value={option.maxPurchasableQuantity}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                        </Row>
                      )}
                    </div>
                  )
                })}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 'fit-content',
                  margin: '1rem auto',
                  cursor: 'pointer',
                }}
                onClick={addOption}
              >
                <img
                  style={{ width: '16px', height: '16px', marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/product/product-option-add.png`}
                  className={`${styles['product-option-button']}`}
                  onClick={addOption}
                />
                <p style={{ margin: 0 }}>옵션추가</p>
              </div>
            </Form.Item>
          </div>
        </> */}
        <>
          {/* 옵션 섹션 제목 */}
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              옵션
            </span>
            <span
              className={`${styles['product-register-box-subtitle']}`}
              style={{
                fontSize: '0.9rem',
                cursor: 'pointer',
                borderBottom: 'solid 1px #117ffa',
                marginLeft: '8px',
              }}
              id={'option'}
              onClick={handleExampleModal}
            >
              예시
            </span>
          </Row>

          {/* 옵션 목록 영역 */}
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '25px',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['product-option-wrap']}`}
              label={`옵션 목록(${productOptions?.length ?? 0}개)`}
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  fontWeight: 500,
                  marginBottom: 8,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
              style={{ marginBottom: 0 }}
            >
              <div className={`${styles['product-option-list-wrap']}`}>
                <Row
                  wrap={false}
                  gutter={[8, 8]}
                  className={`${styles['product-option-header-row']}`}
                  style={{ marginBottom: '12px', textAlign: 'center' }}
                >
                  <Col flex="42px">
                    {/* Fixed width for delete button column */}
                    {/* Empty space for alignment */}
                  </Col>
                  <Col span={2}>옵션 번호</Col>
                  <Col span={2}>세트 상품</Col>
                  <Col span={5}>
                    <span className={`${styles['product-register-box-sign']}`}>
                      *
                    </span>
                    옵션명
                  </Col>
                  <Col span={3}>
                    <span className={`${styles['product-register-box-sign']}`}>
                      *
                    </span>
                    프로그램 타입
                  </Col>
                  {categoryOption?.category4?.categoryParent ===
                    'delegated_claims_product' && (
                    <Col span={2}>위임 청구 수량</Col>
                  )}
                  <Col span={3}>
                    <span className={`${styles['product-register-box-sign']}`}>
                      *
                    </span>
                    판매가
                  </Col>
                  <Col span={2}>할인율</Col>
                  <Col span={3}>할인가</Col>
                  <Col span={2}>
                    <span className={`${styles['product-register-box-sign']}`}>
                      *
                    </span>
                    구매 수량
                  </Col>
                  <Col span={5}>옵션 설명</Col>
                  <Col span={5}>혜택 안내</Col>
                  <Col span={2}>미노출</Col>
                  <Col span={2}>최대 구매 가능 개수</Col>
                </Row>

                {/* 옵션 입력 행 (map 함수 사용) */}
                {productOptions.map((option, index) => {
                  return (
                    <Row
                      wrap={false}
                      gutter={[8, 8]}
                      className={`${styles['product-option-row-wrap']}`}
                      key={option.id || `new-option-${index}`}
                      style={{ marginBottom: '8px' }}
                      align="middle"
                    >
                      {/* 삭제 버튼 */}
                      <Col flex="42px" style={{ textAlign: 'center' }}>
                        {productOptions?.length > 1 && (
                          <img
                            className={`${styles['product-option-button']}`}
                            style={{
                              width: '22px',
                              height: '22px',
                              cursor: 'pointer',
                              verticalAlign: 'middle',
                            }}
                            src={`${process.env.REACT_APP_HOST}/assets/icon/product/product-option-delete.png`}
                            alt="옵션 삭제"
                            onClick={() => deleteOptions(index, option)}
                          />
                        )}
                      </Col>
                      <Col span={2}>
                        <Input
                          readOnly={true}
                          name="option_number"
                          value={
                            option?.productId && option?.id
                              ? `sgot_${option.id}`
                              : ''
                          }
                          disabled={true}
                        />
                      </Col>

                      <Col span={2}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            // justifyContent: 'center',
                            gap: '8px',
                            width: '100%',
                          }}
                        >
                          <Checkbox
                            name="isSetProduct"
                            checked={
                              productOptions[index]?.isSetProduct === true
                            }
                            onChange={(e) => handleOptionChange(e, index)}
                            style={{ flexShrink: 0 }}
                          />
                          {productOptions[index]?.isSetProduct === true &&
                            isSetProduct[index]?.productSetMappingList?.length >
                              0 && (
                              <EditOutlined
                                style={{
                                  cursor: 'pointer',
                                  color: '#117ffa',
                                  fontSize: '16px',
                                  flexShrink: 0,
                                }}
                                onClick={() => handleEditSetOptionsClick(index)}
                              />
                            )}
                        </div>
                      </Col>

                      {/* 옵션명 */}
                      <Col span={5}>
                        <Input
                          name="optionTitle"
                          placeholder="옵션명을 입력해주세요."
                          value={option.optionTitle}
                          onChange={(e) => handleOptionChange(e, index)}
                        />
                      </Col>

                      {/* 프로그램 포함 */}
                      <Col span={3}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            width: '100%',
                          }}
                        >
                          <Select
                            placeholder="선택"
                            value={getProgramIncludedSelectValue(index)}
                            onChange={(value) =>
                              handleProgramSelectChange(value, index)
                            }
                            style={{ flexGrow: 1, width: 'calc(100% - 24px)' }}
                          >
                            <Select.Option value="PRODUCT" label="상품">
                              상품
                            </Select.Option>
                            <Select.Option value="PROGRAM" label="프로그램">
                              프로그램
                            </Select.Option>
                            <Select.Option
                              value="PROGRAM_WITH_PRODUCT"
                              label="상품+프로그램"
                            >
                              상품+프로그램
                            </Select.Option>
                            <Select.Option
                              value="DELEGATED_CLAIMS_PRODUCT"
                              label="위임 청구 상품"
                              // disabled={true}
                            >
                              위임 청구 상품
                            </Select.Option>
                          </Select>
                          {programOption[index]?.programIncluded === true &&
                            programOption[index]?.mappings?.length > 0 && (
                              <EditOutlined
                                style={{
                                  cursor: 'pointer',
                                  color: '#117ffa',
                                  fontSize: '16px',
                                  flexShrink: 0,
                                  marginLeft: 'auto',
                                  zIndex: 1000,
                                }}
                                onClick={() => handleEditProgramsClick(index)}
                              />
                            )}
                        </div>
                      </Col>

                      {/* 위임 청구 수량 - 위임 청구 상품일 때만 표시 */}
                      {categoryOption?.category4?.categoryParent ===
                        'delegated_claims_product' && (
                        <Col span={2}>
                          <InputNumber
                            name="delegationProductOptionQuantity"
                            value={option.delegationProductOptionQuantity || 0}
                            onChange={(value) =>
                              handleOptionChange(
                                value,
                                index,
                                'delegationProductOptionQuantity',
                              )
                            }
                          />
                        </Col>
                      )}

                      {/* 판매가 */}
                      <Col span={3}>
                        <InputNumber
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          }
                          parser={(value) =>
                            `${value}`.replace(/\$\s?|(,*)/g, '')
                          }
                          min={0}
                          value={option.price1}
                          onChange={(value) =>
                            handleOptionPriceChange(value, 'price1', index)
                          }
                          style={{ width: '100%' }}
                        />
                      </Col>

                      {/* 할인율 */}
                      <Col span={2}>
                        <Input
                          type="number"
                          min={0}
                          max={100}
                          name="discount"
                          value={option.discount}
                          onChange={(e) => handleOptionChange(e, index)}
                          suffix="%"
                          style={{ width: '100%' }}
                        />
                      </Col>

                      {/* 할인가 */}
                      <Col span={3}>
                        <InputNumber
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          }
                          parser={(value) =>
                            `${value}`.replace(/\$\s?|(,*)/g, '')
                          }
                          min={0}
                          value={option.price2}
                          onChange={(value) =>
                            handleOptionPriceChange(value, 'price2', index)
                          }
                          style={{ width: '100%' }}
                        />
                      </Col>

                      {/* 구매 수량 */}
                      <Col span={2}>
                        <InputNumber
                          min={1}
                          name="optionQuantity"
                          value={option.optionQuantity}
                          onChange={(value) =>
                            handleOptionChange(
                              { target: { name: 'optionQuantity', value } },
                              index,
                            )
                          }
                          style={{ width: '100%' }}
                        />
                      </Col>

                      {/* 옵션 설명 */}
                      <Col span={5}>
                        <Input
                          name="optionDescription"
                          placeholder="옵션 설명을 입력해주세요"
                          value={option.optionDescription}
                          onChange={(e) => handleOptionChange(e, index)}
                        />
                      </Col>

                      {/* 혜택 안내 */}
                      <Col span={5}>
                        <Input
                          name="optionBenefit"
                          placeholder="혜택 설명을 입력해주세요"
                          value={option.optionBenefit}
                          onChange={(e) => handleOptionChange(e, index)}
                        />
                      </Col>

                      {/* 미노출 */}
                      <Col span={2} style={{ textAlign: 'center' }}>
                        <Checkbox
                          className={`${styles['product-option-checkbox']}`}
                          name="notExposed"
                          checked={option.notExposed}
                          onChange={(e) => handleOptionChange(e, index)}
                        />
                      </Col>

                      {/* 최대 구매 가능 개수 */}
                      <Col span={2}>
                        <InputNumber
                          min={1}
                          name="maxPurchasableQuantity"
                          value={option.maxPurchasableQuantity}
                          onChange={(value) =>
                            handleOptionChange(
                              {
                                target: {
                                  name: 'maxPurchasableQuantity',
                                  value,
                                },
                              },
                              index,
                            )
                          }
                          style={{ width: '100%' }}
                        />
                      </Col>
                    </Row>
                  )
                })}
              </div>

              {/* 옵션 추가 버튼 */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 'fit-content',
                  margin: '20px auto 0',
                  cursor: 'pointer',
                  padding: '8px 16px',
                  border: `1px solid ${styles.primaryColor || '#1890ff'}`,
                  borderRadius: '4px',
                  color: styles.primaryColor || '#1890ff',
                }}
                onClick={addOption}
              >
                <img
                  style={{ width: '16px', height: '16px', marginRight: 8 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/product/product-option-add.png`}
                  alt="옵션 추가"
                  className={`${styles['product-option-button']}`}
                />
                <p style={{ margin: 0, fontWeight: 500 }}>옵션 추가</p>
              </div>
            </Form.Item>
          </div>
        </>

        {/*상품 설명*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              상품 설명
            </span>
            <span
              className={`${styles['product-register-box-subtitle']}`}
              style={{
                fontSize: '0.9rem',
                cursor: 'pointer',
                borderBottom: 'solid 1px #117ffa',
              }}
              id={'pick'}
              onClick={handleExampleModal}
            >
              예시
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '25px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['product-register-form-input-wrap']}`}
              label="메인 특징"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
            >
              <Input name="usp" value={product.usp} onChange={handleChange} />
            </Form.Item>
            <Form.Item
              className={`${styles['product-register-form-input-wrap']}`}
              label={`구성 목록`}
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
              style={{
                position: 'relative',
              }}
            >
              <Input.TextArea
                name={`information`}
                value={product[`information`]}
                onChange={handleChange}
                style={{
                  minHeight: '50px',
                }}
              />
            </Form.Item>
          </div>
        </>

        {/*브랜드 프로모션 수수료율*/}
        {/* <div>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              프로모션 수수료율 (VAT 별도)
            </span>
          </Row>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{
              borderTop: 0,
              padding: '25px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item wrapperCol={{ span: 16 }}>
              <Input
                type="number"
                name="commissionRate"
                value={product.commissionRate}
                min={0}
                onChange={handleChange}
                addonAfter={
                  <span className={`${styles['product-price-label']}`}>%</span>
                }
              />
            </Form.Item>
          </Row>
        </div> */}

        {/*상품이미지*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              상품이미지
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '25px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              label="대표 이미지"
              labelAlign="left"
              tooltip={{
                id: 'main-image',
                title: false,
                trigger: 'click',
                onClick: (e) => {
                  handleExampleModal(e, 'main-image')
                },
              }}
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
              required
            >
              {productId ? (
                <Upload
                  className={`${styles['product-register-upload-img-wrap']}`}
                  listType="picture-card"
                  maxCount={1}
                  fileList={
                    Object.keys(productImg.main)?.length !== 0
                      ? [productImg.main]
                      : null
                  }
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, 'main')
                  }
                  onPreview={handlePreview}
                  beforeUpload={(file) => {
                    return new Promise((resolve) => {
                      // 업로드한 파일이 이미지 형식인지 확인
                      const isImg =
                        file.type === 'image/jpeg' ||
                        file.type === 'image/jpg' ||
                        file.type === 'image/png' ||
                        file.type === 'image/gif' ||
                        file.type === 'image/webp'
                      if (!isImg) {
                        alert(
                          '이미지 파일(webp, jpeg, jpg, png, gif)만 업로드 되어야 합니다.',
                        )
                        return Upload.LIST_IGNORE
                      }
                      // 이미지 사이즈를 확인하기 위해 업로드한 파일을 읽고 이미지로 변환
                      const reader = new FileReader()
                      reader.readAsDataURL(file)
                      reader.addEventListener('load', (event) => {
                        const loadedImgUrl = event.target.result
                        const image = document.createElement('img')
                        image.src = loadedImgUrl
                        image.addEventListener('load', () => {
                          const { width, height } = image
                          if (width !== 1000 && height !== 1000) {
                            alert(
                              '이미지의 크기는 1000px x 1000px 이어야 합니다.',
                            )
                            return Upload.LIST_IGNORE
                          } else {
                            return resolve(false)
                          }
                        })
                      })
                    })
                  }}
                >
                  {Object.keys(productImg.main)?.length !== 0 ? null : (
                    <div
                      className={`${styles['product-register-upload-img-icon-wrap']}`}
                    >
                      <img
                        className={`${styles['product-register-upload-img-icon']}`}
                        src={`${process.env.REACT_APP_HOST}/assets/icon/product/plus.png`}
                      />
                    </div>
                  )}
                </Upload>
              ) : (
                <Upload
                  className={`${styles['product-register-upload-img-wrap']}`}
                  listType="picture-card"
                  maxCount={1}
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, 'main')
                  }
                  onPreview={handlePreview}
                  beforeUpload={(file) => {
                    return new Promise((resolve) => {
                      // 업로드한 파일이 이미지 형식인지 확인
                      const isImg =
                        file.type === 'image/jpeg' ||
                        file.type === 'image/jpg' ||
                        file.type === 'image/png' ||
                        file.type === 'image/gif' ||
                        file.type === 'image/webp'
                      if (!isImg) {
                        alert(
                          '이미지 파일(webp,jpeg, jpg, png, gif)만 업로드 되어야 합니다.',
                        )
                        return Upload.LIST_IGNORE
                      }
                      // 이미지 사이즈를 확인하기 위해 업로드한 파일을 읽고 이미지로 변환
                      const reader = new FileReader()
                      reader.readAsDataURL(file)
                      reader.addEventListener('load', (event) => {
                        const loadedImgUrl = event.target.result
                        const image = document.createElement('img')
                        image.src = loadedImgUrl
                        image.addEventListener('load', () => {
                          const { width, height } = image
                          if (width !== 1000 && height !== 1000) {
                            alert(
                              '이미지의 크기는 1000px x 1000px 이어야 합니다.',
                            )
                            return Upload.LIST_IGNORE
                          } else {
                            return resolve(false)
                          }
                        })
                      })
                    })
                  }}
                >
                  <div
                    className={`${styles['product-register-upload-img-icon-wrap']}`}
                  >
                    <img
                      className={`${styles['product-register-upload-img-icon']}`}
                      src={`${process.env.REACT_APP_HOST}/assets/icon/product/plus.png`}
                    />
                  </div>
                </Upload>
              )}
              <span
                className={`${styles['product-register-upload-img-help']}`}
                style={{ color: '#fe2b4b' }}
              >
                * 필수크기 : 1000 x 1000px{'\n'}
                {/* * 여백: 양쪽 각각 100px (총200px){'\n'} */}
                {/* <span style={{ marginLeft: '40px' }}>
                  제품 모양에 따라 상하/좌우 중 택1
                </span> */}
                {/* {'\n'}* 상하 여백 맞출 시, 좌우 가운데 정렬{'\n'}* 좌우 여백
                맞출 시, 상하 가운데 정렬 */}
              </span>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              className={`${styles['product-register-upload-img']}`}
              label="추가 이미지"
              labelAlign="left"
              multiple
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                  marginBottom: 4,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
            >
              {productId ? (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ position: 'relative', marginBottom: '110px' }}>
                    <Upload.Dragger
                      className={`${styles['product-register-upload-img-wrap']} ${styles['drag-area']}`}
                      listType="picture-card"
                      multiple
                      fileList={productImg.remainder}
                      onChange={({ file, fileList, event }) =>
                        handleImageChange(file, fileList, event, 'additional')
                      }
                      onPreview={handlePreview}
                      beforeUpload={() => false}
                      showUploadList={{ showRemoveIcon: false }}
                      disabled={productImg.remainder?.length !== 0}
                      style={{
                        marginBottom: 4,
                        display: 'flex',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div
                        className={`${styles['product-register-upload-img-icon-wrap']}`}
                      >
                        {productImg.remainder?.length !== 0 ? (
                          <Button
                            type="primary"
                            danger
                            onClick={() => {
                              if (
                                !Object.prototype.hasOwnProperty.call(
                                  productImg.remainder[0],
                                  'originFileObj',
                                )
                              ) {
                                setDeletedImgCount({
                                  ...deletedImgCount,
                                  remainder: productImg.remainder?.length,
                                })
                              }
                              setProductImg({ ...productImg, remainder: [] })
                            }}
                          >
                            전체 삭제
                          </Button>
                        ) : (
                          <img
                            className={`${styles['product-register-upload-img-icon']}`}
                            src={`${process.env.REACT_APP_HOST}/assets/icon/product/plus.png`}
                          />
                        )}
                        <div>
                          {productImg.remainder?.length !== 0
                            ? '이미지 전체 삭제 후, 다시 재등록해주시길 바랍니다.'
                            : '업로드할 이미지를 한번에 드래그하여 끌어다 놓으세요'}
                        </div>
                      </div>
                    </Upload.Dragger>
                  </div>
                  <span
                    className={`${styles['product-register-upload-img-help']}`}
                  >
                    * 권장크기 : 1000 x 1000px{`\n`}* 추가이미지는 최대 9장
                  </span>
                </div>
              ) : (
                <>
                  <Upload
                    className={`${styles['product-register-upload-img-wrap']}`}
                    listType="picture-card"
                    maxCount={9}
                    onChange={({ file, fileList, event }) =>
                      handleImageChange(file, fileList, event, 'additional')
                    }
                    onPreview={handlePreview}
                    beforeUpload={() => false}
                  >
                    <div
                      className={`${styles['product-register-upload-img-icon-wrap']}`}
                    >
                      <img
                        className={`${styles['product-register-upload-img-icon']}`}
                        src={`${process.env.REACT_APP_HOST}/assets/icon/product/plus.png`}
                      />
                    </div>
                  </Upload>
                  <span
                    className={`${styles['product-register-upload-img-help']}`}
                  >
                    * 권장크기 : 1000 x 1000px{`\n`}* 추가이미지는 최대 9장
                  </span>
                </>
              )}
              {/* <span className={`${styles['product-register-upload-img-help']}`}>
                * 권장크기 : 1000 x 1000px{`\n`}* 추가이미지는 최대 9장
              </span> */}
            </Form.Item>
          </div>
        </>

        {/*상품 상세 이미지*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              상품 상세 이미지
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '25px 25px 10px',
              height: 'fit-content',
            }}
          >
            <Form.Item>
              {productId ? (
                <Upload.Dragger
                  className={`${styles['product-register-upload-img-wrap']} ${styles['drag-area']}`}
                  multiple
                  fileList={productDescriptionImg}
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, 'description')
                  }
                  onPreview={handlePreview}
                  beforeUpload={() => false}
                  showUploadList={false}
                  disabled={productDescriptionImg?.length !== 0}
                >
                  <div
                    className={`${styles['product-register-upload-img-icon-wrap']}`}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      {productDescriptionImg?.length !== 0 ? (
                        <>
                          <img
                            className={`${styles['product-register-upload-detail-img-icon']}`}
                            src={`${process.env.REACT_APP_HOST}/assets/answer_active.png`}
                          />
                          <div
                            className={`${styles['product-register-upload-detail-done']}`}
                          >
                            작성된 내용이 있습니다.
                          </div>
                          <Button
                            className={`${styles['product-register-upload-detail-modal-open']}`}
                            style={{
                              cursor: 'pointer',
                              padding: 'auto 2rem',
                            }}
                            onClick={handleExplainProductModalOpen}
                          >
                            수정 {'>'}
                          </Button>
                        </>
                      ) : (
                        <img
                          className={`${styles['product-register-upload-img-icon']}`}
                          src={`${process.env.REACT_APP_HOST}/assets/icon/product/plus.png`}
                        />
                      )}
                      <div>
                        {productDescriptionImg?.length !== 0
                          ? ''
                          : '이미지를 드래그하여 끌어다 놓으세요'}
                      </div>
                    </div>
                  </div>
                </Upload.Dragger>
              ) : (
                <Upload.Dragger
                  className={`${styles['product-register-upload-img-wrap']} ${styles['drag-area']}`}
                  multiple
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, 'description')
                  }
                  onPreview={handlePreview}
                  showUploadList={false}
                  disabled={productDescriptionImg?.length !== 0}
                  beforeUpload={() => false}
                >
                  <div
                    className={`${styles['product-register-upload-img-icon-wrap']}`}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      {productDescriptionImg?.length !== 0 ? (
                        <>
                          <img
                            className={`${styles['product-register-upload-detail-img-icon']}`}
                            src={`${process.env.REACT_APP_HOST}/assets/answer_active.png`}
                          />
                          <div
                            className={`${styles['product-register-upload-detail-done']}`}
                          >
                            작성된 내용이 있습니다.
                          </div>
                          <Button
                            className={`${styles['product-register-upload-detail-modal-open']}`}
                            style={{
                              cursor: 'pointer',
                              padding: 'auto 2rem',
                            }}
                            onClick={handleExplainProductModalOpen}
                          >
                            수정 {'>'}
                          </Button>
                        </>
                      ) : (
                        <img
                          className={`${styles['product-register-upload-img-icon']}`}
                          src={`${process.env.REACT_APP_HOST}/assets/icon/product/plus.png`}
                        />
                      )}
                      <div>
                        {productDescriptionImg?.length !== 0
                          ? ''
                          : '이미지를 드래그하여 끌어다 놓으세요'}
                      </div>
                    </div>
                  </div>
                </Upload.Dragger>
              )}
            </Form.Item>

            <span className={`${styles['product-register-upload-img-help']}`}>
              * 상품 설명의 파일명은 '1'부터 저장하여 업로드해주세요.
            </span>
          </div>
        </>

        {/*상품 속성*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              상품 속성
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '20px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['center-label']}`}
              label="상품군"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 160px',
                style: {
                  minWidth: 160,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 500px' }}
              required
            >
              <Row align="middle" wrap={false}>
                <Col span={8}>
                  <Select
                    placeholder="선택"
                    value={product.productType}
                    onChange={handleSelectChange}
                  >
                    {productTypeItems.map((item, idx) => (
                      <Select.Option
                        key={`${item.id}_${idx}`}
                        id="productType"
                        value={item.value}
                      >
                        {item.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
                <Checkbox
                  name="refProductDetail"
                  value="상품 상세 참조"
                  checked={options.refProductDetail}
                  onChange={handleChange}
                  disabled={
                    product.productType === '' || product.productType === 'ETC'
                  }
                  style={{ marginLeft: 15 }}
                >
                  상품 상세 참조
                </Checkbox>
              </Row>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />

            {/*의료기기*/}
            {product.productType === 'MEDICAL_DEVICE' && (
              <>
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="품명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productDetailName"
                    value={productDetail.productDetailName}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="모델명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productModelName"
                    value={productDetail.productModelName}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  label="의료기기법상 허가 신고번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className={`${styles['product-register-radio-group-wrap']}`}
                    name="approvalNumber"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.approvalNumber}
                  />
                  <Input
                    name="approvalNumber"
                    value={productDetail.approvalNumber}
                    onChange={handleProductDetailChange}
                    disabled={!options.approvalNumber}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="광고사전심의필 유무"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="adPreDeliberation"
                    value={productDetail.adPreDeliberation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  label="정격전압"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className={`${styles['product-register-radio-group-wrap']}`}
                    name="medicalRatedVoltage"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.medicalRatedVoltage}
                  />
                  <Input
                    name="medicalRatedVoltage"
                    value={productDetail.medicalRatedVoltage}
                    onChange={handleProductDetailChange}
                    disabled={!options.medicalRatedVoltage}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  label="소비전력"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className={`${styles['product-register-radio-group-wrap']}`}
                    name="medicalPowerConsumption"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.medicalPowerConsumption}
                  />
                  <Input
                    name="medicalPowerConsumption"
                    value={productDetail.medicalPowerConsumption}
                    onChange={handleProductDetailChange}
                    disabled={!options.medicalPowerConsumption}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="동일 모델의 출시연월"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="releaseDateSameModel"
                    value={productDetail.releaseDateSameModel}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조자(사)"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="productDetailMaker"
                    value={productDetail.productDetailMaker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="사용목적"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="purpose"
                    value={productDetail.purpose}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="사용방법"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="instruction"
                    value={productDetail.instruction}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="취급시 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="품질보증기준"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="qualityAssuranceStandards"
                    value={productDetail.qualityAssuranceStandards}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
              </>
            )}

            {/*화장품*/}
            {product.productType === 'COSMETICS' && (
              <>
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="용량 및 중량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacity"
                    value={productDetail.capacity}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="제품 주요사양"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="productSpecification"
                    value={productDetail.productSpecification}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="사용기한 또는 개봉 후 사용기간"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="validationDate"
                    value={productDetail.validationDate}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="사용방법"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="instruction"
                    value={productDetail.instruction}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="화장품제조업자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="productDetailMaker"
                    value={productDetail.productDetailMaker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조국"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="makerCountry"
                    value={productDetail.makerCountry}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="화장품책임판매업자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="importer"
                    value={productDetail.importer}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="화장품법에 따라 기재 표시하여야 하는 모든성분"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="productSubstanceInformation"
                    value={productDetail.productSubstanceInformation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="기능성 화장품의 경우 화장품법에 따른 식품의약품안전처 심사필 유무"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="foodDragMinistry"
                    value={productDetail.foodDragMinistry}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="사용할 때 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="품질보증기준"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="qualityAssuranceStandards"
                    value={productDetail.qualityAssuranceStandards}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
              </>
            )}

            {/*가공식품*/}
            {product.productType === 'PROCESSED_FOOD' && (
              <>
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제품명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productDetailName"
                    value={productDetail.productDetailName}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="식품의 유형"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="foodType"
                    value={productDetail.foodType}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="생산자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="importer"
                    value={productDetail.importer}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="소재지"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="location"
                    value={productDetail.location}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조연월일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="makeDate"
                    value={productDetail.makeDate}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="유통기한 또는 품질유지기한"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="validationDate"
                    value={productDetail.validationDate}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="포장단위별 내용물의 용량(중량), 수량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacityPackaging"
                    value={productDetail.capacityPackaging}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="포장단위별 수량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="quantityPackaging"
                    value={productDetail.quantityPackaging}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="원재료명 및 함량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="productSubstanceInformation"
                    value={productDetail.productSubstanceInformation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  label="영양성분"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className={`${styles['product-register-radio-group-wrap']}`}
                    name="productNutrient"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.productNutrient}
                  />
                  <Input
                    name="productNutrient"
                    value={productDetail.productNutrient}
                    onChange={handleProductDetailChange}
                    disabled={!options.productNutrient}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
                  label="유전자변형식품에 해당하는 경우의 표시"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Checkbox
                    name="isGeneticModification"
                    checked={productDetail.isGeneticModification}
                    value={true}
                    onChange={handleChange}
                  >
                    유전자변형식품
                  </Checkbox>
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="소비자안전을 위한 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
                  label="수입식품에 해당하는 경우"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Checkbox
                    name="isImported"
                    checked={productDetail.isImported}
                    value={true}
                    onChange={handleChange}
                  >
                    수입식품안전관리특별법에 따른 수입신고를 필함
                  </Checkbox>
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
              </>
            )}

            {/*건강기능식품*/}
            {product.productType === 'HEALTH_FUNCTIONAL_FOOD' && (
              <>
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제품명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productDetailName"
                    value={productDetail.productDetailName}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="식품의 유형"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="foodType"
                    value={productDetail.foodType}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조업소"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productDetailMaker"
                    value={productDetail.productDetailMaker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="소재지"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="location"
                    value={productDetail.location}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조연월일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="makeDate"
                    value={productDetail.makeDate}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="유통기한"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="validationDate"
                    value={productDetail.validationDate}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="포장단위별 내용물의 용량(중량), 수량"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacityPackaging"
                    value={productDetail.capacityPackaging}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="포장단위별 수량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="quantityPackaging"
                    value={productDetail.quantityPackaging}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="원재료명 및 함량"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="productSubstanceInformation"
                    value={productDetail.productSubstanceInformation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="영양정보"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="productNutrient"
                    value={productDetail.productNutrient}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="기능정보"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="productSpecification"
                    value={productDetail.productSpecification}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="섭취량, 섭취방법 및 섭취 시 주의사항"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="cautionIntake"
                    value={productDetail.cautionIntake}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="질병의 예방 및 치료를 위한 의약품이 아니라는 내용의 문구"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="notDrugInformation"
                    value={productDetail.notDrugInformation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
                  label="유전자변형식품에 해당되는 경우의 표시"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Checkbox
                    name="isGeneticModification"
                    checked={productDetail.isGeneticModification}
                    value={true}
                    onChange={handleChange}
                  >
                    유전자변형식품
                  </Checkbox>
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
                  label="수입식품에 해당되는 경우"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Checkbox
                    name="isImported"
                    checked={productDetail.isImported}
                    value={true}
                    onChange={handleChange}
                  >
                    수입식품안전관리특별법에 따른 수입신고를 필함
                  </Checkbox>
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="소비자안전을 위한 주의사항"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
              </>
            )}

            {/*생활화학제품*/}
            {product.productType === 'LIVING_CHEMICAL_PRODUCT' && (
              <>
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="품목 및 제품명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productDetailName"
                    value={productDetail.productDetailName}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="용도 및 제형"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="usageFormulation"
                    value={productDetail.usageFormulation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조연월"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="makeDate"
                    value={productDetail.makeDate}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="유통기한"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="validationDate"
                    value={productDetail.validationDate}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="중량•용량•매수"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacity"
                    value={productDetail.capacity}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="효과•효능"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="effectiveness"
                    value={productDetail.effectiveness}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  label="수입자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className={`${styles['product-register-radio-group-wrap']}`}
                    name="importer"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.importer}
                  />
                  <Input
                    name="importer"
                    value={productDetail.importer}
                    onChange={handleProductDetailChange}
                    disabled={!options.importer}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조국"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="makerCountry"
                    value={productDetail.makerCountry}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조자(사)"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="productDetailMaker"
                    value={productDetail.productDetailMaker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="어린이 보호포장 대상 제품유무"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="childProtectivePackagingProduct"
                    value={productDetail.childProtectivePackagingProduct}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제품에 사용된 화학 물질 명칭"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productSubstanceInformation"
                    value={productDetail.productSubstanceInformation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="사용상 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="안전기준 적합확인 신고번호(자가검사번호) 또는 안전확인대상 생활화학제품 승인번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="approvalNumber"
                    value={productDetail.approvalNumber}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
              </>
            )}

            {/*살생물제품*/}
            {product.productType === 'BIOCIDAL_PRODUCT' && (
              <>
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제품명 및 제품유형"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productDetailName"
                    value={productDetail.productDetailName}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="중량 또는 용량 및 표준사용량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacity"
                    value={productDetail.capacity}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="효과•효능"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="effectiveness"
                    value={productDetail.effectiveness}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="사용대상자 및 사용범위"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="usageInformation"
                    value={productDetail.usageInformation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  label="수입자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className={`${styles['product-register-radio-group-wrap']}`}
                    name="importer"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.importer}
                  />
                  <Input
                    name="importer"
                    value={productDetail.importer}
                    onChange={handleProductDetailChange}
                    disabled={!options.importer}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조국"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="makerCountry"
                    value={productDetail.makerCountry}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제조자(사)"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="productDetailMaker"
                    value={productDetail.productDetailMaker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="어린이 보호포장 대상 제품유무"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="childProtectivePackagingProduct"
                    value={productDetail.childProtectivePackagingProduct}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="살생물물질, 나노물질, 유해화학물질(또는 중점관리물질)의 명칭"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productSubstanceInformation"
                    value={productDetail.productSubstanceInformation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="제품 유해성•위해성 표시"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="productHazardInformation"
                    value={productDetail.productHazardInformation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['product-register-form-input-wrap']}`}
                  label="사용방법 및 사용상 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
                <Form.Item
                  className={`${styles['center-label']}`}
                  label="승인번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="approvalNumber"
                    value={productDetail.approvalNumber}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider
                  className={`${styles['product-register-form-input-divider']}`}
                />
              </>
            )}

            <Form.Item
              className={`${styles['center-label']}`}
              label="소비자 상담 관련 전화번호"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 160px',
                style: {
                  minWidth: 160,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
            >
              <Input
                name="csNumber"
                value={product.csNumber}
                onChange={handleChange}
              />
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              label="제품하자·오배송 등에 따른 청약철회 등의 경우 청약철회 등을 할 수 있는 기간 및 통신판매업자가 부담하는 반품비용 등에 관한 정보"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="cancellationInformation"
                value={options.cancellationInformation}
                onChange={handleChange}
              >
                <Space
                  className={`${styles['product-register-select-group-wrap']}`}
                  direction="vertical"
                >
                  <Radio value={1}>
                    전자상거래등에서의소비자보호에관한법률 등에 의한 제품의 하자
                    또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후
                    3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일
                    이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가
                    부담합니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.cancellationInformation === 3 ? (
                    <Input
                      name="cancellationInformation"
                      value={product.cancellationInformation}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              label="제품하자가 아닌 소비자의 단순변심, 착오구매에 따른 청약철회등이 불가능한 경우 그 구체적 사유와 근거"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="cancellationImpossibleInformation"
                value={options.cancellationImpossibleInformation}
                onChange={handleChange}
              >
                <Space
                  className={`${styles['product-register-select-group-wrap']}`}
                  direction="vertical"
                >
                  <Radio value={1}>
                    전자상거래 등에서의 소비자보호에 관한 법률 등에 의한
                    청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에
                    준하는 것으로 인정되는 경우 청약철회가 제한될 수 있습니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.cancellationImpossibleInformation === 3 ? (
                    <Input
                      name="cancellationImpossibleInformation"
                      value={product.cancellationImpossibleInformation}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              label="재화등의 교환·반품·보증 조건 및 품질보증기준"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="qualityAssuranceStandardsInformation"
                value={options.qualityAssuranceStandardsInformation}
                onChange={handleChange}
              >
                <Space
                  className={`${styles['product-register-select-group-wrap']}`}
                  direction="vertical"
                >
                  <Radio value={1}>
                    소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에
                    따릅니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.qualityAssuranceStandardsInformation === 3 ? (
                    <Input
                      name="qualityAssuranceStandardsInformation"
                      value={product.qualityAssuranceStandardsInformation}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              label="대금을 환불받기 위한 방법과 환불이 지연될 경우 지연에 따른 배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적 조건 및 절차"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="refundIndemnityInformation"
                value={options.refundIndemnityInformation}
                onChange={handleChange}
              >
                <Space
                  className={`${styles['product-register-select-group-wrap']}`}
                  direction="vertical"
                >
                  <Radio value={1}>
                    주문취소 및 대금의 환불은 당신의 영양제 마이페이지에서
                    신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한
                    법률에 따라 소비자의 청약철회 후 판매자가 재화 등을 반환
                    받은 날로부터 3영업일 이내에 지급받은 대금의 환급을 정당한
                    사유 없이 지연하는 때에는 소비자는 지연기간에 대해서 연
                    15%의 지연배상금을 판매자에게 청구할 수 있습니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.refundIndemnityInformation === 3 ? (
                    <Input
                      name="refundIndemnityInformation"
                      value={product.refundIndemnityInformation}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              label="소비자피해보상의 처리, 재화등에 대한 불만 처리 및 소비자와 사업자 사이의 분쟁처리에 관한 사항"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="disputeInformation"
                value={options.disputeInformation}
                onChange={handleChange}
              >
                <Space
                  className={`${styles['product-register-select-group-wrap']}`}
                  direction="vertical"
                >
                  <Radio value={1}>
                    소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에
                    따릅니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.disputeInformation === 3 ? (
                    <Input
                      name="disputeInformation"
                      value={product.disputeInformation}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
          </div>
        </>

        {/*상품 속성-영양제*/}
        {Object.keys(categoryOption.category3)?.length !== 0 &&
        isNutritionalPro() &&
        product.categoryId ? (
          <>
            <Row
              className={`${styles['product-register-border-box']}`}
              wrap={false}
              style={{ marginTop: 20 }}
            >
              <span className={`${styles['product-register-box-title']}`}>
                상품 속성
              </span>
              <span className={`${styles['product-register-box-subtitle']}`}>
                {getCategoryName()}
              </span>
            </Row>
            <div
              className={`${styles['product-register-border-box']}`}
              style={{
                borderTop: 0,
                padding: '15px 20px 45px',
                height: 'fit-content',
              }}
            >
              <Form.Item
                className={`${styles['product-register-nutrients-header-wrap']}`}
                label="건강식품 인증 필수"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 22 }}
              ></Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['add-padding']}`}
                label="영양소 원료명 (식약처고시)"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <p
                  className={`${styles['product-register-nutrients-subtitle']}`}
                >
                  비타민
                </p>
                <Row style={{ rowGap: 8, marginBottom: 20 }}>
                  {nutrientCategoryList.vitamin?.length !== 0 &&
                    nutrientCategoryList.vitamin.map((vitamin, idx) => (
                      <Col span={4} key={`${vitamin.id}-${idx}`}>
                        <Checkbox
                          key={vitamin.id}
                          id={vitamin.nutrientId}
                          name="vitamin"
                          value={0}
                          onChange={handleChange}
                          checked={selectNutrients.some(
                            (selectNutrient) =>
                              JSON.stringify(selectNutrient) ===
                              JSON.stringify(vitamin),
                          )}
                        >
                          {vitamin.nutrientName}
                        </Checkbox>
                      </Col>
                    ))}
                </Row>
                <p
                  className={`${styles['product-register-nutrients-subtitle']}`}
                >
                  미네랄
                </p>
                <Row style={{ rowGap: 8, marginBottom: 20 }}>
                  {nutrientCategoryList.mineral?.length !== 0 &&
                    nutrientCategoryList.mineral.map((mineral, indx) => (
                      <Col span={4} key={`${mineral.id}-${indx}`}>
                        <Checkbox
                          key={mineral.id}
                          id={mineral.nutrientId}
                          name="mineral"
                          value={0}
                          onChange={handleChange}
                          checked={selectNutrients.some(
                            (selectNutrient) =>
                              JSON.stringify(selectNutrient) ===
                              JSON.stringify(mineral),
                          )}
                        >
                          {mineral.nutrientName}
                        </Checkbox>
                      </Col>
                    ))}
                </Row>
                <p
                  className={`${styles['product-register-nutrients-subtitle']}`}
                >
                  뉴트리션
                </p>
                <Row style={{ rowGap: 8, marginBottom: 20 }}>
                  {nutrientCategoryList.nutrition?.length !== 0 &&
                    nutrientCategoryList.nutrition.map((nutrition, indx) => (
                      <Col span={4} key={`${nutrition.id}-${indx}`}>
                        <Checkbox
                          key={nutrition.id}
                          id={nutrition.nutrientId}
                          name="nutrition"
                          value={0}
                          onChange={handleChange}
                          checked={selectNutrients.some(
                            (selectNutrient) =>
                              JSON.stringify(selectNutrient) ===
                              JSON.stringify(nutrition),
                          )}
                        >
                          {nutrition.nutrientName === '플라보놀배당체' ||
                          nutrition.nutrientName === '로르산'
                            ? nutrition.mainNutrientCategoryName
                            : nutrition.nutrientName}
                        </Checkbox>
                      </Col>
                    ))}
                </Row>
                {selectNutrients?.length !== 0 &&
                  selectNutrients.map((nutrient) => (
                    <>
                      <Divider
                        className={`${styles['product-register-form-input-divider']}`}
                      />
                      <Row
                        key={`nutrient_content_${nutrient.nutrientId}`}
                        className={`${styles['add-nutrients-wrap']}`}
                      >
                        <img
                          className={`${styles['delete-nutrients-icon-wrap']}`}
                          src={`${process.env.REACT_APP_HOST}/assets/icon/product/delete-circle.png`}
                          onClick={() => deleteNutritionInfo(nutrient)}
                        />
                        <Col span={5}>
                          <span
                            className={`${styles['product-register-nutrients-subtitle']}`}
                          >
                            {nutrient.nutrientName}
                          </span>
                        </Col>
                        <Input
                          type="number"
                          className={`${styles['add-nutrients-input-wrap']}`}
                          name={nutrient.nutrientId}
                          value={nutrientInfo[nutrient.nutrientId]}
                          min={0}
                          onChange={handleNutrientInfoChange}
                          addonAfter={<span>{nutrient.nutrientUnit}</span>}
                        />
                      </Row>
                    </>
                  ))}
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['add-padding']}`}
                label="알레르기 영양정보"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Row style={{ rowGap: 8 }}>
                  {allergyItems.map((allergy, idx) => (
                    <Col span={4} key={`allergy_${idx}`}>
                      <Checkbox
                        key={`allergy_${idx}`}
                        id={allergy.value}
                        name="nutrientAllergy"
                        value={true}
                        onChange={handleChange}
                        checked={nutrientsAllergy[allergy.value]}
                      >
                        {allergy.label}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['add-padding']}`}
                label="효능"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Row style={{ rowGap: 8 }}>
                  {nutrientSearchOption.effect.map((effect, idx) => (
                    <Col span={4} key={`effect_${idx}`}>
                      <Checkbox
                        key={`effect_${idx}`}
                        id={effect.effectId}
                        name="nutrientEffect"
                        value={effect.effectId}
                        onChange={handleChange}
                        checked={product.nutrientEffect.includes(
                          effect.effectId,
                        )}
                      >
                        {effect.effectName}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-header-wrap']}`}
                label="기타속성"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 22 }}
                style={{ borderTop: 0 }}
              ></Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['add-padding']}`}
                label="제품타입"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Radio.Group
                  name="formulation"
                  onChange={handleChange}
                  value={product.formulation}
                  style={{ width: '100%' }}
                >
                  <Row style={{ rowGap: 8 }}>
                    {formulationItems.map((formulationItem, idx) => (
                      <Col span={4} key={`formulation_${idx}`}>
                        <Radio
                          key={`formulation_${idx}`}
                          value={formulationItem.value}
                        >
                          {formulationItem.label}
                        </Radio>
                      </Col>
                    ))}
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                label="성별"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Radio.Group
                  name="targetGender"
                  onChange={handleChange}
                  value={product.targetGender}
                  style={{ width: '100%' }}
                >
                  <Row style={{ rowGap: 8 }}>
                    {genderItems.map((gender, idx) => (
                      <Col span={4} key={`gender_${idx}`}>
                        <Radio key={`gender_${idx}`} value={gender.value}>
                          {gender.label}
                        </Radio>
                      </Col>
                    ))}
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['add-padding']}`}
                label="섭취대상"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Radio.Group
                  name="productTarget"
                  onChange={handleChange}
                  value={product.productTarget}
                  style={{ width: '100%' }}
                >
                  <Row style={{ rowGap: 8 }}>
                    {targetAgeItems.map((age, idx) => (
                      <Col span={4} key={`age_${idx}`}>
                        <Radio key={`age_${idx}`} value={age.value}>
                          {age.label}
                        </Radio>
                      </Col>
                    ))}
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                label="특징"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Row>
                  <Col span={4}>
                    <Checkbox
                      name="pregnant"
                      value={true}
                      onChange={handleChange}
                      checked={product.pregnant}
                    >
                      임산부
                    </Checkbox>
                  </Col>
                  <Col span={4}>
                    <Checkbox
                      name="began"
                      value={true}
                      onChange={handleChange}
                      checked={product.began}
                    >
                      비건
                    </Checkbox>
                  </Col>
                </Row>
              </Form.Item>
              {nutrientSearchOption.standardContent?.length > 0 ? (
                <Form.Item
                  className={`${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                  label="함량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 2 }}
                  wrapperCol={{ span: 22 }}
                >
                  <Radio.Group
                    name="nutrientStandard"
                    onChange={handleChange}
                    value={product.nutrientStandard}
                    style={{ width: '100%' }}
                  >
                    <Row style={{ rowGap: 8 }}>
                      {nutrientSearchOption.standardContent.map(
                        (nutrient_standard, idx) => {
                          let standardContentUnit = ''
                          if (nutrient_standard.underYn) {
                            standardContentUnit = '미만'
                          } else if (nutrient_standard.overYn) {
                            standardContentUnit = '미만'
                          } else if (nutrient_standard.lessYn) {
                            standardContentUnit = '이하'
                          } else if (nutrient_standard.moreThanYn) {
                            standardContentUnit = '이상'
                          }
                          return (
                            <Col span={4} key={`nutrient_standard_${idx}`}>
                              <Radio
                                key={`nutrient_standard_${idx}`}
                                value={nutrient_standard.id}
                              >{`${nutrient_standard.content}${nutrient_standard.nutrientUnit} ${standardContentUnit}`}</Radio>
                            </Col>
                          )
                        },
                      )}
                    </Row>
                  </Radio.Group>
                </Form.Item>
              ) : null}
              {nutrientSearchOption.additionalIngredient?.length > 0 ? (
                <Form.Item
                  className={`${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                  label="추가성분"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 2 }}
                  wrapperCol={{ span: 22 }}
                >
                  <Row style={{ rowGap: 8 }}>
                    {nutrientSearchOption.additionalIngredient.map(
                      (ingredient, idx) => (
                        <Col span={4} key={`ingredient_${idx}`}>
                          <Checkbox
                            key={`ingredient_${idx}`}
                            id={ingredient.ingredientId}
                            name="nutrientAdditionalIngredient"
                            value={ingredient.ingredientId}
                            onChange={handleChange}
                            checked={product.nutrientAdditionalIngredient.includes(
                              ingredient.ingredientId,
                            )}
                          >
                            {ingredient.ingredientName}
                          </Checkbox>
                        </Col>
                      ),
                    )}
                  </Row>
                </Form.Item>
              ) : null}
              <Form.Item
                className={`${styles['product-register-form-input-wrap']} ${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                label="섭취횟수"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Col span={4} style={{ marginRight: 20 }}>
                  <Input
                    type="number"
                    name="intakesPerDay"
                    value={product.intakesPerDay}
                    min={0}
                    onChange={handleNutrientsChange}
                    addonAfter={
                      <span className={`${styles['product-price-label']}`}>
                        회
                      </span>
                    }
                  />
                </Col>
                <Col span={6}>
                  <Input
                    type="number"
                    name="numPerOne"
                    value={product.numPerOne}
                    min={0}
                    onChange={handleNutrientsChange}
                    addonAfter={
                      <Select
                        className={`${styles['product-price-label']}`}
                        placeholder="선택"
                        value={product.forPersonUnit}
                        onChange={handleSelectChange}
                        style={{ width: 90 }}
                      >
                        {forPersonUnitItems.map((unit, idx) => (
                          <Select.Option
                            key={`unit_${idx}`}
                            id="forPersonUnit"
                            value={unit.value}
                          >
                            {unit.label}
                          </Select.Option>
                        ))}
                      </Select>
                    }
                  />
                </Col>
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                label="1일 총 섭취량"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 6 }}
              >
                <Input
                  type="number"
                  name="forPerson"
                  value={product.forPerson}
                  min={0}
                  onChange={handleNutrientsChange}
                />
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                label="복용시간대"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Input
                  name="takeMedicineTime"
                  value={product.takeMedicineTime}
                  onChange={handleNutrientsChange}
                />
              </Form.Item>
              <Form.Item
                className={`${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                label="판매단위"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 6 }}
              >
                <Input
                  type="number"
                  name="unit"
                  value={product.unit}
                  min={0}
                  onChange={handleProductKpiChange}
                />
              </Form.Item>
              {Object.prototype.hasOwnProperty.call(product, 'categoryId') &&
                product.categoryId !== 'vitamin_multi' &&
                product.categoryId !== 'vitamin_b' && (
                  <Form.Item
                    className={`${styles['product-register-nutrients-item-wrap']} ${styles['center-label']}`}
                    label="대표영양소 함량"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 2 }}
                    wrapperCol={{ span: 6 }}
                  >
                    <Input
                      name="topNutrientContent"
                      value={product.topNutrientContent}
                      onChange={handleChange}
                      addonAfter={<span>{product.topNutrientUnit}</span>}
                    />
                  </Form.Item>
                )}
            </div>
          </>
        ) : null}

        {/*배송*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              배송
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '20px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['center-label']}`}
              label="택배사"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
            >
              <Select
                placeholder="선택"
                value={product.deliveryCompany}
                onChange={handleSelectChange}
              >
                {courierCompanyItems.map((courierCompany, idx) => (
                  <Select.Option
                    key={`courierCompany_${idx}`}
                    id="deliveryCompany"
                    value={courierCompany.value}
                  >
                    {courierCompany.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              className={`${styles['center-label']}`}
              label="출고지"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
            >
              <Input
                name="shipmentPlace"
                value={product.shipmentPlace}
                onChange={handleChange}
              />
            </Form.Item>
          </div>
        </>

        {/*반품배송*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              반품배송
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '20px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['center-label']}`}
              label="반품/교환 택배사"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
            >
              <Select
                placeholder="선택"
                value={product.deliveryCompanyReturnExchange}
                onChange={handleSelectChange}
              >
                {courierCompanyItems.map((courierCompany, idx) => (
                  <Select.Option
                    key={`courierCompany_${idx}`}
                    id="deliveryCompanyReturnExchange"
                    value={courierCompany.value}
                  >
                    {courierCompany.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
              label="반품 배송비(편도)"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
            >
              <Input
                type="number"
                name="deliveryPriceReturn"
                value={product.deliveryPriceReturn}
                min={0}
                onChange={handleChange}
                addonAfter={
                  <span className={`${styles['product-price-label']}`}>원</span>
                }
              />
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              className={`${styles['product-register-form-input-wrap']} ${styles['center-label']}`}
              label="교환 배송비(왕복)"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
            >
              <Input
                type="number"
                name="deliveryPriceExchange"
                value={product.deliveryPriceExchange}
                min={0}
                onChange={handleChange}
                addonAfter={
                  <span className={`${styles['product-price-label']}`}>원</span>
                }
              />
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              className={`${styles['center-label']}`}
              label="반품/교환지"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
            >
              <Input
                name="shipmentPlaceReturnExchange"
                value={product.shipmentPlaceReturnExchange}
                onChange={handleChange}
              />
            </Form.Item>
          </div>
        </>

        {/*A/S 특이사항*/}
        <>
          <Row
            className={`${styles['product-register-border-box']}`}
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className={`${styles['product-register-box-title']}`}>
              A/S 특이사항
            </span>
          </Row>
          <div
            className={`${styles['product-register-border-box']}`}
            style={{
              borderTop: 0,
              padding: '20px 25px 0',
              height: 'fit-content',
            }}
          >
            <Form.Item
              className={`${styles['center-label']}`}
              label="A/S 전화번호"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '0 0 240px' }}
            >
              <Input
                name="asPhone"
                value={product.asPhone}
                onChange={handleChange}
              />
            </Form.Item>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Form.Item
              className={`${styles['product-register-form-input-wrap']}`}
              label="A/S 안내"
              labelAlign="left"
              colon={false}
              labelCol={{
                flex: '0 0 120px',
                style: {
                  minWidth: 120,
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                },
              }}
              wrapperCol={{ flex: '1 1 auto' }}
            >
              <Input.TextArea
                name="asInformation"
                value={product.asInformation}
                onChange={handleChange}
              />
            </Form.Item>
          </div>
        </>

        {/*포인트 정책*/}
        {user.role === 'super_admin' && (
          <>
            <Row
              className={`${styles['product-register-border-box']}`}
              wrap={false}
              style={{ marginTop: 20 }}
            >
              <span className={`${styles['product-register-box-title']}`}>
                포인트 정책
              </span>
            </Row>
            <div
              className={`${styles['product-register-border-box']}`}
              style={{
                borderTop: 0,
                padding: '20px 25px 0',
                height: 'fit-content',
              }}
            >
              <Form.Item
                label="구매시 포인트 사용 허용 여부"
                labelAlign="left"
                colon={false}
                labelCol={{
                  flex: '0 0 140px',
                  style: {
                    minWidth: 200,
                    whiteSpace: 'nowrap',
                    fontWeight: 500,
                  },
                }}
              >
                <Radio.Group
                  name="pointUsable"
                  options={pointUseOptions}
                  onChange={handleChange}
                  value={product.pointUsable}
                  className={`${styles['product-register-delivery-status-wrap']}`}
                  optionType="button"
                  buttonStyle="solid"
                />
              </Form.Item>
            </div>
            <div
              className={`${styles['product-register-border-box']}`}
              style={{
                borderTop: 0,
                padding: '20px 25px 0',
                height: 'fit-content',
              }}
            >
              <Form.Item
                label="구매 포인트 지급"
                labelAlign="left"
                colon={false}
                labelCol={{
                  flex: '0 0 140px',
                  style: {
                    minWidth: 140,
                    whiteSpace: 'nowrap',
                    fontWeight: 500,
                  },
                }}
                wrapperCol={{ flex: '0 0 240px' }}
              >
                <Radio.Group
                  name="savingPoint"
                  options={paymentsOptions}
                  onChange={handleChange}
                  value={options.savingPoint}
                  className={`${styles['product-register-delivery-status-wrap']}`}
                  optionType="button"
                  buttonStyle="solid"
                />
                <Input
                  type="number"
                  className={`${styles['product-register-point-input-wrap']}`}
                  name="savingPoint"
                  value={product.savingPoint}
                  min={0}
                  onChange={handleChange}
                  disabled={!options.savingPoint}
                  addonAfter={
                    <Select
                      value={product.savingPointType}
                      onChange={handleSelectChange}
                    >
                      {pointBenefitUnits.map((item, idx) => (
                        <Select.Option
                          key={`point_benefit_type_${idx}`}
                          id="savingPointType"
                          value={item.value}
                        >
                          {item.label}
                        </Select.Option>
                      ))}
                    </Select>
                  }
                  style={{ width: 200 }}
                />
              </Form.Item>
              <Divider
                className={`${styles['product-register-form-input-divider']}`}
              />
              <Form.Item
                label="리뷰 작성 포인트 지급"
                labelAlign="left"
                colon={false}
                labelCol={{
                  flex: '0 0 140px',
                  style: {
                    minWidth: 140,
                    whiteSpace: 'nowrap',
                    fontWeight: 500,
                  },
                }}
                wrapperCol={{ flex: '1 1 auto' }}
              >
                <Radio.Group
                  name="reviewPoint"
                  options={paymentsOptions}
                  onChange={handleChange}
                  value={options.reviewPoint}
                  className={`${styles['product-register-delivery-status-wrap']}`}
                  optionType="button"
                  buttonStyle="solid"
                />
                <Row
                  className={`${styles['product-register-point-group-wrap']}`}
                >
                  <Form.Item
                    className={`${styles['center-label']}`}
                    label="텍스트 리뷰 작성"
                    labelAlign="left"
                    colon={false}
                    // labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 16 }}
                    style={{ marginBottom: 0 }}
                  >
                    <Input
                      type="number"
                      className={`${styles['product-register-point-input-wrap']}`}
                      name="reviewPoint"
                      value={product.reviewPoint}
                      min={0}
                      onChange={handleChange}
                      disabled={!options.reviewPoint}
                      addonAfter={
                        <Select
                          value={product.reviewPointType}
                          onChange={handleSelectChange}
                        >
                          {pointBenefitUnits.map((item, idx) => (
                            <Select.Option
                              key={`text_review_point_benefit_type_${idx}`}
                              id="reviewPointType"
                              value={item.value}
                            >
                              {item.label}
                            </Select.Option>
                          ))}
                        </Select>
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    className={`${styles['center-label']}`}
                    label="이미지 첨부"
                    labelAlign="left"
                    colon={false}
                    // labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 16 }}
                    style={{ marginBottom: 0 }}
                  >
                    <Input
                      type="number"
                      className={`${styles['product-register-point-input-wrap']}`}
                      name="reviewImagePoint"
                      value={product.reviewImagePoint}
                      min={0}
                      onChange={handleChange}
                      disabled={!options.reviewPoint}
                      addonAfter={
                        <Select
                          value={product.reviewImagePointType}
                          onChange={handleSelectChange}
                        >
                          {pointBenefitUnits.map((item, idx) => (
                            <Select.Option
                              key={`image_review_point_benefit_type_${idx}`}
                              id="reviewImagePointType"
                              value={item.value}
                            >
                              {item.label}
                            </Select.Option>
                          ))}
                        </Select>
                      }
                    />
                  </Form.Item>
                </Row>
              </Form.Item>
            </div>
          </>
        )}

        {/* 예시 모달 */}
        <Modal
          className="related-product-modal-wrap"
          width={exampleTitle.id === 'pick' ? '50%' : '40%'}
          title={exampleTitle.title}
          open={exampleShow}
          onCancel={() => setExampleShow(!exampleShow)}
          footer={null}
        >
          {exampleTitle.id === 'tag' && (
            <Menu className={`modal-tag-list`}>
              <MenuItem
                className={`${exampleTitle.id === 'tag' ? 'click' : ''}`}
                onClick={() =>
                  setExampleTitle({
                    ...exampleTitle,
                    id: 'tag',
                  })
                }
              >
                태그 예시
              </MenuItem>
            </Menu>
          )}

          {exampleTitle.id === 'main-image' ? (
            <div className={'example-modal-main-image-container'}>
              <div className={'main-image-div'}>
                <span>메인 이미지</span>
                <img
                  alt={`${exampleTitle.title}1`}
                  src={`${process.env.REACT_APP_HOST}/assets/images/example/${exampleTitle.id}1.png`}
                />
              </div>
              <div className={'main-image-div'}>
                <span>상세 이미지</span>
                <img
                  alt={`${exampleTitle.title}2`}
                  src={`${process.env.REACT_APP_HOST}/assets/images/example/${exampleTitle.id}2.png`}
                />
              </div>
            </div>
          ) : (
            <img
              alt={exampleTitle.title}
              src={`${process.env.REACT_APP_HOST}/assets/images/example/${exampleTitle.id}.png`}
              style={{
                width: '100%',
                height: '100%',
              }}
            />
          )}
        </Modal>
      </div>
      <div className={`${styles['product-register-fixed-footer']}`}>
        <Button
          className={`${styles['product-register-button']} ${styles.save}`}
          onClick={saveProduct}
          loading={isLoading}
        >
          {isLoading
            ? null
            : productId
              ? isReUse
                ? '저장하기'
                : '수정하기'
              : '저장하기'}
        </Button>
        <Button
          className={`${styles['product-register-button']} ${styles.cancel}`}
          onClick={cancelBtnClick}
        >
          취소
        </Button>
      </div>

      {/*상품설명 이미지 수정 Modal*/}
      {isExplainProductModalOpen && (
        <ProductDetailImageComponent
          isExplainProductModalOpen={isExplainProductModalOpen}
          handleExplainProductModalCancel={handleExplainProductModalCancel}
          handleExplainProductModalOk={handleExplainProductModalOk}
          handleExplainProductImageSave={handleExplainProductImageSave}
          productDescriptionImg={productDescriptionImg}
          handleDeletedImageUid={handleDeletedImageUid}
          refProductDescriptionImg={refProductDescriptionImg}
          clickImageUid={clickImageUid}
        />
      )}

      {isProgramModalVisible && (
        <Modal
          title="프로그램 선택"
          open={isProgramModalVisible}
          onCancel={closeModalAndReset}
          footer={null}
          width={500}
          height={500}
        >
          <div
            style={{
              maxHeight: '400px',
              overflowY: 'auto',
              paddingRight: '10px',
            }}
          >
            <span style={{ fontSize: '14px', color: 'red' }}>
              모달을 열었을 경우 반드시 저장을 눌러주세요!
            </span>
            <List
              dataSource={_programs}
              renderItem={(item) => {
                const currentMapping = modalMappingData?.find(
                  (m) =>
                    m.programId === item.programId &&
                    m.programOptionId === item.programOptionId,
                )
                const isChecked = !!currentMapping
                const quantity = currentMapping
                  ? currentMapping.programTicketsToIssue
                  : 0

                return (
                  <List.Item key={item.programOptionId}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        gap: '10px',
                      }}
                    >
                      <Checkbox
                        checked={isChecked}
                        onChange={(e) => handleModalCheckboxChange(e, item)}
                      />
                      <span style={{ flexGrow: 1 }}>
                        <span style={{ flexGrow: 1 }}>
                          {item.programOptionName
                            ? `[${item.programName}] - ${item.programOptionName} (${item.activeDays}일)`
                            : `[${item.programName}] (${item.activeDays}일)`}
                        </span>
                      </span>
                      <InputNumber
                        min={0}
                        value={quantity}
                        onChange={(value) =>
                          handleModalQuantityChange(value, item)
                        }
                        disabled={!isChecked}
                        style={{ width: '80px' }}
                        placeholder="수량"
                      />
                      <span>개</span>
                    </div>
                  </List.Item>
                )
              }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            {/* 저장할 시 한 개 이상 선택 */}
            <Button
              className={`${styles['product-register-button']} ${styles.save}`}
              style={{ color: 'white', backgroundColor: '#117ffa' }}
              onClick={handleSaveModalSelection}
            >
              저장하기
            </Button>
            <Button onClick={closeModalAndReset}>닫기</Button>
          </div>
        </Modal>
      )}

      {/* 세트 상품 모달 */}
      {isSetProductSelectModalVisible && (
        <ProductSetOptionComponent
          value={isSetProduct}
          onChange={handleSetProductChange}
          currentOptionIndex={currentOptionIndex}
          currentProductId={productOptions[currentOptionIndex]?.productId} // ✅ 현재 편집 중인 상품의 ID 전달
          visible={isSetProductSelectModalVisible}
          onClose={() => setIsSetProductSelectModalVisible(false)}
          product={product}
        />
      )}
    </>
  )
}

export default ProductRegisterPage
